/*
@license
  Impulse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/impulse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/


window.theme = window.theme || {}; 
window.Shopify = window.Shopify || {}; 

theme.config = {
  bpSmall: false,
  hasSessionStorage: true,
  hasLocalStorage: true,
  mediaQuerySmall: 'screen and (max-width: '+ 769 +'px)',
  youTubeReady: false,
  vimeoReady: false,
  vimeoLoading: false,
  isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false,
  stickyHeader: false,
  rtl: document.documentElement.getAttribute('dir') == 'rtl' ? true : false
};

if (theme.config.isTouch) {
  document.documentElement.className += ' supports-touch';
}

if (console && console.log) {
  console.log('Impulse theme ('+theme.settings.themeVersion+') by ARCHΞTYPE | Learn more at https://archetypethemes.co');
}

theme.recentlyViewed = {
  recent: {}, // will store handle+url of recent products
  productInfo: {} // will store product data to reduce API calls
};

window.lazySizesConfig = window.lazySizesConfig || {};
lazySizesConfig.expFactor = 4;

(function(){
  'use strict';

  theme.delegate = {
    on: function(event, callback, options){
      if( !this.namespaces ) // save the namespaces on the DOM element itself
        this.namespaces = {};
  
      this.namespaces[event] = callback;
      options = options || false;
  
      this.addEventListener(event.split('.')[0], callback, options);
      return this;
    },
    off: function(event) {
      if (!this.namespaces) { return }
      this.removeEventListener(event.split('.')[0], this.namespaces[event]);
      delete this.namespaces[event];
      return this;
    }
  };
  
  // Extend the DOM with these above custom methods
  window.on = Element.prototype.on = theme.delegate.on;
  window.off = Element.prototype.off = theme.delegate.off;
  
  theme.utils = {
    defaultTo: function(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value
    },
  
    wrap: function(el, wrapper) {
      el.parentNode.insertBefore(wrapper, el);
      wrapper.appendChild(el);
    },
  
    debounce: function(wait, callback, immediate) {
      var timeout;
      return function() {
        var context = this, args = arguments;
        var later = function() {
          timeout = null;
          if (!immediate) callback.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) callback.apply(context, args);
      }
    },
  
    throttle: function(limit, callback) {
      var waiting = false;
      return function () {
        if (!waiting) {
          callback.apply(this, arguments);
          waiting = true;
          setTimeout(function () {
            waiting = false;
          }, limit);
        }
      }
    },
  
    prepareTransition: function(el, callback) {
      el.addEventListener('transitionend', removeClass);
  
      function removeClass(evt) {
        el.classList.remove('is-transitioning');
        el.removeEventListener('transitionend', removeClass);
      }
  
      el.classList.add('is-transitioning');
      el.offsetWidth; // check offsetWidth to force the style rendering
  
      if (typeof callback === 'function') {
        callback();
      }
    },
  
    // _.compact from lodash
    // Creates an array with all falsey values removed. The values `false`, `null`,
    // `0`, `""`, `undefined`, and `NaN` are falsey.
    // _.compact([0, 1, false, 2, '', 3]);
    // => [1, 2, 3]
    compact: function(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];
  
      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    },
  
    serialize: function(form) {
      var arr = [];
      Array.prototype.slice.call(form.elements).forEach(function(field) {
        if (
          !field.name ||
          field.disabled ||
          ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
        )
          return;
        if (field.type === 'select-multiple') {
          Array.prototype.slice.call(field.options).forEach(function(option) {
            if (!option.selected) return;
            arr.push(
              encodeURIComponent(field.name) +
                '=' +
                encodeURIComponent(option.value)
            );
          });
          return;
        }
        if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
          return;
        arr.push(
          encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
        );
      });
      return arr.join('&');
    }
  };
  
  theme.a11y = {
    trapFocus: function(options) {
      var eventsName = {
        focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
        focusout: options.namespace
          ? 'focusout.' + options.namespace
          : 'focusout',
        keydown: options.namespace
          ? 'keydown.' + options.namespace
          : 'keydown.handleFocus'
      };
  
      // Get every possible visible focusable element
      var focusableEls = options.container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])');
      var elArray = [].slice.call(focusableEls);
      var focusableElements = elArray.filter(el => el.offsetParent !== null);
  
      var firstFocusable = focusableElements[0];
      var lastFocusable = focusableElements[focusableElements.length - 1];
  
      if (!options.elementToFocus) {
        options.elementToFocus = options.container;
      }
  
      options.container.setAttribute('tabindex', '-1');
      options.elementToFocus.focus();
  
      document.documentElement.off('focusin');
      document.documentElement.on(eventsName.focusout, function() {
        document.documentElement.off(eventsName.keydown);
      });
  
      document.documentElement.on(eventsName.focusin, function(evt) {
        if (evt.target !== lastFocusable && evt.target !== firstFocusable) return;
  
        document.documentElement.on(eventsName.keydown, function(evt) {
          _manageFocus(evt);
        });
      });
  
      function _manageFocus(evt) {
        if (evt.keyCode !== 9) return;
        /**
         * On the first focusable element and tab backward,
         * focus the last element
         */
        if (evt.target === firstFocusable && evt.shiftKey) {
          evt.preventDefault();
          lastFocusable.focus();
        }
      }
    },
    removeTrapFocus: function(options) {
      var eventName = options.namespace
        ? 'focusin.' + options.namespace
        : 'focusin';
  
      if (options.container) {
        options.container.removeAttribute('tabindex');
      }
  
      document.documentElement.off(eventName);
    },
  
    lockMobileScrolling: function(namespace, element) {
      var el = element ? element : document.documentElement;
      document.documentElement.classList.add('lock-scroll');
      el.on('touchmove' + namespace, function() {
        return true;
      });
    },
  
    unlockMobileScrolling: function(namespace, element) {
      document.documentElement.classList.remove('lock-scroll');
      var el = element ? element : document.documentElement;
      el.off('touchmove' + namespace);
    }
  };
  
  // Add class when tab key starts being used to show outlines
  document.documentElement.on('keyup.tab', function(evt) {
    if (evt.keyCode === 9) {
      document.documentElement.classList.add('tab-outline');
      document.documentElement.off('keyup.tab');
    }
  });
  
  /**
   * Currency Helpers
   * -----------------------------------------------------------------------------
   * A collection of useful functions that help with currency formatting
   *
   * Current contents
   * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
   *   - When theme.settings.superScriptPrice is enabled, format cents in <sup> tag
   * - getBaseUnit - Splits unit price apart to get value + unit
   *
   */
  
theme.Currency = (function() {
    var moneyFormat = '${{amount}}';
    var superScript = theme && theme.settings && theme.settings.superScriptPrice;
  
    function formatMoney(cents, format) {
      if (!format) {
        format = theme.settings.moneyFormat;
      }
  
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || moneyFormat);
  
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = theme.utils.defaultTo(precision, 2);
        thousands = theme.utils.defaultTo(thousands, ',');
        decimal = theme.utils.defaultTo(decimal, '.');
  
        if (isNaN(number) || number == null) {
          return 0;
        }
  
        number = (number / 100.0).toFixed(precision);
  
        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? (decimal + parts[1]) : '';
  
        return dollarsAmount + centsAmount;
      }
  
      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
  
          if (superScript && value && value.includes('.')) {
            value = value.replace('.', '<sup>') + '</sup>';
          }
  
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
  
          if (superScript && value && value.includes('.')) {
            value = value.replace(',', '<sup>') + '</sup>';
          }
  
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
      }
  
      return formatString.replace(placeholderRegex, value);
    }
  
    function getBaseUnit(variant) {
      if (!variant) {
        return;
      }
  
      if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
        return;
      }
  
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    }
  
    return {
      formatMoney: formatMoney,
      getBaseUnit: getBaseUnit
    }
  })();
  
  theme.Images = (function() {
  
    /**
     * Find the Shopify image attribute size
     */
    function imageSize(src) {
      if (!src) {
        return '620x'; // default based on theme
      }
  
      var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
  
      if (match !== null) {
        return match[1];
      } else {
        return null;
      }
    }
  
    /**
     * Adds a Shopify size attribute to a URL
     */
    function getSizedImageUrl(src, size) {
      if (!src) {
        return src;
      }
  
      if (size == null) {
        return src;
      }
  
      if (size === 'master') {
        return this.removeProtocol(src);
      }
  
      var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
  
      if (match != null) {
        var prefix = src.split(match[0]);
        var suffix = match[0];
  
        return this.removeProtocol(prefix[0] + '_' + size + suffix);
      }
  
      return null;
    }
  
    function removeProtocol(path) {
      return path.replace(/http(s)?:/, '');
    }
  
    function lazyloadImagePath(string) {
      var image;
  
      if (string !== null) {
        image = string.replace(/(\.[^.]*)$/, "_{width}x$1");
      }
  
      return image;
    }
  
    return {
      imageSize: imageSize,
      getSizedImageUrl: getSizedImageUrl,
      removeProtocol: removeProtocol,
      lazyloadImagePath: lazyloadImagePath
    };
  })();
  
  theme.loadImageSection = function(container) {
    // Wait until images inside container have lazyloaded class
    function setAsLoaded() {
      container.classList.remove('loading', 'loading--delayed');
      container.classList.add('loaded');
    }
  
    function checkForLazyloadedImage() {
      return container.querySelector('.lazyloaded');
    }
  
    // If it has SVGs it's in the onboarding state so set as loaded
    if (container.querySelector('svg')) {
      setAsLoaded();
      return;
    };
  
    if (checkForLazyloadedImage()) {
      setAsLoaded();
      return;
    }
  
    var interval = setInterval(function() {
      if (checkForLazyloadedImage()) {
        clearInterval(interval);
        setAsLoaded();
      }
    }, 25);
  };
  
  // Init section function when it's visible, then disable observer
  theme.initWhenVisible = function(options) {
    var threshold = options.threshold ? options.threshold : 0;
  
    var observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (typeof options.callback === 'function') {
            options.callback();
            observer.unobserve(entry.target);
          }
        }
      });
    }, {rootMargin: '0px 0px '+ threshold +'px 0px'});
  
    observer.observe(options.element);
  };
  
  theme.LibraryLoader = (function() {
    var types = {
      link: 'link',
      script: 'script'
    };
  
    var status = {
      requested: 'requested',
      loaded: 'loaded'
    };
  
    var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';
  
    var libraries = {
      youtubeSdk: {
        tagId: 'youtube-sdk',
        src: 'https://www.youtube.com/iframe_api',
        type: types.script
      },
      vimeo: {
        tagId: 'vimeo-api',
        src: 'https://player.vimeo.com/api/player.js',
        type: types.script
      },
      shopifyXr: {
        tagId: 'shopify-model-viewer-xr',
        src: cloudCdn + 'shopify-xr-js/assets/v1.0/shopify-xr.en.js',
        type: types.script
      },
      modelViewerUi: {
        tagId: 'shopify-model-viewer-ui',
        src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.en.js',
        type: types.script
      },
      modelViewerUiStyles: {
        tagId: 'shopify-model-viewer-ui-styles',
        src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
        type: types.link
      }
    };
  
    function load(libraryName, callback) {
      var library = libraries[libraryName];
  
      if (!library) return;
      if (library.status === status.requested) return;
  
      callback = callback || function() {};
      if (library.status === status.loaded) {
        callback();
        return;
      }
  
      library.status = status.requested;
  
      var tag;
  
      switch (library.type) {
        case types.script:
          tag = createScriptTag(library, callback);
          break;
        case types.link:
          tag = createLinkTag(library, callback);
          break;
      }
  
      tag.id = library.tagId;
      library.element = tag;
  
      var firstScriptTag = document.getElementsByTagName(library.type)[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  
    function createScriptTag(library, callback) {
      var tag = document.createElement('script');
      tag.src = library.src;
      tag.addEventListener('load', function() {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }
  
    function createLinkTag(library, callback) {
      var tag = document.createElement('link');
      tag.href = library.src;
      tag.rel = 'stylesheet';
      tag.type = 'text/css';
      tag.addEventListener('load', function() {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }
  
    return {
      load: load
    };
  })();
  
  theme.rteInit = function() {
    // Wrap tables so they become scrollable on small screens
    document.querySelectorAll('.rte table').forEach(table => {
      var wrapWith = document.createElement('div');
      wrapWith.classList.add('table-wrapper');
      theme.utils.wrap(table, wrapWith);
    });
  
    // Wrap video iframe embeds so they are responsive
    document.querySelectorAll('.rte iframe[src*="youtube.com/embed"]').forEach(iframe => {
      wrapVideo(iframe);
    });
    document.querySelectorAll('.rte iframe[src*="player.vimeo"]').forEach(iframe => {
      wrapVideo(iframe);
    });
  
    function wrapVideo(iframe) {
      // Reset the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      iframe.src = iframe.src;
      var wrapWith = document.createElement('div');
      wrapWith.classList.add('video-wrapper');
      theme.utils.wrap(iframe, wrapWith);
    }
  
    // Remove CSS that adds animated underline under image links
    document.querySelectorAll('.rte a img').forEach(img => {
      img.parentNode.classList.add('rte__image');
    });
  }
  
  theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];
  
    document.addEventListener('shopify:section:load', this._onSectionLoad.bind(this));
    document.addEventListener('shopify:section:unload', this._onSectionUnload.bind(this));
    document.addEventListener('shopify:section:select', this._onSelect.bind(this));
    document.addEventListener('shopify:section:deselect', this._onDeselect.bind(this));
    document.addEventListener('shopify:block:select', this._onBlockSelect.bind(this));
    document.addEventListener('shopify:block:deselect', this._onBlockDeselect.bind(this));
  };
  
  theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
    _createInstance: function(container, constructor, scope) {
      var id = container.getAttribute('data-section-id');
      var type = container.getAttribute('data-section-type');
  
      constructor = constructor || this.constructors[type];
  
      if (typeof constructor === 'undefined') {
        return;
      }
  
      // If custom scope passed, check to see if instance
      // is already initialized so we don't double up
      if (scope) {
        var instanceExists = this._findInstance(id);
        if (instanceExists) {
          this._removeInstance(id);
        }
      }
  
      var instance = Object.assign(new constructor(container), {
        id: id,
        type: type,
        container: container
      });
  
      this.instances.push(instance);
    },
  
    _findInstance: function(id) {
      for (var i = 0; i < this.instances.length; i++) {
        if (this.instances[i].id === id) {
          return this.instances[i];
        }
      }
    },
  
    _removeInstance: function(id) {
      var i = this.instances.length;
      var instance;
  
      while(i--) {
        if (this.instances[i].id === id) {
          instance = this.instances[i];
          this.instances.splice(i, 1);
          break;
        }
      }
  
      return instance;
    },
  
    _onSectionLoad: function(evt, subSection, subSectionId) {
      if (window.AOS) { AOS.refreshHard() }
      if (theme && theme.initGlobals) {
        theme.initGlobals();
      }
  
      var container = subSection ? subSection : evt.target;
      var section = subSection ? subSection : evt.target.querySelector('[data-section-id]');
  
      if (!section) {
        return;
      }
  
      this._createInstance(section);
  
      var instance = subSection ? subSectionId : this._findInstance(evt.detail.sectionId);
  
      // Check if we have subsections to load
      var haveSubSections = container.querySelectorAll('[data-subsection]');
      if (haveSubSections.length) {
        this.loadSubSections(container);
      }
  
      // Run JS only in case of the section being selected in the editor
      // before merchant clicks "Add"
      if (instance && typeof instance.onLoad === 'function') {
        instance.onLoad(evt);
      }
  
      // Force editor to trigger scroll event when loading a section
      setTimeout(function() {
        window.dispatchEvent(new Event('scroll'));
      }, 200);
    },
  
    _onSectionUnload: function(evt) {
      this.instances = this.instances.filter(function(instance) {
        var isEventInstance = instance.id === evt.detail.sectionId;
  
        if (isEventInstance) {
          if (typeof instance.onUnload === 'function') {
            instance.onUnload(evt);
          }
        }
  
        return !isEventInstance;
      });
    },
  
    loadSubSections: function(scope) {
      if (!scope) {
        return;
      }
  
      var sections = scope.querySelectorAll('[data-section-id]');
  
      sections.forEach(el => {
        this._onSectionLoad(null, el, el.dataset.sectionId);
      });
    },
  
    _onSelect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onSelect === 'function'
      ) {
        instance.onSelect(evt);
      }
    },
  
    _onDeselect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onDeselect === 'function'
      ) {
        instance.onDeselect(evt);
      }
    },
  
    _onBlockSelect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onBlockSelect === 'function'
      ) {
        instance.onBlockSelect(evt);
      }
    },
  
    _onBlockDeselect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onBlockDeselect === 'function'
      ) {
        instance.onBlockDeselect(evt);
      }
    },
  
    register: function(type, constructor, scope) {
      this.constructors[type] = constructor;
  
      var sections = document.querySelectorAll('[data-section-type="' + type + '"]');
  
      if (scope) {
        sections = scope.querySelectorAll('[data-section-type="' + type + '"]');
      }
  
      sections.forEach(
        function(container) {
          this._createInstance(container, constructor, scope);
        }.bind(this)
      );
    },
  
    reinit: function(section) {
      for (var i = 0; i < this.instances.length; i++) {
        var instance = this.instances[i];
        if (instance['type'] === section) {
          if (typeof instance.forceReload === 'function') {
            instance.forceReload();
          }
        }
      }
    }
  });
  
  theme.Variants = (function() {
  
    function Variants(options) {
      this.container = options.container;
      this.variants = options.variants;
      this.singleOptionSelector = options.singleOptionSelector;
      this.originalSelectorId = options.originalSelectorId;
      this.enableHistoryState = options.enableHistoryState;
      this.currentVariant = this._getVariantFromOptions();
  
      this.container.querySelectorAll(this.singleOptionSelector).forEach(el => {
        el.addEventListener('change', this._onSelectChange.bind(this));
      });
    }
  
    Variants.prototype = Object.assign({}, Variants.prototype, {
  
      _getCurrentOptions: function() {
        var result = [];
  
        this.container.querySelectorAll(this.singleOptionSelector).forEach(el => {
          var type = el.getAttribute('type');
  
          if (type === 'radio' || type === 'checkbox') {
            if (el.checked) {
              result.push({
                value: el.value,
                index: el.dataset.index
              });
            }
          } else {
            result.push({
              value: el.value,
              index: el.dataset.index
            });
          }
        });
  
        // remove any unchecked input values if using radio buttons or checkboxes
        result = theme.utils.compact(result);
  
        return result;
      },
  
      _getVariantFromOptions: function() {
        var selectedValues = this._getCurrentOptions();
        var variants = this.variants;
        var found = false;
  
        variants.forEach(function(variant) {
          var match = true;
          var options = variant.options;
  
          selectedValues.forEach(function(option) {
            if (match) {
              match = (variant[option.index] === option.value);
            }
          });
  
          if (match) {
            found = variant;
          }
        });
  
        return found || null;
      },
  
      _onSelectChange: function() {
        var variant = this._getVariantFromOptions();
  
        this.container.dispatchEvent(new CustomEvent('variantChange', {
          detail: {
            variant: variant
          }
        }));
  
        document.dispatchEvent(new CustomEvent('variant:change', {
          detail: {
            variant: variant
          }
        }));
  
        if (!variant) {
          return;
        }
  
        this._updateMasterSelect(variant);
        this._updateImages(variant);
        this._updatePrice(variant);
        this._updateUnitPrice(variant);
        this._updateSKU(variant);
        this.currentVariant = variant;
  
        if (this.enableHistoryState) {
          this._updateHistoryState(variant);
        }
      },
  
      _updateImages: function(variant) {
        var variantImage = variant.featured_image || {};
        var currentVariantImage = this.currentVariant.featured_image || {};
  
        if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
          return;
        }
  
        this.container.dispatchEvent(new CustomEvent('variantImageChange', {
          detail: {
            variant: variant
          }
        }));
      },
  
      _updatePrice: function(variant) {
        if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
          return;
        }
  
        this.container.dispatchEvent(new CustomEvent('variantPriceChange', {
          detail: {
            variant: variant
          }
        }));
      },
  
      _updateUnitPrice: function(variant) {
        if (variant.unit_price === this.currentVariant.unit_price) {
          return;
        }
  
        this.container.dispatchEvent(new CustomEvent('variantUnitPriceChange', {
          detail: {
            variant: variant
          }
        }));
      },
  
      _updateSKU: function(variant) {
        if (variant.sku === this.currentVariant.sku) {
          return;
        }
  
        this.container.dispatchEvent(new CustomEvent('variantSKUChange', {
          detail: {
            variant: variant
          }
        }));
      },
  
      _updateHistoryState: function(variant) {
        if (!history.replaceState || !variant) {
          return;
        }
  
        var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
        window.history.replaceState({path: newurl}, '', newurl);
      },
  
      _updateMasterSelect: function(variant) {
        this.container.querySelector(this.originalSelectorId).value = variant.id;
        // Force a change event so Shop Pay installments works after a variant is changed
        this.container.querySelector(this.originalSelectorId).dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  
    return Variants;
  })();
  
  window.vimeoApiReady = function() {
    theme.config.vimeoLoading = true;
  
    // Because there's no way to check for the Vimeo API being loaded
    // asynchronously, we use this terrible timeout to wait for it being ready
    checkIfVimeoIsReady()
      .then(function() {
        theme.config.vimeoReady = true;
        theme.config.vimeoLoading = false;
        document.dispatchEvent(new CustomEvent('vimeoReady'));
      });
  }
  
  function checkIfVimeoIsReady() {
    var wait;
    var timeout;
  
    var deferred = new Promise((resolve, reject) => {
      wait = setInterval(function() {
        if (!Vimeo) {
          return;
        }
  
        clearInterval(wait);
        clearTimeout(timeout);
        resolve();
      }, 500);
  
      timeout = setTimeout(function() {
        clearInterval(wait);
        reject();
      }, 4000); // subjective. test up to 8 times over 4 seconds
    });
  
    return deferred;
  }
  
  theme.VimeoPlayer = (function() {
    var classes = {
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable'
    }
  
    var defaults = {
      background: true,
      byline: false,
      controls: false,
      loop: true,
      muted: true,
      playsinline: true,
      portrait: false,
      title: false
    };
  
    function VimeoPlayer(divId, videoId, options) {
      this.divId = divId;
      this.el = document.getElementById(divId);
      this.videoId = videoId;
      this.iframe = null;
      this.options = options;
  
      if (this.options && this.options.videoParent) {
        this.parent = this.el.closest(this.options.videoParent);
      }
  
      this.setAsLoading();
  
      if (theme.config.vimeoReady) {
        this.init();
      } else {
        theme.LibraryLoader.load('vimeo', window.vimeoApiReady);
        document.addEventListener('vimeoReady', this.init.bind(this));
      }
    }
  
    VimeoPlayer.prototype = Object.assign({}, VimeoPlayer.prototype, {
      init: function() {
        var args = defaults;
        args.id = this.videoId;
  
        this.videoPlayer = new Vimeo.Player(this.el, args);
  
        this.videoPlayer.ready().then(this.playerReady.bind(this));
      },
  
      playerReady: function() {
        this.iframe = this.el.querySelector('iframe');
        this.iframe.setAttribute('tabindex', '-1');
  
        this.videoPlayer.setMuted(true);
  
        this.setAsLoaded();
  
        // pause when out of view
        var observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.play();
            } else {
              this.pause();
            }
          });
        }, {rootMargin: '0px 0px 50px 0px'});
  
        observer.observe(this.iframe);
      },
  
      setAsLoading: function() {
        if (!this.parent) return;
        this.parent.classList.add(classes.loading);
      },
  
      setAsLoaded: function() {
        if (!this.parent) return;
        this.parent.classList.remove(classes.loading);
        this.parent.classList.add(classes.loaded);
        if (Shopify && Shopify.designMode) {
          if (window.AOS) {AOS.refreshHard()}
        }
      },
  
      enableInteraction: function() {
        if (!this.parent) return;
        this.parent.classList.add(classes.interactable);
      },
  
      play: function() {
        if (this.videoPlayer && typeof this.videoPlayer.play === 'function') {
          this.videoPlayer.play();
        }
      },
  
      pause: function() {
        if (this.videoPlayer && typeof this.videoPlayer.pause === 'function') {
          this.videoPlayer.pause();
        }
      },
  
      destroy: function() {
        if (this.videoPlayer && typeof this.videoPlayer.destroy === 'function') {
          this.videoPlayer.destroy();
        }
      }
    });
  
    return VimeoPlayer;
  })();
  
  window.onYouTubeIframeAPIReady = function() {
    theme.config.youTubeReady = true;
    document.dispatchEvent(new CustomEvent('youTubeReady'));
  }
  
  /*============================================================================
    YouTube SDK method
    Parameters:
      - player div id (required)
      - arguments
        - videoId (required)
        - videoParent (selector, optional for section loading state)
        - events (object, optional)
  ==============================================================================*/
  theme.YouTube = (function() {
    var classes = {
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable'
    }
  
    var defaults = {
      width: 1280,
      height: 720,
      playerVars: {
        autohide: 0,
        autoplay: 1,
        cc_load_policy: 0,
        controls: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        rel: 0
      }
    };
  
    function YouTube(divId, options) {
      this.divId = divId;
      this.iframe = null;
  
      this.attemptedToPlay = false;
  
      // API callback events
      defaults.events = {
        onReady: this.onVideoPlayerReady.bind(this),
        onStateChange: this.onVideoStateChange.bind(this)
      };
  
      this.options = Object.assign({}, defaults, options);
  
      if (this.options) {
        if (this.options.videoParent) {
          this.parent = document.getElementById(this.divId).closest(this.options.videoParent);
        }
  
        // Most YT videos will autoplay. If in product media,
        // will handle in theme.Product instead
        if (!this.options.autoplay) {
          this.options.playerVars.autoplay = this.options.autoplay;
        }
  
        if (this.options.style === 'sound') {
          this.options.playerVars.controls = 1;
          this.options.playerVars.autoplay = 0;
        }
  
      }
  
      this.setAsLoading();
  
      if (theme.config.youTubeReady) {
        this.init();
      } else {
        theme.LibraryLoader.load('youtubeSdk');
        document.addEventListener('youTubeReady', this.init.bind(this));
      }
    }
  
    YouTube.prototype = Object.assign({}, YouTube.prototype, {
      init: function() {
        this.videoPlayer = new YT.Player(this.divId, this.options);
      },
  
      onVideoPlayerReady: function(evt) {
        this.iframe = document.getElementById(this.divId); // iframe once YT loads
        this.iframe.setAttribute('tabindex', '-1');
  
        if (this.options.style !== 'sound') {
          evt.target.mute();
        }
  
        // pause when out of view
        var observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.play();
            } else {
              this.pause();
            }
          });
        }, {rootMargin: '0px 0px 50px 0px'});
  
        observer.observe(this.iframe);
      },
  
      onVideoStateChange: function(evt) {
        switch (evt.data) {
          case -1: // unstarted
            // Handle low power state on iOS by checking if
            // video is reset to unplayed after attempting to buffer
            if (this.attemptedToPlay) {
              this.setAsLoaded();
              this.enableInteraction();
            }
            break;
          case 0: // ended, loop it
            this.play(evt);
            break;
          case 1: // playing
            this.setAsLoaded();
            break;
          case 3: // buffering
            this.attemptedToPlay = true;
            break;
        }
      },
  
      setAsLoading: function() {
        if (!this.parent) return;
        this.parent.classList.add(classes.loading);
      },
  
      setAsLoaded: function() {
        if (!this.parent) return;
        this.parent.classList.remove(classes.loading);
        this.parent.classList.add(classes.loaded);
        if (Shopify && Shopify.designMode) {
          if (window.AOS) {AOS.refreshHard()}
        }
      },
  
      enableInteraction: function() {
        if (!this.parent) return;
        this.parent.classList.add(classes.interactable);
      },
  
      play: function() {
        if (this.videoPlayer && typeof this.videoPlayer.playVideo === 'function') {
          this.videoPlayer.playVideo();
        }
      },
  
      pause: function() {
        if (this.videoPlayer && typeof this.videoPlayer.pauseVideo === 'function') {
          this.videoPlayer.pauseVideo();
        }
      },
  
      destroy: function() {
        if (this.videoPlayer && typeof this.videoPlayer.destroy === 'function') {
          this.videoPlayer.destroy();
        }
      }
    });
  
    return YouTube;
  })();
  
  // Patch Flickity resize event for iOS15 jank fix
  (function() {
    var originalResizeMethod = Flickity.prototype.resize;
    var lastWidth = window.innerWidth;
  
    Flickity.prototype.resize = function() {
      if (window.innerWidth === lastWidth) {
        return;
      }
  
      lastWidth = window.innerWidth;
      originalResizeMethod.apply(this, arguments); // Call original method
    }
  })();
  
  // Prevent vertical scroll while using flickity sliders
  (function() {
    var e = !1;
    var t;
  
    document.body.addEventListener('touchstart', function(i) {
      if (!i.target.closest('.flickity-slider')) {
        return e = !1;
        void 0;
      }
      e = !0;
      t = {
        x: i.touches[0].pageX,
        y: i.touches[0].pageY
      }
    })
  
    document.body.addEventListener('touchmove', function(i) {
      if (e && i.cancelable) {
        var n = {
          x: i.touches[0].pageX - t.x,
          y: i.touches[0].pageY - t.y
        };
        Math.abs(n.x) > Flickity.defaults.dragThreshold && i.preventDefault()
      }
    }, { passive: !1 })
  })();
  

  /**
   * Ajax Renderer
   * -----------------------------------------------------------------------------
   * Render sections without reloading the page.
   * @param {Object[]} sections - The section to update on render.
   * @param {string} sections[].sectionId - The ID of the section from Shopify.
   * @param {string} sections[].nodeId - The ID of the DOM node to replace.
   * @param {Function} sections[].onReplace (optional) - The custom render function.
   * @param {string[]} preserveParams - The param name to preserve in the URL.
   * @param {boolean} debug - Output logs to console for debugging.
   *
   */
  
  theme.AjaxRenderer = (function () {
    function AjaxRenderer({ sections, preserveParams, onReplace, debug } = {}) {
      this.sections = sections || [];
      this.preserveParams = preserveParams || [];
      this.cachedSections = [];
      this.onReplace = onReplace;
      this.debug = Boolean(debug);
    }
  
    AjaxRenderer.prototype = Object.assign({}, AjaxRenderer.prototype, {
      renderPage: function (basePath, searchParams, updateURLHash = true) {
        if (searchParams) this.appendPreservedParams(searchParams);
  
        const sectionRenders = this.sections.map(section => {
          const url = `${basePath}?section_id=${section.sectionId}&${searchParams}`;
          const cachedSectionUrl = cachedSection => cachedSection.url === url;
  
          return this.cachedSections.some(cachedSectionUrl)
            ? this.renderSectionFromCache(cachedSectionUrl, section)
            : this.renderSectionFromFetch(url, section);
        });
  
        if (updateURLHash) this.updateURLHash(searchParams);
  
        return Promise.all(sectionRenders);
      },
  
      renderSectionFromCache: function (url, section) {
        const cachedSection = this.cachedSections.find(url);
  
        this.log(`[AjaxRenderer] rendering from cache: url=${cachedSection.url}`);
        this.renderSection(cachedSection.html, section);
        return Promise.resolve(section);
      },
  
      renderSectionFromFetch: function (url, section) {
        this.log(`[AjaxRenderer] redering from fetch: url=${url}`);
  
        return new Promise((resolve, reject) => {
          fetch(url)
            .then(response => response.text())
            .then(responseText => {
              const html = responseText;
              this.cachedSections = [...this.cachedSections, { html, url }];
              this.renderSection(html, section);
              resolve(section);
            })
            .catch(err => reject(err));
        });
      },
  
      renderSection: function (html, section) {
        this.log(
          `[AjaxRenderer] rendering section: section=${JSON.stringify(section)}`,
        );
  
        const newDom = new DOMParser().parseFromString(html, 'text/html');
        if (this.onReplace) {
          this.onReplace(newDom, section);
        } else {
          if (typeof section.nodeId === 'string') {
            document.getElementById(section.nodeId).innerHTML =
              newDom.getElementById(section.nodeId).innerHTML;
          } else {
            section.nodeId.forEach(id => {
              document.getElementById(id).innerHTML =
                newDom.getElementById(id).innerHTML;
            });
          }
        }
  
        return section;
      },
  
      appendPreservedParams: function (searchParams) {
        this.preserveParams.forEach(paramName => {
          const param = new URLSearchParams(window.location.search).get(
            paramName,
          );
  
          if (param) {
            this.log(`[AjaxRenderer] Preserving ${paramName} param`);
            searchParams.append(paramName, param);
          }
        });
      },
  
      updateURLHash: function (searchParams) {
        history.pushState(
          {},
          '',
          `${window.location.pathname}${
            searchParams && '?'.concat(searchParams)
          }`,
        );
      },
  
      log: function (...args) {
        if (this.debug) {
          console.log(...args);
        }
      },
    });
  
    return AjaxRenderer;
  })();
  
  theme.cart = {
    getCart: function() {
      var url = ''.concat(theme.routes.cart, '?t=').concat(Date.now());
      return fetch(url, {
        credentials: 'same-origin',
        method: 'GET'
      }).then(response => response.json());
    },
  
    getCartProductMarkup: function() {
      var url = ''.concat(theme.routes.cartPage, '?t=').concat(Date.now());
  
      url = url.indexOf('?') === -1 ? (url + '?view=ajax') : (url + '&view=ajax');
  
      return fetch(url, {
        credentials: 'same-origin',
        method: 'GET'
      })
      .then(function(response) {return response.text()});
    },
  
    changeItem: function(key, qty) {
      return this._updateCart({
        url: ''.concat(theme.routes.cartChange, '?t=').concat(Date.now()),
        data: JSON.stringify({
          id: key,
          quantity: qty
        })
      })
    },

    changeItem: function(data) {
      return this._updateCart({
        url: ''.concat(theme.routes.cartChange, '?t=').concat(Date.now()),
        data: JSON.stringify({
          ...data
        })
      })
    },

    updateItems: function(data) {
      return this._updateCart({
        url: '/cart/update.js',
        data: JSON.stringify({
          updates: {...data}
        })
      });
    },

    addGiftWrappingToCart: function() {
      return this._updateCart({
        url: '/cart/add.js',
        data: JSON.stringify({
          items: [
            {
              quantity: 1,
              id: 42222635155571,
            }
          ]
        })
      });
    },


    // free gift used when cart amount is eligible
     addFreeMysteryNecklace: function() {
      return this._updateCart({
        url: '/cart/add.js',
        data: JSON.stringify({
          items: [
            {
              quantity: 1,
              id: 42222962835571,
            }
          ]
        })
      });
    },
    
    _updateCart: function(params) {
      return fetch(params.url, {
        method: 'POST',
        body: params.data,
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => response.json())
      .then(function(cart) {
        return cart;
      });
    },
  
    updateAttribute: function(key, value) {
      return this._updateCart({
        url: '/cart/update.js',
        data: JSON.stringify({
          attributes: {
            [key]: theme.cart.attributeToString(value)
          }
        })
      });
    },
  
    updateNote: function(note) {
      return this._updateCart({
        url: '/cart/update.js',
        data: JSON.stringify({
          note: theme.cart.attributeToString(note)
        })
      });
    },
  
    attributeToString: function(attribute) {
      if ((typeof attribute) !== 'string') {
        attribute += '';
        if (attribute === 'undefined') {
          attribute = '';
        }
      }
      return attribute.trim();
    }
  }
  
  /*============================================================================
    CartForm
    - Prevent checkout when terms checkbox exists
    - Listen to quantity changes, rebuild cart (both widget and page)
  ==============================================================================*/
  theme.CartForm = (function() {
    var selectors = {
      products: '[data-products]',
      qtySelector: '.js-qty__wrapper',
      qtyRemoveSelector: '.js-qty__remove__wrapper',
      discounts: '[data-discounts]',
      savings: '[data-savings]',
      subTotal: '[data-subtotal]',
      subTotalBtn: '[data-subtotal-btn]',
      subtotalWithoutDiscount: '[data-subtotal-without-discount]',
  
      cartBubble: '.cart-link__bubble',
      cartNote: '[name="note"]',
      termsCheckbox: '.cart__terms-checkbox',
      checkoutBtn: '.cart__checkout',
      addGiftWrapping: 'add-gift-wrapping'
    };
  
    var classes = {
      btnLoading: 'btn--loading'
    };
  
    var config = {
      requiresTerms: false
    };
  
    function CartForm(form) {

      if (!form) {
        return;
      }
  
      this.form = form;
      this.wrapper = form.parentNode;
      this.location = form.dataset.location;
      this.namespace = '.cart-' + this.location;
      this.products = form.querySelector(selectors.products)
      this.submitBtn = form.querySelector(selectors.checkoutBtn);
  
      this.discounts = form.querySelector(selectors.discounts);
      this.savings = form.querySelector(selectors.savings);
      this.subtotal = form.querySelector(selectors.subTotal);
      this.subTotalBtn = form.querySelector(selectors.subTotalBtn);
      this.subtotalWithoutDiscount = form.querySelector(selectors.subtotalWithoutDiscount);
      this.termsCheckbox = form.querySelector(selectors.termsCheckbox);
      this.noteInput = form.querySelector(selectors.cartNote);

      this.addGiftWrapping = document.getElementById(selectors.addGiftWrapping);
  
      if (this.termsCheckbox) {
        config.requiresTerms = true;
      }
  
      this.init();
    }
  
    CartForm.prototype = Object.assign({}, CartForm.prototype, {
      init: function() {
        this.initQtySelectors();
  
        document.addEventListener('cart:quantity' + this.namespace, this.quantityChanged.bind(this));
        document.addEventListener('cart:gift-wrapping-enabled', this.enabledGiftWrapping.bind(this) );

  
        this.form.on('submit' + this.namespace, this.onSubmit.bind(this));
        
        this.addGiftWrapping.addEventListener('input', this.addGiftWrappingCallback.bind(this))

  
        if (this.noteInput) {
          this.noteInput.addEventListener('change', function() {
            var newNote = this.value;
            theme.cart.updateNote(newNote);
          });
        }
  
        // Dev-friendly way to build the cart
        document.addEventListener('cart:build', function() {
          this.buildCart();
        }.bind(this));
      },
  
      reInit: function() {
        this.initQtySelectors();
      },
  
      onSubmit: function(evt) {
        this.submitBtn.classList.add(classes.btnLoading);
  
        if (config.requiresTerms) {
          if (this.termsCheckbox.checked) {
            // continue to checkout
          } else {
            alert(theme.strings.cartTermsConfirmation);
            this.submitBtn.classList.remove(classes.btnLoading)
            evt.preventDefault();
            return false;
          }
        }
      },

      enabledGiftWrapping: function() {
        let el = document.getElementById('gift-wrapping-checkout-selection')

        theme.cart.getCart().then(function (cart) {
          let hasGiftPackaging = cart.items.filter(e => e.id === 42222635155571).length > 0
          if (el != null && !hasGiftPackaging) {
            el.classList.remove("hide");
          }
        })
      },
  
      /*============================================================================
        Query cart page to get markup
      ==============================================================================*/
      _parseProductHTML: function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        return {
          items: doc.querySelector('.cart__items'),
          discounts: doc.querySelector('.cart__discounts')
        }
      },
  
      buildCart: function() {
        theme.cart.getCartProductMarkup().then(this.cartMarkup.bind(this));
      },
  
      cartMarkup: function(html) {
        var markup = this._parseProductHTML(html);
        var items = markup.items;
        var count = parseInt(items.dataset.count);
        var subtotal = items.dataset.cartSubtotal;
        var subtotalWithoutDiscount = items.dataset.cartTotalWithoutDiscount;
        var savings = items.dataset.cartSavings ? items.dataset.cartSavings : 0;
        this.updateCartDiscounts(markup.discounts);
        this.updateSavings(savings);
  
        if (count > 0) {
          this.wrapper.classList.remove('is-empty');
        } else {
          this.wrapper.classList.add('is-empty');
        }
        
        this.updateCount(count);
        
        // fix items count in cart drawer 
        var valid_item_count = 0;
        let item_details = items.querySelectorAll('.cart__item')
        for(let i=0; i < item_details.length; i++) {
          let item_detail = item_details[i];
          let item_title = item_detail.getAttribute('data-aex-title');
          let isHidden = item_detail.classList.contains("cart__item_hidden");
          let item_qty = item_detail.getAttribute('data-aex-qty');
          if (!( item_title.toLowerCase().includes("free $30 gift card") || item_title.toLowerCase().includes("bundle") || item_title.toLowerCase().includes("any 5") || item_title.toLowerCase().includes("free mystery item") || item_title.toLowerCase().includes("free mystery gift") || item_title.toLowerCase().includes("box deal") || item_title.toLowerCase().includes("gift packaging")))
            valid_item_count += parseInt(item_qty)
          }

        let item_hidden = items.querySelectorAll('.cart__item_hidden')
        // Append item markup
        this.products.innerHTML = '';
        this.products.append(items);

        // remove -Default title from items
            var items_title= items.querySelectorAll('.cart__item-title');
            
             items_title.forEach((el) => {
               
                 if (el.hasChildNodes()) {
                  let children = el.querySelectorAll('div');
                  for (const node of children) {
                     let nodeText= node.innerText.trim();
                     if ((nodeText!= null) && (nodeText.includes("- Default Title"))) {
                       let nodetxt=nodeText.replaceAll('\n', ' ')
                       node.innerText = nodetxt.replaceAll('- Default Title', ' ');
                      }
                     if ((nodeText!= null) && (nodeText.includes("-Default Title"))) {
                       let nodetxt=nodeText.replaceAll('\n', ' ')
                       node.innerText = nodetxt.replaceAll('-Default Title', ' ');
                     }
                  }
               }
          
        }); 

        //rearange prod 6 and 7 on bundle
       
          var element_to_style= items.querySelectorAll('div.hide.spooky22-savings-item')
          element_to_style.forEach((element) => {
             let next_element = element.nextElementSibling;
            if (next_element != null ){
             // console.log("nextElInertext:", next_element.innerText);
              let next_element_txt = next_element.innerText;
              if (next_element_txt.includes("Jewelry 6")) 
              {
                next_element.classList.add("order_last_6");
                 if (next_element.nextElementSibling.innerText.includes("Jewelry 7")){next_element.nextElementSibling.classList.add("order_last_7");}
                 if (next_element.nextElementSibling.nextElementSibling.innerText.includes("Jewelry 8")){next_element.nextElementSibling.nextElementSibling.classList.add("order_last_8");}
                 if (next_element.nextElementSibling.nextElementSibling.nextElementSibling.innerText.includes("Jewelry 9")){next_element.nextElementSibling.nextElementSibling.nextElementSibling.classList.add("order_last_9");}
                 if (next_element.nextElementSibling.nextElementSibling.nextElementSibling.nextElementSibling.innerText.includes("Jewelry 10")){next_element.nextElementSibling.nextElementSibling.nextElementSibling.nextElementSibling.classList.add("order_last_10");}           
                 if (next_element.nextElementSibling.nextElementSibling.nextElementSibling.nextElementSibling.nextElementSibling.innerText.includes("Jewelry 11")){next_element.nextElementSibling.nextElementSibling.nextElementSibling.nextElementSibling.nextElementSibling.classList.add("order_last_11");} 
                 if (next_element.nextElementSibling.nextElementSibling.nextElementSibling.nextElementSibling.nextElementSibling.nextElementSibling.innerText.includes("Jewelry 12")){next_element.nextElementSibling.nextElementSibling.nextElementSibling.nextElementSibling.nextElementSibling.nextElementSibling.classList.add("order_last_12");} 
               }
            }
          });

        // Update subtotal
        try {
          this.subtotal.innerHTML = theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat);
          this.subTotalBtn.innerHTML = theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat);
          this.subtotalWithoutDiscount.innerHTML = theme.Currency.formatMoney(subtotalWithoutDiscount, theme.settings.moneyFormat);
          this.updateSavingsAex(items, subtotal)
          this.updateCartBOGOPromo(items, count, subtotal);
          this.updateCart70PercentOffPromo(items, count, subtotal);
          this.updateCart50PercentOffPromo(items, count, subtotal);
          this.freeShippingCalc();
          this.updateCartFreeGiftSelector(items);


          // Cart Checkout Button Price update code start
          setTimeout(() => {

            let totalQty = 0;

            document.querySelectorAll('[data-aex-qty]').forEach(el => {
                let q = parseInt(el.getAttribute('data-aex-qty')) || 0;
                totalQty += q;
            });

            // only run when 5+
            if (totalQty < 5) return;


            let total = 0;

            document.querySelectorAll('.cart-item-price').forEach(row => {

                let discount = row.querySelector('[data-aex-cart-discount-price]');
                let compare = row.querySelector('[data-aex-cart-price]');

                let priceText = "";

                if (discount && discount.textContent.trim() !== "" && !discount.classList.contains('hide')) {
                    priceText = discount.textContent;
                } else if (compare) {
                    priceText = compare.textContent;
                }

                if (priceText) {
                    let price = parseFloat(priceText.replace(/[^0-9.]/g, ''));
                    if (!isNaN(price)) total += price;
                }

            });

            let btn = document.getElementById('cart-subtotal-btn');

            if (btn && total) {
                btn.innerHTML = theme.Currency.formatMoney(total * 100, theme.settings.moneyFormat);
            }

        }, 200);
        // Cart Checkout Button Price update code end

        } catch(e) {
        }

        this.reInit();
  
        if (window.AOS) { AOS.refreshHard() }
  
        if (Shopify && Shopify.StorefrontExpressButtons) {
          Shopify.StorefrontExpressButtons.initialize();
        }

        try {
          DoublyGlobalCurrency.convertAll(DoublyGlobalCurrency.currentCurrency, '')
        } catch(e) {

        }
      },

     freeShippingCalc: function () {
       let mirrorTotal = document.getElementById('cart-subtotal-btn');
        let TotalCart = Number(mirrorTotal.innerHTML.replace(/[^0-9-]+/g, ""));
        let CartUpdate = new CustomEvent("CartUpdate", { detail: TotalCart });
        window.dispatchEvent(CartUpdate);
          
            let matchFound = false;
            let matchedVariantIds = [];
            let targetVariantId = '42222834647155';
            const productButtons = document.querySelectorAll('.choose_popup_product_column .choose_select_product_btn');
            const cartItems = document.querySelectorAll('.cart__item');
            productButtons.forEach(button => {
                const productId = button.getAttribute('data-productid'); 
                cartItems.forEach(cartItem => {
                    const variantId = cartItem.getAttribute('data-variant-id'); 
                    if (productId === variantId || variantId === targetVariantId) {
                        matchFound = true;
                        if (!matchedVariantIds.includes(variantId)) {
                            matchedVariantIds.push(variantId); 
                        }
                    }
                });
            });
       
            const sg = document.querySelector('.choose_your_gift_main');
            const gi = document.getElementById('freeghiftimg');
            if (sg && gi) {
                if (matchFound) {
                    sg.classList.add('hide');
                    gi.src = "https://cdn.shopify.com/s/files/1/0315/5827/1111/files/Tick.svg?v=1747995715";
                } else {
                    gi.src = "https://cdn.shopify.com/s/files/1/0315/5827/1111/files/Tick.svg?v=1747995715";
                }
            }
        
          fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            let freeGiftUnlocked = false;
            let freeGiftVariantIds = [];
            let allfreeGiftUnlocked = false;
            let allfreeGiftVariantId = [];
        
            // Check if total price is zero, if so, remove all items
            if (cart.total_price === 0) {
              cart.items.forEach(item => {
                $.ajax({
                  type: 'POST',
                  url: '/cart/update.js',
                  data: { updates: { [item.variant_id]: 0 } },
                  dataType: 'json',
                  success: function (data) {
                    document.dispatchEvent(new CustomEvent('cart:build'));
                  },
                  error: function (XMLHttpRequest, textStatus) {
                    console.error('Error removing product from cart');
                  }
                });
              });
            } else {
              // Existing conditions to handle unlocked free gifts and other products
              cart.items.forEach(item => {
                if (theme.CartForm.needGiftAbTest === false && item.title.toLowerCase().includes("free")) {
                  allfreeGiftVariantId.push(item.variant_id);
                }
                if (item.properties && item.properties['_type'] === 'unlocked a free gift') {
                  freeGiftUnlocked = true;
                  freeGiftVariantIds.push(item.variant_id);
                }
              });
        
              // Remove extra free gifts if more than 1 is unlocked
              if (freeGiftUnlocked && freeGiftVariantIds.length > 1) {
                freeGiftVariantIds.slice(1).forEach(vId => {
                  $.ajax({
                    type: 'POST',
                    url: '/cart/update.js',
                    data: { updates: { [vId]: 0 } },
                    dataType: 'json',
                    success: function (data) {
                      document.dispatchEvent(new CustomEvent('cart:build'));
                    },
                    error: function (XMLHttpRequest, textStatus) {
                      console.error('Error removing product from cart');
                    }
                  });
                });
              }
        
              // Remove all free gifts if unlocked
              if (allfreeGiftUnlocked) {
                allfreeGiftVariantId.forEach(vId => {
                  $.ajax({
                    type: 'POST',
                    url: '/cart/update.js',
                    data: { updates: { [vId]: 0 } },
                    dataType: 'json',
                    success: function (data) {
                      document.dispatchEvent(new CustomEvent('cart:build'));
                    },
                    error: function (XMLHttpRequest, textStatus) {
                      console.error('Error removing product from cart');
                    }
                  });
                });
              }
            }
          })
          .catch(error => {
            console.error('Error fetching cart data:', error);
          });

      },

    updateCartFreeGiftSelector: function (items){
       var giftInCartAb = false;
       let itemdetails = items.querySelectorAll('.cart__item');
      
        for(let i=0; i < itemdetails.length; i++) {
          let itemdetail = itemdetails[i];
          if (itemdetail.classList.contains('cart__item_unlock_gift')) {
            let itemid = itemdetail.getAttribute('data-variant-id');
            giftInCartAb = true;
          }
        }
      
       if (theme.CartForm.needGiftAbTest == false){
          if  (giftInCartAb  == true) {
              var removeId = document.querySelector('.cart__item.cart__item_unlock_gift').getAttribute('data-variant-id');
               this.removeProductFromCart(removeId);
               theme.cart.getCart()
                 .then(function (cart){
                  this.buildCart();
               }.bind(this));           
          } 
       }
    },
 
    removeProductFromCart: function(variantId) {
        $.ajax({
          type: 'POST',
          url: '/cart/update.js', 
          data: {
            updates: {
              [variantId]: 0 
            }
          },
          dataType: 'json',
          success: function(data) {
            // console.log('Product removed from cart:', data);
          },
          error: function(XMLHttpRequest, textStatus) {
            // console.log('Error removing product from cart');
          }
        });
    },

    updateSavingsAex: function(items, subtotal) {
        let item_qtys_price = [];
        let item_details = items.querySelectorAll('.cart__item');
        for(let i=0; i < item_details.length; i++) {
          let item_detail = item_details[i];
          let item_qty = item_detail.getAttribute('data-aex-qty');
          let isHidden = item_detail.classList.contains("cart__item_hidden");
          let original_price = item_detail.getAttribute('data-aex-original-price')
          if (!isHidden) {
            item_qtys_price.push({'qty': item_qty, 'original_price': original_price})
          }
          let price_el = item_detail.querySelector('[data-aex-cart-price]');
          let discount_price_el = item_detail.querySelector('[data-aex-cart-discount-price]');
          let item_price = item_detail.getAttribute('data-aex-price');
          let priceforshown = item_qty * original_price;
          let discountforshown = item_qty * item_price;
          if (price_el != null) {
            price_el.innerHTML = `${theme.Currency.formatMoney(priceforshown, theme.settings.moneyFormat)}`;
          }
          if (original_price != item_price){
            if( discount_price_el != null ){
            discount_price_el.innerHTML = `<small class="cart__price-inline">${theme.Currency.formatMoney(discountforshown, theme.settings.moneyFormat)}</small> `;
             }
          } else {
            if (price_el != null) {
              price_el.innerHTML = '';
            }
          }
        }

        let original_price = 0;

        for (let i = 0; i < item_qtys_price.length; i++) {
          let c = item_qtys_price[i];
          original_price += c.qty * c.original_price
        }

        let el = this.form.querySelector('[data-aex-savings]');
        let savings = original_price - subtotal;
        let savingsLabel = el.closest('.cart__item-sub').querySelector('.drawer__cart-savings');
        if(savings == 0) {
          el.parentNode.style.display = 'none';
          savingsLabel.style.display = 'none';
        } else {
          el.parentNode.style.display = 'flex';
          savingsLabel.style.display = 'flex';
        }
        el.innerHTML = theme.Currency.formatMoney(savings, theme.settings.moneyFormat);
      },

      // updateCartBOGOPromo: function(items, count, subtotal) {
      //   var isActivePromo = false;
      //   var discountCode = null;
      //   var minimumProducts = null;
        
      //   if (Cookies.get("BEB_PROMOTION")) {
      //       var cookieValue = Cookies.get("BEB_PROMOTION");
      //       var promotionData = offerUpdates[cookieValue] || null;
      //       if (promotionData) {
      //           discountCode = promotionData.discountCode; 
      //           isActivePromo = true;
      //           minimumProducts = parseInt(promotionData.discountQty || 0);
      //       }
      //   }
        
      //   var valid_item_count = 0;
      //   let item_details = items.querySelectorAll('.cart__item');
       
      //   for(let i=0; i < item_details.length; i++) {
      //     let item_detail = item_details[i];
      //     let item_title = item_detail.getAttribute('data-aex-title');
      //     let item_variantid = item_detail.getAttribute('data-variant-id');
      //     let matchFound = false;
      //     const productButtons = document.querySelectorAll('.choose_popup_product_column .choose_select_product_btn');
      //     if (productButtons) {
      //       productButtons.forEach(button => {
      //           const productId = button.getAttribute('data-productid');
      //           if (productId === item_variantid) {
      //               matchFound = true;
      //           }
      //       }); 
      //     }
      //     let isHidden = item_detail.classList.contains("cart__item_hidden");
      //     if (!(matchFound || item_title.toLowerCase().includes("free $30 gift card") || item_title.toLowerCase().includes("bundle") || item_title.toLowerCase().includes("any 5") || item_title.toLowerCase().includes("free mystery item") || item_title.toLowerCase().includes("free mystery gift") || item_title.toLowerCase().includes("free mystery earrings") || item_title.toLowerCase().includes("box deal") || item_title.toLowerCase().includes("gift packaging")) && !isHidden ) {           
      //       let item_qty = item_detail.getAttribute('data-aex-qty');
      //       valid_item_count += parseInt(item_qty);
      //     }
      //   }

      //   if (isActivePromo) {
      //     let totalSavings = 0;
      //     let totalSpent = 0;

      //     try {
      //       if (valid_item_count >= minimumProducts) {
      //         console.log(valid_item_count,"valid_item_count")
      //         console.log(minimumProducts,"minimumProducts")
      //         let items_free_count = Math.floor(valid_item_count/2);
      //         let item_qtys_price = [];
      //         let item_details = items.querySelectorAll('.cart__item');
      //         for(let i=0; i < item_details.length; i++) {
      //           let item_detail = item_details[i];
      //           let item_title = item_detail.getAttribute('data-aex-title');
      //           let item_variantid = item_detail.getAttribute('data-variant-id');
      //           let matchFound = false;
      //           const productButtons = document.querySelectorAll('.choose_popup_product_column .choose_select_product_btn');
      //           if (productButtons) {
      //             productButtons.forEach(button => {
      //                 const productId = button.getAttribute('data-productid');
      //                 if (productId === item_variantid) {
      //                     matchFound = true;
      //                 }
      //             }); 
      //           }
      //           let isHidden = item_detail.classList.contains("cart__item_hidden");
      //           if (!(matchFound || item_title.toLowerCase().includes("free $30 gift card") || item_title.toLowerCase().includes("bundle") || item_title.toLowerCase().includes("any 5") || item_title.toLowerCase().includes("free mystery item") || item_title.toLowerCase().includes("free mystery gift") || item_title.toLowerCase().includes("free mystery earrings") || item_title.toLowerCase().includes("box deal") || item_title.toLowerCase().includes("gift packaging")) && !isHidden ) {
      //             let item_qty = item_detail.getAttribute('data-aex-qty');
      //             let item_price = item_detail.getAttribute('data-aex-price')
      //             let original_price = item_detail.getAttribute('data-aex-original-price')

      //             let price_el = item_detail.querySelector('[data-aex-cart-price]');
      //             let priceforshowntwo = item_qty * original_price;
      //             if (price_el != null) {
      //              price_el.innerHTML = `${theme.Currency.formatMoney(priceforshowntwo, theme.settings.moneyFormat)}`;
      //             }

      //             item_qtys_price.push({'qty': item_qty, 'price': item_price, 'key': i, 'original_price': original_price})
      //           } else if (!isHidden) {
      //             let item_price = item_detail.getAttribute('data-aex-price')
      //             let item_qty = item_detail.getAttribute('data-aex-qty');
      //             totalSpent += item_price * item_qty
      //           }
      //         }

      //         item_qtys_price = item_qtys_price.sort((a, b) => parseFloat(a.price) - parseFloat(b.price));

      //         for (let i = 0; i < item_qtys_price.length; i++) {
      //           if (items_free_count == 0) {
      //             let c = item_qtys_price[i];
      //             let originalSaving = (c.original_price * c.qty) - (c.price * c.qty);
      //             totalSpent += (c.original_price * c.qty)
      //             totalSavings += originalSaving;
      //           } else {
      //             let c = item_qtys_price[i];
      //             totalSpent += (c.original_price * c.qty)
      //             let item_detail = item_details[c.key]
      //             let price_el = item_detail.querySelector('[data-aex-cart-price]');
      //             let discount_price_el = item_detail.querySelector('[data-aex-cart-discount-price]');
      //             let discount_tag_el = item_detail.querySelector('[data-spooky22-savings-item]');
      //             let discount_tag_inner_el = item_detail.querySelector('[data-spooky22-dc]');
      //             discount_price_el.classList.remove("hide")
      //             discount_price_el.classList.add("cart__price_sale-spooky22")
      //             discount_tag_el.classList.remove("hide")
      //             discount_tag_inner_el.innerHTML = discountCode;
      
      //             if (c.qty <= items_free_count) {
      //               price_el.classList.add("cart__price--strikethrough")
      //               price_el.classList.add("cart__price_original-spooky22")
      //               price_el.innerHTML = `${theme.Currency.formatMoney(c.original_price*c.qty, theme.settings.moneyFormat)}`;
                    
      //               items_free_count -= c.qty;
      //               let finalPrice = 0
      //               let originalSaving = c.original_price * c.qty;
      //               totalSavings += originalSaving;
      //               discount_price_el.innerHTML = `<small class="cart__price-inline">${theme.Currency.formatMoney(finalPrice, theme.settings.moneyFormat)}</small>`;
      //               } else {                    
      //               let finalPrice = c.price
      //               let originalSaving = c.original_price * items_free_count;
      //               let totalsforshown = c.price * c.qty;
      //               let totalsforshown2 = c.original_price * c.qty;
      //               let pricediscountforshown = totalsforshown - originalSaving;
                  
      //               totalSavings += originalSaving + ((c.qty - items_free_count) * (c.original_price - c.price));
      //               let savingX = originalSaving + ((c.qty - items_free_count) * (c.original_price - c.price));
      //               let pricediscountforshown2 = totalsforshown2 - savingX;
                    
      //               if (finalPrice === c.original_price) {
      //                 price_el.classList.add("cart__price--strikethrough")
      //                 price_el.classList.add("cart__price_original-spooky22")
      //                 price_el.innerHTML = `${theme.Currency.formatMoney(totalsforshown, theme.settings.moneyFormat)}`;
      //                 discount_price_el.innerHTML = `<small class="cart__price-inline">${theme.Currency.formatMoney(pricediscountforshown, theme.settings.moneyFormat)}</small> `;
      //               } else {
      //                 price_el.classList.add("cart__price--strikethrough")
      //                 price_el.classList.add("cart__price_original-spooky22")
      //                 price_el.innerHTML = `${theme.Currency.formatMoney(totalsforshown2, theme.settings.moneyFormat)}`;
      //                 discount_price_el.innerHTML = `<small class="cart__price-inline">${theme.Currency.formatMoney(pricediscountforshown2, theme.settings.moneyFormat)}</small> `;
      //               }
      //               items_free_count = 0;
      //             }
      //           }
      //         }
      //       }
      //     } catch (err) {
      //       console.log(err);
      //     }

      //     let cart_savings_tag = "spooky22-cart-savings"
      //     let cart_savings_drawer_tag = "spooky22-cart-savings-drawer"
      //     let cart_subtotal_tag = "spooky22-cart-subtotal";
      //     let cart_subtotal_drawer_tag = "spooky22-cart-subtotal-drawer";
      //     let cartSavingsEl = document.getElementById(cart_savings_tag);
      //     let cartSavingsDrawerEl = document.getElementById(cart_savings_drawer_tag);
      //     let cartSubTotalEl = document.getElementById(cart_subtotal_tag);
      //     let cartSubTotalDrawerEl = document.getElementById(cart_subtotal_drawer_tag);

      //     if (totalSavings > 0) {
      //       var input = document.createElement("input");
      //       input.setAttribute("type", "hidden");
      //       input.setAttribute("name", "discount");
      //       input.setAttribute("value", discountCode);

      //       this.form.appendChild(input);
      //       this.subtotal.classList.add("hide")
      //       if (cartSavingsEl != null) {
      //         cartSavingsEl.classList.remove("hide");
      //         let savings_money_el = this.form.querySelector('[data-spooky22-savings]');
      //         let discount_tag_inner_el = this.form.querySelector('[data-spooky22-main-dc]');
      //         savings_money_el.innerHTML = theme.Currency.formatMoney(totalSavings, theme.settings.moneyFormat);
      //         discount_tag_inner_el.innerHTML = discountCode;
      //       }

      //       if (cartSavingsDrawerEl != null) {
      //         cartSavingsDrawerEl.classList.remove("hide");
      //         let savings_money_el = this.form.querySelector('[data-spooky22-savings]');
      //         let discount_tag_inner_el = this.form.querySelector('[data-spooky22-main-dc]');
      //         savings_money_el.innerHTML = theme.Currency.formatMoney(totalSavings, theme.settings.moneyFormat);
      //         discount_tag_inner_el.innerHTML = discountCode;
      //       }

      //       if (cartSubTotalEl != null) {
      //         let subtotal_money_el = this.form.querySelector('[data-spooky22-subtotal]');
      //         subtotal_money_el.innerHTML = theme.Currency.formatMoney(totalSpent - totalSavings, theme.settings.moneyFormat);
      //         this.subTotalBtn.innerHTML = theme.Currency.formatMoney(totalSpent - totalSavings, theme.settings.moneyFormat);
      //         // cartSubTotalEl.classList.remove("hide");
      //       }
            
      //       if (cartSubTotalDrawerEl != null) {
      //         let subtotal_money_el = this.form.querySelector('[data-spooky22-subtotal]');
      //         subtotal_money_el.innerHTML = theme.Currency.formatMoney(totalSpent - totalSavings, theme.settings.moneyFormat);
      //         cartSubTotalDrawerEl.classList.remove("hide");
      //       }
      //     } 
      //     else {
      //       var input = document.createElement("input");
      //       input.setAttribute("type", "hidden");
      //       input.setAttribute("name", "discount");
      //       input.setAttribute("value", "");

      //       this.subtotal.classList.remove("hide")
      //       if (cartSavingsEl != null) {
      //         cartSavingsEl.classList.add("hide");
      //       }

      //       if (cartSavingsDrawerEl != null) {
      //         cartSavingsDrawerEl.classList.add("hide");
      //       }

      //       if (cartSubTotalEl != null) {
      //         cartSubTotalEl.classList.add("hide");
      //       }
            
      //       if (cartSubTotalDrawerEl != null) {
      //         cartSubTotalDrawerEl.classList.add("hide");
      //       }
      //     }

      //     if (totalSavings > 0) {
      //       let el = this.form.querySelector('[data-aex-savings]');
      //       el.innerHTML = theme.Currency.formatMoney(totalSavings, theme.settings.moneyFormat);
      //     }
      //   }

      // },

// updateCartBOGOPromo: function(items, count, subtotal) {
//   var isActivePromo = false;
//   var discountCode = null;
//   var minimumProducts = null;

//   if (Cookies.get("BEB_PROMOTION")) {
//     var cookieValue = Cookies.get("BEB_PROMOTION");
//     var promotionData = offerUpdates[cookieValue] || null;
//     if (promotionData) {
//       discountCode = promotionData.discountCode;
//       isActivePromo = true;
//       minimumProducts = parseInt(promotionData.discountQty || 0);
//     }
//   }

//   let valid_item_count = 0;
//   let item_details = items.querySelectorAll('.cart__item');

//   const isExcludedItem = (title) => {
//     title = title.toLowerCase();
//     return (
//       title.includes("free $30 gift card") ||
//       title.includes("bundle") ||
//       title.includes("any 5") ||
//       title.includes("free mystery item") ||
//       title.includes("free mystery gift") ||
//       title.includes("free mystery earrings") ||
//       title.includes("box deal") ||
//       title.includes("gift packaging")
//     );
//   };

//   // COUNT ALL ELIGIBLE ITEMS
//   for (let i = 0; i < item_details.length; i++) {
//     let item_detail = item_details[i];
//     let title = item_detail.getAttribute('data-aex-title');
//     let isHidden = item_detail.classList.contains("cart__item_hidden");

//     if (!isExcludedItem(title) && !isHidden) {
//       valid_item_count += parseInt(item_detail.getAttribute('data-aex-qty'));
//     }
//   }

//   if (isActivePromo) {
//     let totalSavings = 0;
//     let totalSpent = 0;

//     try {
//       if (valid_item_count >= minimumProducts) {
//         // UPDATED: For "buy 1 get 2 free", calculate free items as floor(total/3) * 2
//         // This ensures for every 3 items, 2 are free (e.g., 3 items → 2 free, 6 items → 4 free)
//         let items_free_count = Math.floor(valid_item_count / 3) * 2;

//         let items_free_count222 = Math.floor(valid_item_count / 2);
//         console.log(items_free_count222,"items_free_count222")
//         console.log(items_free_count,"items_free_count")

        
//         let item_qtys_price = [];
//         let item_details = items.querySelectorAll('.cart__item');

//         // MAKE LIST OF ELIGIBLE ITEMS
//         for (let i = 0; i < item_details.length; i++) {
//           let item_detail = item_details[i];
//           let title = item_detail.getAttribute('data-aex-title');
//           let isHidden = item_detail.classList.contains("cart__item_hidden");

//           if (!isExcludedItem(title) && !isHidden) {
//             let qty = parseInt(item_detail.getAttribute('data-aex-qty'));
//             let price = parseFloat(item_detail.getAttribute('data-aex-price'));
//             let original_price = parseFloat(item_detail.getAttribute('data-aex-original-price'));

//             item_qtys_price.push({
//               qty: qty,
//               price: price,
//               original_price: original_price,
//               element: item_detail   // DOM reference for updates
//             });
//           } else if (!isHidden) {
//             let price = parseFloat(item_detail.getAttribute('data-aex-price'));
//             let qty = parseInt(item_detail.getAttribute('data-aex-qty'));
//             totalSpent += price * qty;
//           }
//         }

//         // SORT CHEAPEST FIRST (to apply free discount to cheapest items)
//         item_qtys_price.sort((a, b) => a.price - b.price);

//         // APPLY FREE ITEMS
//         for (let i = 0; i < item_qtys_price.length; i++) {
//           let c = item_qtys_price[i];
//           let item_detail = c.element;

//           let price_el = item_detail.querySelector('[data-aex-cart-price]');
//           let discount_price_el = item_detail.querySelector('[data-aex-cart-discount-price]');
//           let discount_tag_el = item_detail.querySelector('[data-spooky22-savings-item]');
//           let discount_tag_inner_el = item_detail.querySelector('[data-spooky22-dc]');

//           if (discount_price_el) {
//             discount_price_el.classList.remove("hide");
//             discount_price_el.classList.add("cart__price_sale-spooky22");
//           }
//           if (discount_tag_el) discount_tag_el.classList.remove("hide");
//           if (discount_tag_inner_el) discount_tag_inner_el.innerHTML = discountCode;

//           // FULL FREE ITEMS
//           if (items_free_count > 0) {
//             if (c.qty <= items_free_count) {
//               items_free_count -= c.qty;

//               if (price_el) {
//                 price_el.classList.add("cart__price--strikethrough", "cart__price_original-spooky22");
//                 price_el.innerHTML = theme.Currency.formatMoney(c.original_price * c.qty, theme.settings.moneyFormat);
//               }

//               if (discount_price_el) {
//                 discount_price_el.innerHTML = `<small class="cart__price-inline">${theme.Currency.formatMoney(0, theme.settings.moneyFormat)}</small>`;
//               }

//               totalSavings += c.original_price * c.qty;
//               totalSpent += c.original_price * c.qty;
//             } else {
//               // PARTIAL FREE (if qty > remaining free count)
//               let freeQty = items_free_count;
//               items_free_count = 0;

//               let originalSaving = c.original_price * freeQty;
//               let totalOriginal = c.original_price * c.qty;
//               let paidAmount = totalOriginal - originalSaving;

//               if (price_el) {
//                 price_el.classList.add("cart__price--strikethrough", "cart__price_original-spooky22");
//                 price_el.innerHTML = theme.Currency.formatMoney(totalOriginal, theme.settings.moneyFormat);
//               }

//               if (discount_price_el) {
//                 discount_price_el.innerHTML = `<small class="cart__price-inline">${theme.Currency.formatMoney(paidAmount, theme.settings.moneyFormat)}</small>`;
//               }

//               totalSavings += originalSaving;
//               totalSpent += totalOriginal;
//             }
//           } else {
//             // NO MORE FREE ITEMS - Apply any existing discount
//             let originalSaving = (c.original_price * c.qty) - (c.price * c.qty);
//             totalSavings += originalSaving;
//             totalSpent += (c.original_price * c.qty);
//           }
//         }
//       }
//     } catch (err) {
//       console.log(err);
//     }

//     // UPDATE CART UI
//     let cartSavingsEl = document.getElementById("spooky22-cart-savings");
//     let cartSavingsDrawerEl = document.getElementById("spooky22-cart-savings-drawer");
//     let cartSubTotalEl = document.getElementById("spooky22-cart-subtotal");
//     let cartSubTotalDrawerEl = document.getElementById("spooky22-cart-subtotal-drawer");

//     if (totalSavings > 0) {
//       var input = document.createElement("input");
//       input.type = "hidden";
//       input.name = "discount";
//       input.value = discountCode;
//       this.form.appendChild(input);

//       this.subtotal.classList.add("hide");

//       if (cartSavingsEl) {
//         cartSavingsEl.classList.remove("hide");
//         this.form.querySelector('[data-spooky22-savings]').innerHTML =
//           theme.Currency.formatMoney(totalSavings, theme.settings.moneyFormat);
//         this.form.querySelector('[data-spooky22-main-dc]').innerHTML = discountCode;
//       }

//       if (cartSubTotalEl) {
//         let finalAmount = totalSpent - totalSavings;
//         this.form.querySelector('[data-spooky22-subtotal]').innerHTML =
//           theme.Currency.formatMoney(finalAmount, theme.settings.moneyFormat);
//         this.subTotalBtn.innerHTML =
//           theme.Currency.formatMoney(finalAmount, theme.settings.moneyFormat);
//       }

//       if (cartSubTotalDrawerEl) {
//         let finalAmount = totalSpent - totalSavings;
//         this.form.querySelector('[data-spooky22-subtotal]').innerHTML =
//           theme.Currency.formatMoney(finalAmount, theme.settings.moneyFormat);
//         cartSubTotalDrawerEl.classList.remove("hide");
//       }
//     } else {
//       this.subtotal.classList.remove("hide");
//       if (cartSavingsEl) cartSavingsEl.classList.add("hide");
//       if (cartSavingsDrawerEl) cartSavingsDrawerEl.classList.add("hide");
//       if (cartSubTotalEl) cartSubTotalEl.classList.add("hide");
//       if (cartSubTotalDrawerEl) cartSubTotalDrawerEl.classList.add("hide");
//     }
//   }
// },



// updateCartBOGOPromo: function(items, count, subtotal) {
//   var isActivePromo = false;
//   var discountCode = null;
//   var minimumProducts = null;

//   if (Cookies.get("BEB_PROMOTION")) {
//     var cookieValue = Cookies.get("BEB_PROMOTION");
//     var promotionData = offerUpdates[cookieValue] || null;
//     if (promotionData) {
//       discountCode = promotionData.discountCode;
//       isActivePromo = true;
//       minimumProducts = parseInt(promotionData.discountQty || 0);
//     }
//   }

//   let valid_item_count = 0;
//   let item_details = items.querySelectorAll('.cart__item');

//   const isExcludedItem = (title) => {
//     title = title.toLowerCase();
//     return (
//       title.includes("free $30 gift card") ||
//       title.includes("bundle") ||
//       title.includes("any 5") ||
//       title.includes("free mystery item") ||
//       title.includes("free mystery gift") ||
//       title.includes("free mystery earrings") ||
//       title.includes("box deal") ||
//       title.includes("gift packaging")
//     );
//   };

//   // COUNT ALL ELIGIBLE ITEMS
//   for (let i = 0; i < item_details.length; i++) {
//     let item_detail = item_details[i];
//     let title = item_detail.getAttribute('data-aex-title');
//     let isHidden = item_detail.classList.contains("cart__item_hidden");

//     if (!isExcludedItem(title) && !isHidden) {
//       valid_item_count += parseInt(item_detail.getAttribute('data-aex-qty'));
//     }
//   }

//   if (isActivePromo) {
//     let totalSavings = 0;
//     let totalSpent = 0;

//     try {
//       if (valid_item_count >= minimumProducts) {
//         let items_free_count = Math.floor(valid_item_count / 3) * 2;

//         let item_qtys_price = [];
//         let item_details = items.querySelectorAll('.cart__item');

//         // MAKE LIST OF ELIGIBLE ITEMS
//         for (let i = 0; i < item_details.length; i++) {
//           let item_detail = item_details[i];
//           let title = item_detail.getAttribute('data-aex-title');
//           let isHidden = item_detail.classList.contains("cart__item_hidden");

//           if (!isExcludedItem(title) && !isHidden) {
//             let qty = parseInt(item_detail.getAttribute('data-aex-qty'));
//             let price = parseFloat(item_detail.getAttribute('data-aex-price'));
//             let original_price = parseFloat(item_detail.getAttribute('data-aex-original-price'));

//             item_qtys_price.push({
//               qty: qty,
//               price: price,
//               original_price: original_price,
//               element: item_detail
//             });
//           } else if (!isHidden) {
//             let price = parseFloat(item_detail.getAttribute('data-aex-price'));
//             let qty = parseInt(item_detail.getAttribute('data-aex-qty'));
//             totalSpent += price * qty;
//           }
//         }

//         // SORT CHEAPEST FIRST
//         item_qtys_price.sort((a, b) => a.price - b.price);

//         // APPLY FREE ITEMS
//         for (let i = 0; i < item_qtys_price.length; i++) {
//           let c = item_qtys_price[i];
//           let item_detail = c.element;

//           let price_el = item_detail.querySelector('[data-aex-cart-price]');
//           let discount_price_el = item_detail.querySelector('[data-aex-cart-discount-price]');
//           let discount_tag_el = item_detail.querySelector('[data-spooky22-savings-item]');
//           let discount_tag_inner_el = item_detail.querySelector('[data-spooky22-dc]');

//           if (discount_price_el) {
//             discount_price_el.classList.remove("hide");
//             discount_price_el.classList.add("cart__price_sale-spooky22");
//           }
//           if (discount_tag_el) discount_tag_el.classList.remove("hide");
//           if (discount_tag_inner_el) discount_tag_inner_el.innerHTML = discountCode;

//           if (items_free_count > 0) {
//             if (c.qty <= items_free_count) {
//               items_free_count -= c.qty;

//               // *** UPDATED DISPLAY: STRIKE ORIGINAL + SHOW $0.00 ***
//               if (price_el && discount_price_el) {
//                 price_el.classList.add("cart__price--strikethrough", "cart__price_original-spooky22");
//                 price_el.innerHTML = theme.Currency.formatMoney(c.original_price, theme.settings.moneyFormat);

//                 discount_price_el.innerHTML =
//                   `<small class="cart__price-inline">${theme.Currency.formatMoney(0, theme.settings.moneyFormat)}</small>`;
//               }

//               totalSavings += c.original_price * c.qty;
//               totalSpent += c.original_price * c.qty;

//             } else {
//               let freeQty = items_free_count;
//               items_free_count = 0;

//               let originalSaving = c.original_price * freeQty;
//               let totalOriginal = c.original_price * c.qty;
//               let paidAmount = totalOriginal - originalSaving;

//               if (price_el) {
//                 price_el.classList.add("cart__price--strikethrough", "cart__price_original-spooky22");
//                 price_el.innerHTML = theme.Currency.formatMoney(totalOriginal, theme.settings.moneyFormat);
//               }

//               if (discount_price_el) {
//                 discount_price_el.innerHTML =
//                   `<small class="cart__price-inline">${theme.Currency.formatMoney(paidAmount, theme.settings.moneyFormat)}</small>`;
//               }

//               totalSavings += originalSaving;
//               totalSpent += totalOriginal;
//             }
//           } else {
//             let originalSaving = (c.original_price * c.qty) - (c.price * c.qty);
//             totalSavings += originalSaving;
//             totalSpent += (c.original_price * c.qty);
//           }
//         }
//       }
//     } catch (err) {
//       console.log(err);
//     }

//     // UPDATE CART UI
//     let cartSavingsEl = document.getElementById("spooky22-cart-savings");
//     let cartSavingsDrawerEl = document.getElementById("spooky22-cart-savings-drawer");
//     let cartSubTotalEl = document.getElementById("spooky22-cart-subtotal");
//     let cartSubTotalDrawerEl = document.getElementById("spooky22-cart-subtotal-drawer");

//     if (totalSavings > 0) {

//       // PREVENT DUPLICATE DISCOUNT INPUT
//       if (!this.form.querySelector('input[name="discount"]')) {
//         var input = document.createElement("input");
//         input.type = "hidden";
//         input.name = "discount";
//         input.value = discountCode;
//         this.form.appendChild(input);
//       }

//       this.subtotal.classList.add("hide");

//       if (cartSavingsEl) {
//         cartSavingsEl.classList.remove("hide");
//         this.form.querySelector('[data-spooky22-savings]').innerHTML =
//           theme.Currency.formatMoney(totalSavings, theme.settings.moneyFormat);
//         this.form.querySelector('[data-spooky22-main-dc]').innerHTML = discountCode;
//       }

//       if (cartSubTotalEl) {
//         let finalAmount = totalSpent - totalSavings;
//         this.form.querySelector('[data-spooky22-subtotal]').innerHTML =
//           theme.Currency.formatMoney(finalAmount, theme.settings.moneyFormat);
//         this.subTotalBtn.innerHTML =
//           theme.Currency.formatMoney(finalAmount, theme.settings.moneyFormat);
//       }

//       if (cartSubTotalDrawerEl) {
//         let finalAmount = totalSpent - totalSavings;
//         this.form.querySelector('[data-spooky22-subtotal]').innerHTML =
//           theme.Currency.formatMoney(finalAmount, theme.settings.moneyFormat);
//         cartSubTotalDrawerEl.classList.remove("hide");
//       }
//     } else {
//       this.subtotal.classList.remove("hide");
//       if (cartSavingsEl) cartSavingsEl.classList.add("hide");
//       if (cartSavingsDrawerEl) cartSavingsDrawerEl.classList.add("hide");
//       if (cartSubTotalEl) cartSubTotalEl.classList.add("hide");
//       if (cartSubTotalDrawerEl) cartSubTotalDrawerEl.classList.add("hide");
//     }
//     if (totalSavings > 0) {
//       let el = this.form.querySelector('[data-aex-savings]');
//       el.innerHTML = theme.Currency.formatMoney(totalSavings, theme.settings.moneyFormat);
//     }
//   }
// },



updateCartBOGOPromo: function(items, count, subtotal) {
  var isActivePromo = false;
  var discountCode = null;
  var minimumProducts = null;

  if (Cookies.get("BEB_PROMOTION")) {
    var cookieValue = Cookies.get("BEB_PROMOTION");
    var promotionData = offerUpdates[cookieValue] || null;
    if (promotionData) {
      discountCode = promotionData.discountCode;
      isActivePromo = true;
      minimumProducts = parseInt(promotionData.discountQty || 0);
    }
  }

  let valid_item_count = 0;
  let item_details = items.querySelectorAll('.cart__item');

  const isExcludedItem = (title) => {
    title = title.toLowerCase();
    return (
      title.includes("free $30 gift card") ||
      title.includes("bundle") ||
      title.includes("any 5") ||
      title.includes("free mystery item") ||
      title.includes("free mystery gift") ||
      title.includes("free mystery earrings") ||
      title.includes("box deal") ||
      title.includes("free") ||
      title.includes("mystery") ||
      title.includes("gift packaging")
    );
  };

  // COUNT ALL ELIGIBLE ITEMS
  for (let i = 0; i < item_details.length; i++) {
    let item_detail = item_details[i];
    let title = item_detail.getAttribute('data-aex-title');
    let isHidden = item_detail.classList.contains("cart__item_hidden") || item_detail.hasAttribute("data-free-gift") || item_detail.querySelector(".image_bundle li") !== null;


    if (!isExcludedItem(title) && !isHidden) {
      valid_item_count += parseInt(item_detail.getAttribute('data-aex-qty'));
    }
  }

  if (isActivePromo) {
    let totalSavings = 0;
    let totalSpent = 0;

    try {
      if (valid_item_count >= minimumProducts) {
        let items_free_count = Math.floor(valid_item_count / 3) * 2;

        console.log("items_free_count---", items_free_count);
        
        let item_qtys_price = [];
        let item_details = items.querySelectorAll('.cart__item');

        // MAKE LIST OF ELIGIBLE ITEMS
        for (let i = 0; i < item_details.length; i++) {
          let item_detail = item_details[i];
          let title = item_detail.getAttribute('data-aex-title');
          let isHidden = item_detail.classList.contains("cart__item_hidden") || item_detail.hasAttribute("data-free-gift");

          if (!isExcludedItem(title) && !isHidden) {
            let qty = parseInt(item_detail.getAttribute('data-aex-qty'));
            let price = parseFloat(item_detail.getAttribute('data-aex-price'));
            let original_price = parseFloat(item_detail.getAttribute('data-aex-original-price'));

            item_qtys_price.push({
              qty: qty,
              price: price,
              original_price: original_price,
              element: item_detail
            });
          } else if (!isHidden) {
            let price = parseFloat(item_detail.getAttribute('data-aex-price'));
            let qty = parseInt(item_detail.getAttribute('data-aex-qty'));
            totalSpent += price * qty;
          }
        }

        // SORT CHEAPEST FIRST
        item_qtys_price.sort((a, b) => a.price - b.price);

        // APPLY FREE ITEMS
        for (let i = 0; i < item_qtys_price.length; i++) {
          let c = item_qtys_price[i];
          let item_detail = c.element;

          let price_el = item_detail.querySelector('[data-aex-cart-price]');
          let discount_price_el = item_detail.querySelector('[data-aex-cart-discount-price]');
          let discount_tag_el = item_detail.querySelector('[data-spooky22-savings-item]');
          let discount_tag_inner_el = item_detail.querySelector('[data-spooky22-dc]');


          if (discount_price_el) {
            discount_price_el.classList.remove("hide");
            discount_price_el.classList.add("cart__price_sale-spooky22");
          }
          if (discount_tag_el) discount_tag_el.classList.remove("hide");
          if (discount_tag_inner_el) discount_tag_inner_el.innerHTML = discountCode;

          
          if (items_free_count > 0) {
            if (c.qty <= items_free_count) {
              items_free_count -= c.qty;

              if (price_el) {
                price_el.classList.add("cart__price--strikethrough", "cart__price_original-spooky22");
                price_el.innerHTML = theme.Currency.formatMoney(c.original_price * c.qty, theme.settings.moneyFormat);
              }

              if (discount_price_el) {
                discount_price_el.innerHTML = `<small class="cart__price-inline">${theme.Currency.formatMoney(0, theme.settings.moneyFormat)}</small>`;
                // discount_price_el.innerHTML = `<small class="cart__price-inline">${theme.Currency.formatMoney(0, theme.settings.moneyFormat)}</small> <span class="cart__price--strikethrough ">${theme.Currency.formatMoney(c.original_price * c.qty, theme.settings.moneyFormat)}</span>`;
              }

              totalSavings += c.original_price * c.qty;
              totalSpent += c.original_price * c.qty;
            } else {
              let freeQty = items_free_count;
              items_free_count = 0;

              let originalSaving = c.original_price * freeQty;
              let totalOriginal = c.original_price * c.qty;
              let paidAmount = totalOriginal - originalSaving;
              

              if (price_el) {
                price_el.classList.add("cart__price--strikethrough", "cart__price_original-spooky22");
                price_el.innerHTML = theme.Currency.formatMoney(totalOriginal, theme.settings.moneyFormat);
              }

              if (discount_price_el) {
                discount_price_el.innerHTML = `<small class="cart__price-inline">${theme.Currency.formatMoney(paidAmount, theme.settings.moneyFormat)}</small>`;
                // discount_price_el.innerHTML = `<small class="cart__price-inline">${theme.Currency.formatMoney(0, theme.settings.moneyFormat)}</small> <span class="cart__price--strikethrough">${theme.Currency.formatMoney(c.original_price * c.qty, theme.settings.moneyFormat)}</span>`;

              }
              totalSavings += originalSaving;
              totalSpent += totalOriginal;
            }
          } else {
            let originalSaving = (c.original_price * c.qty) - (c.price * c.qty);
            totalSavings += originalSaving;
            totalSpent += (c.original_price * c.qty);
          }
          
        }

        this.subTotalBtn.innerHTML = theme.Currency.formatMoney(totalSpent - totalSavings, theme.settings.moneyFormat);
      }
    } catch (err) {
      console.log(err);
    }

    // UPDATE CART UI
    let cartSavingsEl = document.getElementById("spooky22-cart-savings");
    let cartSavingsDrawerEl = document.getElementById("spooky22-cart-savings-drawer");
    let cartSubTotalEl = document.getElementById("spooky22-cart-subtotal");
    let cartSubTotalDrawerEl = document.getElementById("spooky22-cart-subtotal-drawer");

    
    if (totalSavings > 0) {
      
      // *** NEW CHECK TO PREVENT DUPLICATE DISCOUNT INPUT ***
      if (!this.form.querySelector('input[name="discount"]')) {
        var input = document.createElement("input");
        input.type = "hidden";
        input.name = "discount";
        input.value = discountCode;
        this.form.appendChild(input);
      } else {
        let form_tag = this.form.querySelector('input[name="discount"]');
        if(form_tag) {
          form_tag.type = "hidden";
          form_tag.name = "discount";
          form_tag.value = discountCode;
        }
      }

      this.subtotal.classList.add("hide");

      if (cartSavingsEl) {
        cartSavingsEl.classList.remove("hide");
        this.form.querySelector('[data-spooky22-savings]').innerHTML =
          theme.Currency.formatMoney(totalSavings, theme.settings.moneyFormat);
        this.form.querySelector('[data-spooky22-main-dc]').innerHTML = discountCode;
      }

      if (cartSubTotalEl) {
        let finalAmount = totalSpent - totalSavings;
        this.form.querySelector('[data-spooky22-subtotal]').innerHTML =
          theme.Currency.formatMoney(finalAmount, theme.settings.moneyFormat);
        this.subTotalBtn.innerHTML =
          theme.Currency.formatMoney(finalAmount, theme.settings.moneyFormat);
      }

      if (cartSubTotalDrawerEl) {
        let finalAmount = totalSpent - totalSavings;
        this.form.querySelector('[data-spooky22-subtotal]').innerHTML =
          theme.Currency.formatMoney(finalAmount, theme.settings.moneyFormat);
        cartSubTotalDrawerEl.classList.remove("hide");
      }
    } else {
      this.subtotal.classList.remove("hide");
      if (cartSavingsEl) cartSavingsEl.classList.add("hide");
      if (cartSavingsDrawerEl) cartSavingsDrawerEl.classList.add("hide");
      if (cartSubTotalEl) cartSubTotalEl.classList.add("hide");
      if (cartSubTotalDrawerEl) cartSubTotalDrawerEl.classList.add("hide");
    }
    if (totalSavings > 0) {
      let el = this.form.querySelector('[data-aex-savings]');
      el.innerHTML = theme.Currency.formatMoney(totalSavings, theme.settings.moneyFormat);
    }
  }
},





      updateCart70PercentOffPromo: function(items, count, subtotal) {
        var isActivePromo = false;
        var discountCode = "TAKE70";
        var minimumProducts = 5;
        
        var valid_item_count = 0;
        let item_details = items.querySelectorAll('.cart__item');
        let discountInput = document.querySelector('#CartDrawerForm input[name="discount"]');

        if (Cookies.get("collection_visited")) {
            isActivePromo = true;
        }

        for(let i=0; i < item_details.length; i++) {
          let item_detail = item_details[i];
          let item_title = item_detail.getAttribute('data-aex-title');
          let item_variantid = item_detail.getAttribute('data-variant-id');
          let matchFound = false;
          const productButtons = document.querySelectorAll('.choose_popup_product_column .choose_select_product_btn');
          if (productButtons) {
            productButtons.forEach(button => {
                const productId = button.getAttribute('data-productid');
                if (productId === item_variantid) {
                    matchFound = true;
                }
            }); 
          }
          let isHidden = item_detail.classList.contains("cart__item_hidden");
          if (!(matchFound || item_title.toLowerCase().includes("free $30 gift card") || item_title.toLowerCase().includes("bundle") || item_title.toLowerCase().includes("any 5") || item_title.toLowerCase().includes("free mystery item") || item_title.toLowerCase().includes("free mystery gift") || item_title.toLowerCase().includes("free mystery earrings") || item_title.toLowerCase().includes("box deal") || item_title.toLowerCase().includes("gift packaging")) && !isHidden ) {           
            let item_qty = item_detail.getAttribute('data-aex-qty');
            valid_item_count += parseInt(item_qty);
          }
        }
        if (valid_item_count >= minimumProducts) {
          let totalSavings = 0;
          let totalSpent = 0;
            if (isActivePromo) {
              for (let i = 0; i < item_details.length; i++) {
                    let item_detail = item_details[i];
                    let item_qty = parseInt(item_detail.getAttribute('data-aex-qty'));
                    let original_price = parseFloat(item_detail.getAttribute('data-product-price'));
                    let original_price_compare = parseFloat(item_detail.getAttribute('data-compare-price'));
                    let price_el = item_detail.querySelector('[data-aex-cart-price]');
                    let discount_price_el = item_detail.querySelector('[data-aex-cart-discount-price]');
        
                    let discountedPrice = original_price * (1 - 0.7);
                 
                    let totalItemPrice = original_price_compare * item_qty;
                    let totalDiscountedPrice = discountedPrice * item_qty;
                    totalSpent += totalItemPrice;

                
                    if (price_el) {
                        price_el.classList.add("cart__price--strikethrough");
                        price_el.innerHTML = `${theme.Currency.formatMoney(totalItemPrice, theme.settings.moneyFormat)}`;
                    }
        
                    if (totalItemPrice !== totalDiscountedPrice){
                      if(discount_price_el != null ){
                        discount_price_el.classList.remove("hide");
                        discount_price_el.innerHTML = `<small class="cart__price-inline">${theme.Currency.formatMoney(totalDiscountedPrice, theme.settings.moneyFormat)}</small> `;
                      }
                    } else {
                      if (price_el) {
                        price_el.innerHTML = '';
                      }
                    }
        
                    totalSavings += (totalItemPrice - totalDiscountedPrice);
                }
  
              let cart_savings_tag = "spooky22-cart-savings"
              let cart_savings_drawer_tag = "spooky22-cart-savings-drawer"
              let cart_subtotal_tag = "spooky22-cart-subtotal";
              let cart_subtotal_drawer_tag = "spooky22-cart-subtotal-drawer";
              let cartSavingsEl = document.getElementById(cart_savings_tag);
              let cartSavingsDrawerEl = document.getElementById(cart_savings_drawer_tag);
              let cartSubTotalEl = document.getElementById(cart_subtotal_tag);
              let cartSubTotalDrawerEl = document.getElementById(cart_subtotal_drawer_tag);
               if (totalSavings > 0) {
                   if (!discountInput) {
                      discountInput = document.createElement("input");
                      discountInput.setAttribute("type", "hidden");
                      discountInput.setAttribute("name", "discount");
                      discountInput.setAttribute("value", discountCode);
                      this.form.appendChild(discountInput);
                  } else {
                      discountInput.value = discountCode;
                  }
                 
                  this.subtotal.classList.add("hide")
                  if (cartSavingsEl != null) {
                    cartSavingsEl.classList.remove("hide");
                    let savings_money_el = this.form.querySelector('[data-spooky22-savings]');
                    let discount_tag_inner_el = this.form.querySelector('[data-spooky22-main-dc]');
                    savings_money_el.innerHTML = theme.Currency.formatMoney(totalSavings, theme.settings.moneyFormat);
                    discount_tag_inner_el.innerHTML = discountCode;
                  }
      
                  if (cartSavingsDrawerEl != null) {
                    cartSavingsDrawerEl.classList.remove("hide");
                    let savings_money_el = this.form.querySelector('[data-spooky22-savings]');
                    let discount_tag_inner_el = this.form.querySelector('[data-spooky22-main-dc]');
                    savings_money_el.innerHTML = theme.Currency.formatMoney(totalSavings, theme.settings.moneyFormat);
                    discount_tag_inner_el.innerHTML = discountCode;
                  }
      
                  if (cartSubTotalEl != null) {
                    let subtotal_money_el = this.form.querySelector('[data-spooky22-subtotal]');
                    subtotal_money_el.innerHTML = theme.Currency.formatMoney(totalSpent - totalSavings, theme.settings.moneyFormat);
                    this.subTotalBtn.innerHTML = theme.Currency.formatMoney(totalSpent - totalSavings, theme.settings.moneyFormat);
                    // cartSubTotalEl.classList.remove("hide");
                  }
                  
                  if (cartSubTotalDrawerEl != null) {
                    let subtotal_money_el = this.form.querySelector('[data-spooky22-subtotal]');
                    subtotal_money_el.innerHTML = theme.Currency.formatMoney(totalSpent - totalSavings, theme.settings.moneyFormat);
                    cartSubTotalDrawerEl.classList.remove("hide");
                  }
                } 
                else {
                  if (discountInput) {
                      discountInput.remove();
                  }
                  this.subtotal.classList.remove("hide");
                  
                  if (cartSavingsEl != null) {
                    cartSavingsEl.classList.add("hide");
                  }
      
                  if (cartSavingsDrawerEl != null) {
                    cartSavingsDrawerEl.classList.add("hide");
                  }
      
                  if (cartSubTotalEl != null) {
                    cartSubTotalEl.classList.add("hide");
                  }
                  
                  if (cartSubTotalDrawerEl != null) {
                    cartSubTotalDrawerEl.classList.add("hide");
                  }
                }
      
                if (totalSavings > 0) {
                  let el = this.form.querySelector('[data-aex-savings]');
                  el.innerHTML = theme.Currency.formatMoney(totalSavings, theme.settings.moneyFormat);
                }
            } 
        }
      },

      updateCart50PercentOffPromo: function(items, count, subtotal) {
        var isActivePromo = false;
        var discountCode = null;
        var minimumProducts = 0;
        
        var valid_item_count = 0;
        let item_details = items.querySelectorAll('.cart__item');
        let discountInput = document.querySelector('#CartDrawerForm input[name="discount"]');

        if (Cookies.get("BEB_PROMOTION")) {
            var promotionData = offerUpdates['Any5SummerOffer'] || null;
            if (promotionData) {
                discountCode = promotionData.discountCode; 
                isActivePromo = true;
                minimumProducts = parseInt(promotionData.discountQty || 0);
            }
        }

        for(let i=0; i < item_details.length; i++) {
          let item_detail = item_details[i];
          let item_title = item_detail.getAttribute('data-aex-title');
          let item_variantid = item_detail.getAttribute('data-variant-id');
          let matchFound = false;
          const productButtons = document.querySelectorAll('.choose_popup_product_column .choose_select_product_btn');
          if (productButtons) {
            productButtons.forEach(button => {
                const productId = button.getAttribute('data-productid');
                if (productId === item_variantid) {
                    matchFound = true;
                }
            }); 
          }
          let isHidden = item_detail.classList.contains("cart__item_hidden");
          if (!(matchFound || item_title.toLowerCase().includes("free $30 gift card") || item_title.toLowerCase().includes("bundle") || item_title.toLowerCase().includes("any 5") || item_title.toLowerCase().includes("free mystery item") || item_title.toLowerCase().includes("free mystery gift") || item_title.toLowerCase().includes("free mystery earrings") || item_title.toLowerCase().includes("box deal") || item_title.toLowerCase().includes("gift packaging") || item_title.toLowerCase().includes("build your own spring box")) && !isHidden ) {           
            let item_qty = item_detail.getAttribute('data-aex-qty');
            valid_item_count += parseInt(item_qty);
          }
        }
        if (valid_item_count >= minimumProducts) {
          let totalSavings = 0;
          let totalSpent = 0;
            if (isActivePromo) {
              for (let i = 0; i < item_details.length; i++) {
                    let item_detail = item_details[i];
                    let item_title = item_detail.getAttribute('data-aex-title') || '';
                      let item_variantid = item_detail.getAttribute('data-variant-id');
                      let matchFound = false;
                      const productButtons = document.querySelectorAll('.choose_popup_product_column .choose_select_product_btn');
                      if (productButtons) {
                          productButtons.forEach(button => {
                              const productId = button.getAttribute('data-productid');
                              if (productId === item_variantid) {
                                  matchFound = true;
                              }
                          });
                      }
                    let isHidden = item_detail.classList.contains("cart__item_hidden");

                    let isExcluded =
                        matchFound ||
                        item_title.toLowerCase().includes("free $30 gift card") ||
                        item_title.toLowerCase().includes("bundle") ||
                        item_title.toLowerCase().includes("any 5") ||
                        item_title.toLowerCase().includes("free mystery item") ||
                        item_title.toLowerCase().includes("free mystery gift") ||
                        item_title.toLowerCase().includes("free mystery earrings") ||
                        item_title.toLowerCase().includes("box deal") ||
                        item_title.toLowerCase().includes("gift packaging") ||
                        item_title.toLowerCase().includes("build your own spring box") ||
                        isHidden;

                    let item_qty = parseInt(item_detail.getAttribute('data-aex-qty'));
                    let original_price = parseFloat(item_detail.getAttribute('data-product-price'));
                    let original_price_compare = parseFloat(item_detail.getAttribute('data-compare-price'));
                    let price_el = item_detail.querySelector('[data-aex-cart-price]');
                    let discount_price_el = item_detail.querySelector('[data-aex-cart-discount-price]');
        
                    // console.log("original_price_compare------", original_price_compare, item_detail);
                    let totalItemPrice = original_price_compare * item_qty;
                    let actualItemPrice = original_price * item_qty;

                    if (!item_detail.hasAttribute("data-free-gift")) {
                      if (isExcluded) {
                        totalSpent += actualItemPrice; // use real price for excluded items
                      } else {
                        totalSpent += totalItemPrice; // use compare price for discounted items
                      }
                    }

                    if (isExcluded) {
                        continue;
                    }


                    let discountedPrice = original_price * 0.5;              
                    let totalDiscountedPrice = discountedPrice * item_qty;

                    
                    if (price_el) {
                        price_el.classList.add("cart__price--strikethrough");
                        price_el.innerHTML = `${theme.Currency.formatMoney(totalItemPrice, theme.settings.moneyFormat)}`;
                    }    
                    
                    if (totalItemPrice !== totalDiscountedPrice){
                      if(discount_price_el != null ){
                        discount_price_el.classList.remove("hide");
                        discount_price_el.innerHTML = `<small class="cart__price-inline">${theme.Currency.formatMoney(totalDiscountedPrice, theme.settings.moneyFormat)}</small> `;
                      }
                    } else {
                      if (price_el) {
                        price_el.innerHTML = '';
                      }
                    }
        
                    totalSavings += (totalItemPrice - totalDiscountedPrice);
                }
  
              let cart_savings_tag = "spooky22-cart-savings"
              let cart_savings_drawer_tag = "spooky22-cart-savings-drawer"
              let cart_subtotal_tag = "spooky22-cart-subtotal";
              let cart_subtotal_drawer_tag = "spooky22-cart-subtotal-drawer";
              let cartSavingsEl = document.getElementById(cart_savings_tag);
              let cartSavingsDrawerEl = document.getElementById(cart_savings_drawer_tag);
              let cartSubTotalEl = document.getElementById(cart_subtotal_tag);
              let cartSubTotalDrawerEl = document.getElementById(cart_subtotal_drawer_tag);
               if (totalSavings > 0) {
                   if (!discountInput) {
                      discountInput = document.createElement("input");
                      discountInput.setAttribute("type", "hidden");
                      discountInput.setAttribute("name", "discount");
                      discountInput.setAttribute("value", discountCode);
                      this.form.appendChild(discountInput);
                  } else {
                      discountInput.value = discountCode;
                  }
                 
                  this.subtotal.classList.add("hide")
                  if (cartSavingsEl != null) {
                    cartSavingsEl.classList.remove("hide");
                    let savings_money_el = this.form.querySelector('[data-spooky22-savings]');
                    let discount_tag_inner_el = this.form.querySelector('[data-spooky22-main-dc]');
                    savings_money_el.innerHTML = theme.Currency.formatMoney(totalSavings, theme.settings.moneyFormat);
                    discount_tag_inner_el.innerHTML = discountCode;
                  }
      
                  if (cartSavingsDrawerEl != null) {
                    cartSavingsDrawerEl.classList.remove("hide");
                    let savings_money_el = this.form.querySelector('[data-spooky22-savings]');
                    let discount_tag_inner_el = this.form.querySelector('[data-spooky22-main-dc]');
                    savings_money_el.innerHTML = theme.Currency.formatMoney(totalSavings, theme.settings.moneyFormat);
                    discount_tag_inner_el.innerHTML = discountCode;
                  }
      
                  if (cartSubTotalEl != null) {
                    let subtotal_money_el = this.form.querySelector('[data-spooky22-subtotal]');
                    subtotal_money_el.innerHTML = theme.Currency.formatMoney(totalSpent - totalSavings, theme.settings.moneyFormat);
                    this.subTotalBtn.innerHTML = theme.Currency.formatMoney(totalSpent - totalSavings, theme.settings.moneyFormat);
                    // cartSubTotalEl.classList.remove("hide");
                  }
                  
                  if (cartSubTotalDrawerEl != null) {
                    let subtotal_money_el = this.form.querySelector('[data-spooky22-subtotal]');
                    subtotal_money_el.innerHTML = theme.Currency.formatMoney(totalSpent - totalSavings, theme.settings.moneyFormat);
                    cartSubTotalDrawerEl.classList.remove("hide");
                  }
                } 
                else {
                  if (discountInput) {
                      discountInput.remove();
                  }
                  this.subtotal.classList.remove("hide");
                  
                  if (cartSavingsEl != null) {
                    cartSavingsEl.classList.add("hide");
                  }
      
                  if (cartSavingsDrawerEl != null) {
                    cartSavingsDrawerEl.classList.add("hide");
                  }
      
                  if (cartSubTotalEl != null) {
                    cartSubTotalEl.classList.add("hide");
                  }
                  
                  if (cartSubTotalDrawerEl != null) {
                    cartSubTotalDrawerEl.classList.add("hide");
                  }
                }
      
                if (totalSavings > 0) {
                  let el = this.form.querySelector('[data-aex-savings]');
                  el.innerHTML = theme.Currency.formatMoney(totalSavings, theme.settings.moneyFormat);
                }
            } 
        }
      },
  
      updateCartDiscounts: function(markup) {
        if (!this.discounts) {
          return;
        }
        this.discounts.innerHTML = '';
        this.discounts.append(markup);
      },
  
      /*============================================================================
        Quantity handling
      ==============================================================================*/
      initQtySelectors: function() {
        this.form.querySelectorAll(selectors.qtySelector).forEach(el => {
          var selector = new theme.QtySelector(el, {
            namespace: this.namespace,
            isCart: true
          });
        });

        this.form.querySelectorAll(selectors.qtyRemoveSelector).forEach(el => {
          var selector = new theme.QtyRemoveSelector(el, {
            namespace: this.namespace,
            isCart: true
          });
        });
      },

      addGiftWrappingCallback: function() {
        let el = document.getElementById('gift-wrapping-checkout-selection')
        if (el != null) {
          theme.cart.addGiftWrappingToCart()
          .then(function(cart) {
            this.buildCart();
            el.classList.add("hide");
          }.bind(this));
        }
      },
  
      quantityChanged: function(evt) {
        var key = evt.detail[0];
        var qty = evt.detail[1];
        var oldQty = evt.detail[3];
        var el = evt.detail[2];

        if (!key || !qty || !oldQty) {
          return;
        }

        // Disable qty selector so multiple clicks can't happen while loading
        if (el) {
          el.classList.add('is-loading');
        }

        theme.cart.getCart().then(function (cart) {

          var bundle_uid = "";
          const cartItemsUpdated = {
            [key]:qty
          }

          for (const item of cart.items) {
            if (item.key == key) {
              bundle_uid = item.properties["_bundle_uid"];
              break;
            }
          }

          for (const item of cart.items) {
            if (item.properties["_bundle_uid"] && item.properties["_bundle_uid"] == bundle_uid && item.properties["type"] && item.properties["type"] == 'gift-box-item') {
              cartItemsUpdated[item.key] = (item.quantity/oldQty) * qty

            }
          }

          return cartItemsUpdated
        }).then(function (cartItemsUpdated){
          return theme.cart.updateItems(cartItemsUpdated)
        }).then(function (cart){
          if (cart.item_count > 0) {
              this.wrapper.classList.remove('is-empty');
            } else {
              this.wrapper.classList.add('is-empty');
            }

            this.buildCart();
  
            document.dispatchEvent(new CustomEvent('cart:updated', {
              detail: {
                cart: cart
              }
            }));
         
           let mirrorTotalc = document.querySelector('#CartPageForm .cart-subtotal');
            if (mirrorTotalc) {
              let TotalCartc = cart.total_price;
              let CartUpdate = new CustomEvent("CartUpdate", { detail: TotalCartc });
              window.dispatchEvent(CartUpdate);
              var items = document.querySelector('.cart__page .cart__page-col');
              var giftInCartAb = false;
              let itemdetails = items.querySelectorAll('.cart__item');
             
               for(let i=0; i < itemdetails.length; i++) {
                 let itemdetail = itemdetails[i];
                 if (itemdetail.classList.contains('cart__item_unlock_gift')) {
                   let itemid = itemdetail.getAttribute('data-variant-id');
                   giftInCartAb = true;
                 }
               }
               if (theme.CartForm.needGiftAbTest == false){
                 if  (giftInCartAb) {
                      var removeId = document.querySelector('.cart__item.cart__item_unlock_gift').getAttribute('data-variant-id');                   
                       $.ajax({
                        type: 'POST',
                        url: '/cart/update.js',
                        data: {
                          updates: {
                            [removeId]: 0
                          }
                        },
                        dataType: 'json',
                        success: function(data) {
                          console.log('Product removed from cart: Mystery unlock free gift', data);
                        },
                        error: function(XMLHttpRequest, textStatus) {
                          console.log('Error removing product from cart');
                        }
                      });
                  
                      theme.cart.getCart()
                        .then(function(cart) {
                          this.buildCart();
                        }.bind(this));  
                   } 
                }
            }

           // Add the fetchAndDisplayImages function call here
            if (typeof fetchAndDisplayImages === 'function') {
                setTimeout(() => {
                    fetchAndDisplayImages();
                }, 2000);
            }

          
        }.bind(this))
        .catch(function(XMLHttpRequest){});
      },
  
      /*============================================================================
        Update elements of the cart
      ==============================================================================*/
      updateSubtotal: function(subtotal) {
        this.form.querySelector(selectors.subTotal).innerHTML = theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat);
      },
  
      updateSavings: function(savings) {
        if (!this.savings) {
          return;
        }
  
        if (savings > 0) {
          var amount = theme.Currency.formatMoney(savings, theme.settings.moneyFormat);
          this.savings.classList.remove('hide');
          this.savings.innerHTML = theme.strings.cartSavings.replace('[savings]', amount);
        } else {
          this.savings.classList.add('hide');
        }
      },
  
      updateCount: function(count) {
        var countEls = document.querySelectorAll('.cart-link__bubble-num');
  
        if (countEls.length) {
          countEls.forEach(el => {
            el.innerText = count;
          });
        }
  
        // show/hide bubble(s)
        var bubbles = document.querySelectorAll(selectors.cartBubble);
        if (bubbles.length) {
          if (count > 0) {
            bubbles.forEach(b => {
              b.innerText = count;
              b.classList.add('cart-link__bubble--visible');
            });
          } else {
            bubbles.forEach(b => {
              b.classList.remove('cart-link__bubble--visible');
            });
          }
        }
      }
    });
  
    return CartForm;
  })();
  
  // Either collapsible containers all acting individually,
  // or tabs that can only have one open at a time
  theme.collapsibles = (function() {
    var selectors = {
      trigger: '.collapsible-trigger',
      module: '.collapsible-content',
      moduleInner: '.collapsible-content__inner',
      tabs: '.collapsible-trigger--tab'
    };
  
    var classes = {
      hide: 'hide',
      open: 'is-open',
      autoHeight: 'collapsible--auto-height',
      tabs: 'collapsible-trigger--tab'
    };
  
    var namespace = '.collapsible';
  
    var isTransitioning = false;
  
    function init(scope) {
      var el = scope ? scope : document;
      el.querySelectorAll(selectors.trigger).forEach(trigger => {
        var state = trigger.classList.contains(classes.open);
        trigger.setAttribute('aria-expanded', state);
  
        trigger.off('click' + namespace);
        trigger.on('click' + namespace, toggle);
      });
    }
  
    function toggle(evt) {
      if (isTransitioning) {
        return;
      }
  
      isTransitioning = true;
  
      var el = evt.currentTarget;
      var isOpen = el.classList.contains(classes.open);
      var isTab = el.classList.contains(classes.tabs);
      var moduleId = el.getAttribute('aria-controls');
      var container = document.getElementById(moduleId);
      if(moduleId) {
        if(moduleId.includes("Footer-")) {
          console.log("true----")
          var container = el.nextSibling;
        }
      }
  
      if (!moduleId) {
        moduleId = el.dataset.controls;
      }
  
      // No ID, bail
      if (!moduleId) {
        return;
      }
  
      // If container=null, there isn't a matching ID.
      // Check if data-id is set instead. Could be multiple.
      // Select based on being in the same parent div.
      if (!container) {
        var multipleMatches = document.querySelectorAll('[data-id="' + moduleId + '"]');
        if (multipleMatches.length > 0) {
          container = el.parentNode.querySelector('[data-id="' + moduleId + '"]');
        }
      }
  
      if (!container) {
        isTransitioning = false;
        return;
      }
  
      var height = container.querySelector(selectors.moduleInner).offsetHeight;
      var isAutoHeight = container.classList.contains(classes.autoHeight);
      var parentCollapsibleEl = container.parentNode.closest(selectors.module);
      var childHeight = height;
  
      if (isTab) {
        if(isOpen) {
          isTransitioning = false;
          return;
        }
  
        var newModule;
        document.querySelectorAll(selectors.tabs + '[data-id="'+ el.dataset.id +'"]').forEach(el => {
          el.classList.remove(classes.open);
          newModule = document.querySelector('#' + el.getAttribute('aria-controls'));
          setTransitionHeight(newModule, 0, true);
        });
      }
  
      // If isAutoHeight, set the height to 0 just after setting the actual height
      // so the closing animation works nicely
      if (isOpen && isAutoHeight) {
        setTimeout(function() {
          height = 0;
          setTransitionHeight(container, height, isOpen, isAutoHeight);
        }, 0);
      }
  
      if (isOpen && !isAutoHeight) {
        height = 0;
      }
  
      el.setAttribute('aria-expanded', !isOpen);
      if (isOpen) {
        el.classList.remove(classes.open);
      } else {
        el.classList.add(classes.open);
      }
  
      setTransitionHeight(container, height, isOpen, isAutoHeight);
  
      // If we are in a nested collapsible element like the mobile nav,
      // also set the parent element's height
      if (parentCollapsibleEl) {
        var totalHeight = isOpen
                          ? parentCollapsibleEl.offsetHeight - childHeight
                          : height + parentCollapsibleEl.offsetHeight;
  
        setTransitionHeight(parentCollapsibleEl, totalHeight, false, false);
      }
  
      // If Shopify Product Reviews app installed,
      // resize container on 'Write review' click
      // that shows form
      if (window.SPR) {
        var btn = container.querySelector('.spr-summary-actions-newreview');
        if (!btn) { return }
        btn.off('click' + namespace);
        btn.on('click' + namespace, function() {
          height = container.querySelector(selectors.moduleInner).offsetHeight;
          setTransitionHeight(container, height, isOpen, isAutoHeight);
        });
      }
    }
  
    function setTransitionHeight(container, height, isOpen, isAutoHeight) {
      container.classList.remove(classes.hide);
      theme.utils.prepareTransition(container, function() {
        container.style.height = height+'px';
        if (isOpen) {
          container.classList.remove(classes.open);
        } else {
          container.classList.add(classes.open);
        }
      });
  
      if (!isOpen && isAutoHeight) {
        var o = container;
        window.setTimeout(function() {
          o.css('height','auto');
          isTransitioning = false;
        }, 500);
      } else {
        isTransitioning = false;
      }
    }
  
    return {
      init: init
    };
  })();
  
  // Shopify-built select-like popovers for currency and language selection
  theme.Disclosure = (function() {
    var selectors = {
      disclosureForm: '[data-disclosure-form]',
      disclosureList: '[data-disclosure-list]',
      disclosureToggle: '[data-disclosure-toggle]',
      disclosureInput: '[data-disclosure-input]',
      disclosureOptions: '[data-disclosure-option]'
    };
  
    var classes = {
      listVisible: 'disclosure-list--visible'
    };
  
    function Disclosure(disclosure) {
      this.container = disclosure;
      this._cacheSelectors();
      this._setupListeners();
    }
  
    Disclosure.prototype = Object.assign({}, Disclosure.prototype, {
      _cacheSelectors: function() {
        this.cache = {
          disclosureForm: this.container.closest(selectors.disclosureForm),
          disclosureList: this.container.querySelector(selectors.disclosureList),
          disclosureToggle: this.container.querySelector(
            selectors.disclosureToggle
          ),
          disclosureInput: this.container.querySelector(
            selectors.disclosureInput
          ),
          disclosureOptions: this.container.querySelectorAll(
            selectors.disclosureOptions
          )
        };
      },
  
      _setupListeners: function() {
        this.eventHandlers = this._setupEventHandlers();
  
        this.cache.disclosureToggle.addEventListener(
          'click',
          this.eventHandlers.toggleList
        );
  
        this.cache.disclosureOptions.forEach(function(disclosureOption) {
          disclosureOption.addEventListener(
            'click',
            this.eventHandlers.connectOptions
          );
        }, this);
  
        this.container.addEventListener(
          'keyup',
          this.eventHandlers.onDisclosureKeyUp
        );
  
        this.cache.disclosureList.addEventListener(
          'focusout',
          this.eventHandlers.onDisclosureListFocusOut
        );
  
        this.cache.disclosureToggle.addEventListener(
          'focusout',
          this.eventHandlers.onDisclosureToggleFocusOut
        );
  
        document.body.addEventListener('click', this.eventHandlers.onBodyClick);
      },
  
      _setupEventHandlers: function() {
        return {
          connectOptions: this._connectOptions.bind(this),
          toggleList: this._toggleList.bind(this),
          onBodyClick: this._onBodyClick.bind(this),
          onDisclosureKeyUp: this._onDisclosureKeyUp.bind(this),
          onDisclosureListFocusOut: this._onDisclosureListFocusOut.bind(this),
          onDisclosureToggleFocusOut: this._onDisclosureToggleFocusOut.bind(this)
        };
      },
  
      _connectOptions: function(event) {
        event.preventDefault();
  
        this._submitForm(event.currentTarget.dataset.value);
      },
  
      _onDisclosureToggleFocusOut: function(event) {
        var disclosureLostFocus =
          this.container.contains(event.relatedTarget) === false;
  
        if (disclosureLostFocus) {
          this._hideList();
        }
      },
  
      _onDisclosureListFocusOut: function(event) {
        var childInFocus = event.currentTarget.contains(event.relatedTarget);
  
        var isVisible = this.cache.disclosureList.classList.contains(
          classes.listVisible
        );
  
        if (isVisible && !childInFocus) {
          this._hideList();
        }
      },
  
      _onDisclosureKeyUp: function(event) {
        if (event.which !== 27) return;
        this._hideList();
        this.cache.disclosureToggle.focus();
      },
  
      _onBodyClick: function(event) {
        var isOption = this.container.contains(event.target);
        var isVisible = this.cache.disclosureList.classList.contains(
          classes.listVisible
        );
  
        if (isVisible && !isOption) {
          this._hideList();
        }
      },
  
      _submitForm: function(value) {
        this.cache.disclosureInput.value = value;
        this.cache.disclosureForm.submit();
      },
  
      _hideList: function() {
        this.cache.disclosureList.classList.remove(classes.listVisible);
        this.cache.disclosureToggle.setAttribute('aria-expanded', false);
      },
  
      _toggleList: function() {
        var ariaExpanded =
          this.cache.disclosureToggle.getAttribute('aria-expanded') === 'true';
        this.cache.disclosureList.classList.toggle(classes.listVisible);
        this.cache.disclosureToggle.setAttribute('aria-expanded', !ariaExpanded);
      },
  
      destroy: function() {
        this.cache.disclosureToggle.removeEventListener(
          'click',
          this.eventHandlers.toggleList
        );
  
        this.cache.disclosureOptions.forEach(function(disclosureOption) {
          disclosureOption.removeEventListener(
            'click',
            this.eventHandlers.connectOptions
          );
        }, this);
  
        this.container.removeEventListener(
          'keyup',
          this.eventHandlers.onDisclosureKeyUp
        );
  
        this.cache.disclosureList.removeEventListener(
          'focusout',
          this.eventHandlers.onDisclosureListFocusOut
        );
  
        this.cache.disclosureToggle.removeEventListener(
          'focusout',
          this.eventHandlers.onDisclosureToggleFocusOut
        );
  
        document.body.removeEventListener(
          'click',
          this.eventHandlers.onBodyClick
        );
      }
    });
  
    return Disclosure;
  })();
  
  theme.Drawers = (function() {
    function Drawers(id, name) {
      this.config = {
        id: id,
        close: '.js-drawer-close',
        open: '.js-drawer-open-' + name,
        openClass: 'js-drawer-open',
        closingClass: 'js-drawer-closing',
        activeDrawer: 'drawer--is-open',
        namespace: '.drawer-' + name
      };

      
  
      this.nodes = {
        page: document.querySelector('#MainContent')
      };
  
      this.drawer = document.querySelector('#' + id);
      this.isOpen = false;
  
      if (!this.drawer) {
        return;
      }
  
      this.init();
    }
  
    Drawers.prototype = Object.assign({}, Drawers.prototype, {
      init: function() {
        // Setup open button(s)
        document.querySelectorAll(this.config.open).forEach(openBtn => {
          openBtn.setAttribute('aria-expanded', 'false');
          openBtn.addEventListener('click', this.open.bind(this));
        });

        this.drawer.querySelector(this.config.close).addEventListener('click', this.close.bind(this));
  
        // Close modal if a drawer is opened
        document.addEventListener('modalOpen', function() {
          this.close();
        }.bind(this));
      },
  
      open: function(evt, returnFocusEl) {
        if (evt) {
          evt.preventDefault();
        }
  
        if (this.isOpen) {
          return;
        }
  
        // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer.
        if (evt && evt.stopPropagation) {
          evt.stopPropagation();
          // save the source of the click, we'll focus to this on close
          evt.currentTarget.setAttribute('aria-expanded', 'true');
          this.activeSource = evt.currentTarget;
        } else if (returnFocusEl) {
          returnFocusEl.setAttribute('aria-expanded', 'true');
          this.activeSource = returnFocusEl;
        }
  
        theme.utils.prepareTransition(this.drawer, function() {
          this.drawer.classList.add(this.config.activeDrawer);
        }.bind(this));
  
        document.documentElement.classList.add(this.config.openClass);
        this.isOpen = true;
  
        theme.a11y.trapFocus({
          container: this.drawer,
          namespace: 'drawer_focus'
        });
  
        document.dispatchEvent(new CustomEvent('drawerOpen'));
        document.dispatchEvent(new CustomEvent('drawerOpen.' + this.config.id));
  
        this.bindEvents();
      },
  
      close: function(evt) {
        if (!this.isOpen) {
          return;
        }
  
        // Do not close if click event came from inside drawer
        if (evt) {
          let inner_modal = document.getElementById("gift-wrapping-modal")          
          if (inner_modal != null && inner_modal.classList.contains("drawer--is-open")) {            
            if (evt.target.closest('.drawer')) {            
              return;
              // don't close inner if we click an element inside the drawer
            } else {              
              inner_modal.classList.remove("drawer--is-open")
              return;
            }
          }

          if (evt.target.closest('.js-drawer-close')) {
            // Do not close if using the drawer close button
          } else if (evt.target.closest('.drawer')) {
            return;
          }
        }          
        
        // deselect any focused form elements
        document.activeElement.blur();
  
        theme.utils.prepareTransition(this.drawer, function() {
          this.drawer.classList.remove(this.config.activeDrawer);
        }.bind(this));
  
        document.documentElement.classList.remove(this.config.openClass);
        document.documentElement.classList.add(this.config.closingClass);
  
        window.setTimeout(function() {
          document.documentElement.classList.remove(this.config.closingClass);
          if (this.activeSource && this.activeSource.getAttribute('aria-expanded')) {
            this.activeSource.setAttribute('aria-expanded', 'false');
            this.activeSource.focus();
          }
        }.bind(this), 500);
  
        this.isOpen = false;
  
        theme.a11y.removeTrapFocus({
          container: this.drawer,
          namespace: 'drawer_focus'
        });
  
        this.unbindEvents();
      },
  
      bindEvents: function() {
        // Clicking out of drawer closes it
        window.on('click' + this.config.namespace, function(evt) {
          this.close(evt)
          return;
        }.bind(this));
  
        // Pressing escape closes drawer
        window.on('keyup' + this.config.namespace, function(evt) {
          if (evt.keyCode === 27) {
            this.close();
          }
        }.bind(this));
  
        theme.a11y.lockMobileScrolling(this.config.namespace, this.nodes.page);
      },
  
      unbindEvents: function() {
        window.off('click' + this.config.namespace);
        window.off('keyup' + this.config.namespace);
  
        theme.a11y.unlockMobileScrolling(this.config.namespace, this.nodes.page);
      }
    });
  
    return Drawers;
  })();
  
  theme.Modals = (function() {
    function Modal(id, name, options) {
      var defaults = {
        close: '.js-modal-close',
        open: '.js-modal-open-' + name,
        openClass: 'modal--is-active',
        closingClass: 'modal--is-closing',
        bodyOpenClass: ['modal-open'],
        bodyOpenSolidClass: 'modal-open--solid',
        bodyClosingClass: 'modal-closing',
        closeOffContentClick: true
      };
  
      this.id = id;
      this.modal = document.getElementById(id);
  
      if (!this.modal) {
        return false;
      }
  
      this.modalContent = this.modal.querySelector('.modal__inner');
  
      this.config = Object.assign(defaults, options);
      this.modalIsOpen = false;
      this.focusOnOpen = this.config.focusIdOnOpen ? document.getElementById(this.config.focusIdOnOpen) : this.modal;
      this.isSolid = this.config.solid;
  
      this.init();
    }
  
    Modal.prototype.init = function() {
      document.querySelectorAll(this.config.open).forEach(btn => {
        btn.setAttribute('aria-expanded', 'false');
        btn.addEventListener('click', this.open.bind(this));
      });
  
      this.modal.querySelectorAll(this.config.close).forEach(btn => {
        btn.addEventListener('click', this.close.bind(this));
      });
  
      // Close modal if a drawer is opened
      document.addEventListener('drawerOpen', function() {
        this.close();
      }.bind(this));
    };
  
    Modal.prototype.open = function(evt) {
      // Keep track if modal was opened from a click, or called by another function
      var externalCall = false;
  
      // don't open an opened modal
      if (this.modalIsOpen) {
        return;
      }
  
      // Prevent following href if link is clicked
      if (evt) {
        evt.preventDefault();
      } else {
        externalCall = true;
      }
  
      // Without this, the modal opens, the click event bubbles up to $nodes.page
      // which closes the modal.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        // save the source of the click, we'll focus to this on close
        this.activeSource = evt.currentTarget.setAttribute('aria-expanded', 'true');
      }
  
      if (this.modalIsOpen && !externalCall) {
        this.close();
      }
  
      this.modal.classList.add(this.config.openClass);
      var model_form = this.modal.querySelector(".product-section");
      if(model_form) {
        var model_form_id = model_form.id;
        var main_form_id = `AddToCartForm-${model_form.dataset.productId}-modal`;
        var main_gift_drawer = document.querySelector(".gift-order_drawer_main");
        if(main_gift_drawer) {
          let all_radios = main_gift_drawer.querySelectorAll("input[type='radio']");
          if(all_radios){
            all_radios.forEach(radio => {
              radio.setAttribute('form', main_form_id);
            })
          }
        }
      }
  
      document.documentElement.classList.add(...this.config.bodyOpenClass);
  
      if (this.isSolid) {
        document.documentElement.classList.add(this.config.bodyOpenSolidClass);
      }
  
      this.modalIsOpen = true;
  
      theme.a11y.trapFocus({
        container: this.modal,
        elementToFocus: this.focusOnOpen,
        namespace: 'modal_focus'
      });
  
      document.dispatchEvent(new CustomEvent('modalOpen'));
      document.dispatchEvent(new CustomEvent('modalOpen.' + this.id));
  
      this.bindEvents();
    };
  
    Modal.prototype.close = function(evt) {
      // don't close a closed modal
      if (!this.modalIsOpen) {
        return;
      }
  
      // Do not close modal if click happens inside modal content
      if (evt) {
        if (evt.target.closest('.js-modal-close')) {
          // Do not close if using the modal close button
        } else if (evt.target.closest('.modal__inner')) {
          return;
        }
      }
  
      // deselect any focused form elements
      document.activeElement.blur();
  
      this.modal.classList.remove(this.config.openClass);
      this.modal.classList.add(this.config.closingClass);
  
      document.documentElement.classList.remove(...this.config.bodyOpenClass);
      document.documentElement.classList.add(this.config.bodyClosingClass);
  
      window.setTimeout(function() {
        document.documentElement.classList.remove(this.config.bodyClosingClass);
        this.modal.classList.remove(this.config.closingClass);
        if (this.activeSource && this.activeSource.getAttribute('aria-expanded')) {
          this.activeSource.setAttribute('aria-expanded', 'false').focus();
        }
      }.bind(this), 500); // modal close css transition
  
      if (this.isSolid) {
        document.documentElement.classList.remove(this.config.bodyOpenSolidClass);
      }
  
      this.modalIsOpen = false;
  
      theme.a11y.removeTrapFocus({
        container: this.modal,
        namespace: 'modal_focus'
      });
  
      document.dispatchEvent(new CustomEvent('modalClose.' + this.id));
  
      this.unbindEvents();
    };
  
    Modal.prototype.bindEvents = function() {
      window.on('keyup.modal', function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }.bind(this));
  
      if (this.config.closeOffContentClick) {
        // Clicking outside of the modal content also closes it
        this.modal.on('click.modal', this.close.bind(this));
      }
    };
  
    Modal.prototype.unbindEvents = function() {
      document.documentElement.off('.modal');
  
      if (this.config.closeOffContentClick) {
        this.modal.off('.modal');
      }
    };
  
    return Modal;
  })();
  
  theme.parallaxSections = {};
  
  theme.Parallax = (function() {
    var speed = 0.85;
    var reset = false;
  
    function parallax(container, args) {
      this.isInit = false;
      this.isVisible = false;
      this.container = container;
      this.image = container.querySelector('.parallax-image');
      this.namespace = args.namespace;
      this.desktopOnly = args.desktopOnly;
  
      if (!this.container || !this.image) {
        return;
      }
  
      // If set for desktop only, setup listeners for disabling
      // on mobile and re-enabling on desktop
      if (this.desktopOnly) {
        document.addEventListener('matchSmall', function() {
          this.destroy();
        }.bind(this));
  
        document.addEventListener('unmatchSmall', function() {
          this.init(true);
        }.bind(this));
      }
  
      this.init(this.desktopOnly);
    }
  
    parallax.prototype = Object.assign({}, parallax.prototype, {
      init: function(desktopOnly) {
        // Reset in case initialized again
        if (this.isInit) {
          this.destroy();
        }
  
        this.isInit = true;
  
        // Do not setup scroll event if on mobile
        if (desktopOnly && theme.config.bpSmall) {
          return;
        }
  
        // Set position on page load
        this.setSizes();
        this.scrollHandler();
  
        var observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            this.isVisible = entry.isIntersecting;
            if (this.isVisible) {
              window.on('scroll' + this.namespace, this.onScroll.bind(this));
            } else {
              window.off('scroll' + this.namespace);
            }
          });
        }, {rootMargin: '200px 0px 200px 0px'});
  
        observer.observe(this.container);
  
        window.on('resize' + this.namespace, theme.utils.debounce(250, this.setSizes.bind(this)));
  
        document.addEventListener('shopify:section:reorder', theme.utils.debounce(250, this.onReorder.bind(this)));
      },
  
      onScroll: function() {
        if (!this.isVisible) {
          return;
        }
  
        // If a scroll event finds Shopify's review app,
        // update parallax scroll positions because of page reflows
        if (window.SPR && !reset) {
          this.setSizes();
          reset = true;
        }
  
        requestAnimationFrame(this.scrollHandler.bind(this));
      },
  
      scrollHandler: function() {
        var shiftDistance = (window.scrollY - this.elTop) * speed;
        this.image.style.transform = 'translate3d(0, ' + shiftDistance + 'px, 0)';
      },
  
      setSizes: function() {
        var rect = this.container.getBoundingClientRect();
        this.elTop = rect.top + window.scrollY;
      },
  
      onReorder: function() {
        this.setSizes();
        this.onScroll();
      },
  
      destroy: function() {
        this.image.style.transform = 'none';
        window.off('scroll' + this.namespace);
        window.off('resize' + this.namespace);
      }
    });
  
    return parallax;
  })();
  
  if (typeof window.noUiSlider === 'undefined') {
    throw new Error('theme.PriceRange is missing vendor noUiSlider: // =require vendor/nouislider.js');
  }
  
  theme.PriceRange = (function () {
    var defaultStep = 1;
    var selectors = {
      priceRange: '.price-range',
      priceRangeSlider: '.price-range__slider',
      priceRangeInputMin: '.price-range__input-min',
      priceRangeInputMax: '.price-range__input-max',
      priceRangeDisplayMin: '.price-range__display-min',
      priceRangeDisplayMax: '.price-range__display-max',
    };
  
    function PriceRange(container, {onChange, onUpdate, ...sliderOptions} = {}) {
      this.container = container;
      this.onChange = onChange;
      this.onUpdate = onUpdate;
      this.sliderOptions = sliderOptions || {};
  
      return this.init();
    }
  
    PriceRange.prototype = Object.assign({}, PriceRange.prototype, {
      init: function () {
        if (!this.container.classList.contains('price-range')) {
          throw new Error('You must instantiate PriceRange with a valid container')
        }
  
        this.formEl = this.container.closest('form');
        this.sliderEl = this.container.querySelector(selectors.priceRangeSlider);
        this.inputMinEl = this.container.querySelector(selectors.priceRangeInputMin);
        this.inputMaxEl = this.container.querySelector(selectors.priceRangeInputMax);
        this.displayMinEl = this.container.querySelector(selectors.priceRangeDisplayMin);
        this.displayMaxEl = this.container.querySelector(selectors.priceRangeDisplayMax);
  
        this.minRange = parseFloat(this.container.dataset.min) || 0;
        this.minValue = parseFloat(this.container.dataset.minValue) || 0;
        this.maxRange = parseFloat(this.container.dataset.max) || 100;
        this.maxValue = parseFloat(this.container.dataset.maxValue) || this.maxRange;
  
        return this.createPriceRange();
      },
  
      createPriceRange: function () {
        if (this.sliderEl && this.sliderEl.noUiSlider && typeof this.sliderEl.noUiSlider.destroy === 'function') {
          this.sliderEl.noUiSlider.destroy();
        }
  
        var slider = noUiSlider.create(this.sliderEl, {
          connect: true,
          step: defaultStep,
          ...this.sliderOptions,
          // Do not allow overriding these options
          start: [this.minValue, this.maxValue],
          range: {
            min: this.minRange,
            max: this.maxRange,
          },
        });
  
        slider.on('update', values => {
          this.displayMinEl.innerHTML = theme.Currency.formatMoney(
            values[0],
            theme.settings.moneyFormat,
          );

          this.displayMaxEl.innerHTML = theme.Currency.formatMoney(values[1], theme.settings.moneyFormat,);

          try {
            DoublyGlobalCurrency.convertAll(DoublyGlobalCurrency.currentCurrency, '')
          } catch(e) {

          }

          if (this.onUpdate) {
            this.onUpdate(values);
          }
        });
  
        slider.on('change', values => {
          this.inputMinEl.value = values[0];
          this.inputMaxEl.value = values[1];
  
          if (this.onChange) {
            const formData = new FormData(this.formEl);
            if (!theme.FilterDrawer.isOpen) {
                this.onChange(formData);
            }

          }
        });
  
        return slider;
      },
    });
  
    return PriceRange;
  })();
  
  theme.AjaxProduct = (function() {
    var status = {
      loading: false
    };
  
    function ProductForm(form, submit, args) {
      this.form = form;
      this.args = args;
  
      var submitSelector = submit ? submit : '.add-to-cart';
  
      if (this.form) {
        this.addToCart = form.querySelector(submitSelector);
        this.form.addEventListener('submit', this.addItemFromForm.bind(this));
      }
    };
  
    ProductForm.prototype = Object.assign({}, ProductForm.prototype, {
      addItemFromForm: function(evt, callback){
        evt.preventDefault();

        if (status.loading) {
          return;
        }
  
        // Loading indicator on add to cart button
        this.addToCart.classList.add('btn--loading');
        status.loading = true;

        var data = theme.utils.serialize(this.form);

        fetch(theme.routes.cartAdd, {
          method: 'POST',
          body: data,
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(response => response.json())
        .then(function(data) {
          if (data.status === 422) {
            this.error(data);
          } else {
            var product = data;
            this.success(product);

              fetch('/cart.js')
              .then(response => response.json())
              .then(cart => {
                  let freeGiftUnlocked = false;
                  let freeGiftVariantIds = [];
                  cart.items.forEach(item => {
                      if (item.properties && item.properties['_type'] === 'unlocked a free gift') {
                          freeGiftUnlocked = true;
                          freeGiftVariantIds.push(item.variant_id);
                      }
                  });
                  if (freeGiftUnlocked && freeGiftVariantIds.length > 1) {
                      freeGiftVariantIds.slice(1).forEach(vId => {
                          $.ajax({
                              type: 'POST',
                              url: '/cart/update.js',
                              data: { updates: { [vId]: 0 } },
                              dataType: 'json',
                              success: function (data) {
                                console.log(vId,"vId")
                                  document.dispatchEvent(new CustomEvent('cart:build'));
                              },
                              error: function (XMLHttpRequest, textStatus) {
                              }
                          });
                      });
                  }
              })
              .catch(error => {
                  console.error('Error fetching cart data:', error);
              });

          }

          // theme.updateFreeMysteryEarringsCart();
          status.loading = false;
          this.addToCart.classList.remove('btn--loading');
  
          // Reload page if adding product from a section on the cart page
          if (document.body.classList.contains('template-cart')) {
            window.scrollTo(0, 0);
            location.reload();
          }
        }.bind(this));
      },

      success: function(product) {
        var errors = this.form.querySelector('.errors');
        if (errors) {
          errors.remove();
        }
  
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: product,
            addToCartBtn: this.addToCart
          }
        }));
  
        if (this.args && this.args.scopedEventId) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:added:' + this.args.scopedEventId, {
            detail: {
              product: product,
              addToCartBtn: this.addToCart
            }
          }));
        }
      },
  
      error: function(error) {
        if (!error.description) {
          console.warn(error);
          return;
        }
  
        var errors = this.form.querySelector('.errors');
        if (errors) {
          errors.remove();
        }
  
        var errorDiv = document.createElement('div');
        errorDiv.classList.add('errors', 'text-center');
        errorDiv.textContent = error.description;
        this.form.append(errorDiv);
  
        document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
          detail: {
            errorMessage: error.description
          }
        }));
  
        if (this.args && this.args.scopedEventId) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:error:' + this.args.scopedEventId, {
            detail: {
              errorMessage: error.description
            }
          }));
        }
      }
    });
  
    return ProductForm;
  })();
  
  theme.ProductMedia = (function() {
    var modelJsonSections = {};
    var models = {};
    var xrButtons = {};
  
    var selectors = {
      mediaGroup: '[data-product-single-media-group]',
      xrButton: '[data-shopify-xr]'
    };
  
    function init(modelViewerContainers, sectionId) {
      modelJsonSections[sectionId] = {
        loaded: false
      };
  
      modelViewerContainers.forEach(function(container, index) {
        var mediaId = container.dataset.mediaId;
        var modelViewerElement = container.querySelector('model-viewer');
        var modelId = modelViewerElement.dataset.modelId;
  
        if (index === 0) {
          var mediaGroup = container.closest(selectors.mediaGroup);
          var xrButton = mediaGroup.querySelector(selectors.xrButton);
          xrButtons[sectionId] = {
            element: xrButton,
            defaultId: modelId
          };
        }
  
        models[mediaId] = {
          modelId: modelId,
          sectionId: sectionId,
          container: container,
          element: modelViewerElement
        };
  
      });
  
      window.Shopify.loadFeatures([
        {
          name: 'shopify-xr',
          version: '1.0',
          onLoad: setupShopifyXr
        },
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: setupModelViewerUi
        }
      ]);
  
      theme.LibraryLoader.load('modelViewerUiStyles');
    }
  
    function setupShopifyXr(errors) {
      if (errors) return;
  
      if (!window.ShopifyXR) {
        document.addEventListener('shopify_xr_initialized', function() {
          setupShopifyXr();
        });
        return;
      }
  
      for (var sectionId in modelJsonSections) {
        if (modelJsonSections.hasOwnProperty(sectionId)) {
          var modelSection = modelJsonSections[sectionId];
  
          if (modelSection.loaded) continue;
  
          var modelJson = document.querySelector('#ModelJson-' + sectionId);
  
          window.ShopifyXR.addModels(JSON.parse(modelJson.innerHTML));
          modelSection.loaded = true;
        }
      }
      window.ShopifyXR.setupXRElements();
    }
  
    function setupModelViewerUi(errors) {
      if (errors) return;
  
      for (var key in models) {
        if (models.hasOwnProperty(key)) {
          var model = models[key];
          if (!model.modelViewerUi && Shopify) {
            model.modelViewerUi = new Shopify.ModelViewerUI(model.element);
          }
          setupModelViewerListeners(model);
        }
      }
    }
  
    function setupModelViewerListeners(model) {
      var xrButton = xrButtons[model.sectionId];
  
      model.container.addEventListener('mediaVisible', function() {
        xrButton.element.setAttribute('data-shopify-model3d-id', model.modelId);
        if (theme.config.isTouch) return;
        model.modelViewerUi.play();
      });
  
      model.container.addEventListener('mediaHidden', function() {
        xrButton.element.setAttribute('data-shopify-model3d-id', xrButton.defaultId);
        model.modelViewerUi.pause();
      });
  
      model.container.addEventListener('xrLaunch', function() {
        model.modelViewerUi.pause();
      });
    }
  
    function removeSectionModels(sectionId) {
      for (var key in models) {
        if (models.hasOwnProperty(key)) {
          var model = models[key];
          if (model.sectionId === sectionId) {
            delete models[key];
          }
        }
      }
      delete modelJsonSections[sectionId];
    }
  
    return {
      init: init,
      removeSectionModels: removeSectionModels
    };
  })();

  theme.QtyRemoveSelector = (function() {
    var selector = '.js-qty__remove'

    function QtyRemoveSelector(el, options) {
      this.wrapper = el;
      this.remove = el.querySelector(selector);
      var defaults = {
        namespace: null,
        isCart: false,
        key: this.remove.dataset.id
      };

      this.options = Object.assign({}, defaults, options);

      this.init();
    }

    QtyRemoveSelector.prototype = Object.assign({}, QtyRemoveSelector.prototype, {
      init: function() {
        this.remove.addEventListener('click', function() {
          this._change();
        }.bind(this));
      },

      _change: function() {
        if (this.options.isCart) {
         
          var bundqtyinput = [];
          var indexNumber = this.wrapper.getAttribute('data-index-remove');
          document.querySelectorAll('.cart__item').forEach(function(item) {
              var qty = item.querySelector('.js-qty__num').value;
              var allIndexNumber = item.getAttribute('data-item-index');
           if (indexNumber === allIndexNumber) {
                  bundqtyinput.push(0);  
              } else {
                  bundqtyinput.push(qty); 
              }
          });
          fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: bundqtyinput })
          }).then(response => {
            if (!response.ok) {
              throw new Error(`HTTP error! Status: ${response.status}`);
            }
            return response.json();
          }).then(cart => {
            if (cart.item_count > 0) {
              this.wrapper.classList.remove('is-empty');
            } else {
              this.wrapper.classList.add('is-empty');
            }
        
            if (document.body.classList.contains('template-cart')) {
              this.cartForm = new theme.CartForm(document.querySelector('#CartPageForm'));
            } else {
              this.cartForm = new theme.CartForm(document.querySelector('#CartDrawerForm'));
            }
        
            this.cartForm.buildCart();
            document.dispatchEvent(new CustomEvent('cart:updated', {
              detail: { cart: cart }
            }));
              let mirrorTotalcart = document.querySelector('#CartPageForm .cart-subtotal');
              if (mirrorTotalcart) {
                  let TotalCartcart = cart.total_price;
                  let CartUpdate = new CustomEvent("CartUpdate", { detail: TotalCartcart });
                  window.dispatchEvent(CartUpdate);
                  if (theme.CartForm.needGiftAbTest == false){
                    var removeId = document.querySelector('.cart__item.cart__item_unlock_gift').getAttribute('data-variant-id');
                    $.ajax({
                      type: 'POST',
                      url: '/cart/update.js',
                      data: { updates: { [removeId]: 0  } },
                      dataType: 'json',
                      success: function(data) {},
                      error: function(XMLHttpRequest, textStatus) {}
                    });
                    theme.cart.getCart()
                     .then(function (cart){
                      this.cartForm.buildCart();
                   }.bind(this));
                  }
              }

          }).catch(error => {
            console.error('Error updating cart:', error);
          });
        }
      }
    });

    return QtyRemoveSelector;
  })();
  
  theme.QtySelector = (function() {
    var selectors = {
      input: '.js-qty__num',
      plus: '.js-qty__adjust--plus',
      minus: '.js-qty__adjust--minus'
    };
  
    function QtySelector(el, options) {
      this.wrapper = el;
      this.plus = el.querySelector(selectors.plus);
      this.minus = el.querySelector(selectors.minus);
      this.input = el.querySelector(selectors.input);
      this.minValue = this.input.getAttribute('min') || 1;
  
      var defaults = {
        namespace: null,
        isCart: false,
        key: this.input.dataset.id
      };
  
      this.options = Object.assign({}, defaults, options);

      this.init();
    }
  
    QtySelector.prototype = Object.assign({}, QtySelector.prototype, {
      init: function() {
        this.plus.addEventListener('click', function() {
          var qty = this._getQty();
          // console.log('qty',qty)
          this._change(qty + 1, qty);
        }.bind(this));
  
        this.minus.addEventListener('click', function() {
          var qty = this._getQty();
          this._change(qty - 1, qty);
        }.bind(this));

        this.input.addEventListener('click', function(evt) {
          this.input.setAttribute("oldvalue", this.input.value);
        }.bind(this));
  
        this.input.addEventListener('change', function(evt) {
          this._change(this._getQty(), this.input.getAttribute("oldValue"));
        }.bind(this));
      },
  
      _getQty: function() {
        var qty = this.input.value;
        // console.log(qty,"qty get qty")
        if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
          // We have a valid number!
        } else {
          // Not a number. Default to 1.
          qty = 1;
        }
        return parseInt(qty);
      },
  
      _change: function(qty, oldQty) {
        if (qty <= this.minValue) {
          qty = this.minValue;
        }
  
        this.input.value = qty;
  
        if (this.options.isCart) {
          document.dispatchEvent(new CustomEvent('cart:quantity' + this.options.namespace, {
              detail: [this.options.key, qty, this.wrapper, oldQty]
          }));
        }
      }
    });
  
    return QtySelector;
  })();
  
  theme.initQuickShop = function() {
    var ids = [];
    var products = document.querySelectorAll('.grid-product');

    if (!products.length || !theme.settings.quickView) {
      return;
    }
  
    products.forEach(product => {
      product.addEventListener('mouseover', productMouseover);
    });
  
    function productMouseover(evt) {
      var el = evt.currentTarget;
      // No quick view on mobile breakpoint
      
        el.removeEventListener('mouseover', productMouseover);
        if (!el || !el.dataset.productId) {
          // Onboarding product, no real data
          return;
        }
        var productId = el.dataset.productId;
        var handle = el.dataset.productHandle;
        var btn = el.querySelector('.quick-product__btn');
  
        theme.preloadProductModal(handle, productId, btn);
      
    }
  };
  
  theme.preloadProductModal = function(handle, productId, btn) {
    var holder = document.getElementById('QuickShopHolder-' + handle);
    var url = theme.routes.home + '/products/' + handle + '?view=modal';
    if (btn) {
      if(btn.dataset.target){
        var target__ele = document.getElementById(btn.dataset.target);
        console.log("target__ele",target__ele);
        target__ele.style.zIndex = 30;
      }
    }
  
    // remove double `/` in case shop might have /en or language in URL
    url = url.replace('//', '/');
  
    fetch(url).then(function(response) {
      return response.text();
    }).then(function(html) {
      
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var div = doc.querySelector('.product-section[data-product-handle="'+handle+'"]');

      if (!holder) {
        return;
      }
  
      holder.innerHTML = '';
      holder.append(div);
  
      // Setup quick view modal
      var modalId = 'QuickShopModal-' + productId;
      var name = 'quick-modal-' + productId;
      new theme.Modals(modalId, name);
  
      // Register product template inside quick view
      theme.sections.register('product', theme.Product, holder);
  
      // Register collapsible elements
      theme.collapsibles.init();
  
      // Register potential video modal links (when video has sound)
      theme.videoModal();

      if (btn) {
        btn.classList.remove('quick-product__btn--not-ready');
        
      }
    });
  }
  
  // theme.Slideshow handles all flickity based sliders
  // Child navigation is only setup to work on product images
  theme.Slideshow = (function() {
    var classes = {
      animateOut: 'animate-out',
      isPaused: 'is-paused',
      isActive: 'is-active'
    };
  
    var selectors = {
      allSlides: '.slideshow__slide',
      currentSlide: '.is-selected',
      wrapper: '.slideshow-wrapper',
      pauseButton: '.slideshow__pause'
    };
  
    var productSelectors = {
      thumb: '.product__thumb-item:not(.hide)',
      links: '.product__thumb-item:not(.hide) a',
      arrow: '.product__thumb-arrow'
    };
  
    var defaults = {
      adaptiveHeight: false,
      autoPlay: false,
      avoidReflow: false, // custom by Archetype
      childNav: null, // element. Custom by Archetype instead of asNavFor
      childNavScroller: null, // element
      childVertical: false,
      dragThreshold: 7,
      fade: false,
      friction: 0.8,
      initialIndex: 0,
      pageDots: false,
      pauseAutoPlayOnHover: false,
      prevNextButtons: true,
      rightToLeft: theme.config.rtl,
      selectedAttraction: 0.14,
      setGallerySize: true,
      wrapAround: true
    };
  
    function slideshow(el, args) {
      this.el = el;
      this.args = Object.assign({}, defaults, args);
  
      // Setup listeners as part of arguments
      this.args.on = {
        ready: this.init.bind(this),
        change: this.slideChange.bind(this),
        settle: this.afterChange.bind(this)
      };
  
      if (this.args.childNav) {
        this.childNavEls = this.args.childNav.querySelectorAll(productSelectors.thumb);
        this.childNavLinks = this.args.childNav.querySelectorAll(productSelectors.links);
        this.arrows = this.args.childNav.querySelectorAll(productSelectors.arrow);
        if (this.childNavLinks.length) {
          this.initChildNav();
        }
      }
  
      if (this.args.avoidReflow) {
        avoidReflow(el);
      }
  
      this.slideshow = new Flickity(el, this.args);
  
      if (this.args.autoPlay) {
        var wrapper = el.closest(selectors.wrapper);
        this.pauseBtn = wrapper.querySelector(selectors.pauseButton);
        if (this.pauseBtn) {
          this.pauseBtn.addEventListener('click', this._togglePause.bind(this));
        }
      }
  
      // Reset dimensions on resize
      window.on('resize', theme.utils.debounce(300, function() {
        this.resize();
      }.bind(this)));
  
      // Set flickity-viewport height to first element to
      // avoid awkward page reflows while initializing.
      // Must be added in a `style` tag because element does not exist yet.
      // Slideshow element must have an ID
      function avoidReflow(el) {
        if (!el.id) return;
        var firstChild = el.firstChild;
        while(firstChild != null && firstChild.nodeType == 3){ // skip TextNodes
          firstChild = firstChild.nextSibling;
        }
        var style = document.createElement('style');
        style.innerHTML = `#${el.id} .flickity-viewport{height:${firstChild.offsetHeight}px}`;
        document.head.appendChild(style); 
      }
    }
  
    slideshow.prototype = Object.assign({}, slideshow.prototype, {
      init: function(el) {
        this.currentSlide = this.el.querySelector(selectors.currentSlide);
  
        // Optional onInit callback
        if (this.args.callbacks && this.args.callbacks.onInit) {
          if (typeof this.args.callbacks.onInit === 'function') {
            this.args.callbacks.onInit(this.currentSlide);
          }
        }
  
        if (window.AOS) { AOS.refresh() }
      },
  
      slideChange: function(index) {
        // Outgoing fade styles
        if (this.args.fade && this.currentSlide) {
          this.currentSlide.classList.add(classes.animateOut);
          this.currentSlide.addEventListener('transitionend', function() {
            this.currentSlide.classList.remove(classes.animateOut);
          }.bind(this));
        }
  
        // Match index with child nav
        if (this.args.childNav) {
          this.childNavGoTo(index);
        }
  
        // Optional onChange callback
        if (this.args.callbacks && this.args.callbacks.onChange) {
          if (typeof this.args.callbacks.onChange === 'function') {
            this.args.callbacks.onChange(index);
          }
        }
  
        // Show/hide arrows depending on selected index
        if (this.arrows && this.arrows.length) {
          this.arrows[0].classList.toggle('hide', index === 0);
          this.arrows[1].classList.toggle('hide', index === (this.childNavLinks.length - 1));
        }
      },
      afterChange: function(index) {
        // Remove all fade animation classes after slide is done
        if (this.args.fade) {
          this.el.querySelectorAll(selectors.allSlides).forEach(slide => {
            slide.classList.remove(classes.animateOut);
          });
        }
  
        this.currentSlide = this.el.querySelector(selectors.currentSlide);
  
        // Match index with child nav (in case slider height changed first)
        if (this.args.childNav) {
          this.childNavGoTo(this.slideshow.selectedIndex);
        }
      },
      destroy: function() {
        if (this.args.childNav && this.childNavLinks.length) {
          this.childNavLinks.forEach(a => {
            a.classList.remove(classes.isActive);
          });
        }
        this.slideshow.destroy();
      },
      _togglePause: function() {
        if (this.pauseBtn.classList.contains(classes.isPaused)) {
          this.pauseBtn.classList.remove(classes.isPaused);
          this.slideshow.playPlayer();
        } else {
          this.pauseBtn.classList.add(classes.isPaused);
          this.slideshow.pausePlayer();
        }
      },
      resize: function() {
        this.slideshow.resize();
      },
      play: function() {
        this.slideshow.playPlayer();
      },
      pause: function() {
        this.slideshow.pausePlayer();
      },
      goToSlide: function(i) {
        this.slideshow.select(i);
      },
      setDraggable: function(enable) {
        this.slideshow.options.draggable = enable;
        this.slideshow.updateDraggable();
      },
  
      initChildNav: function() {
        this.childNavLinks[this.args.initialIndex].classList.add('is-active');
  
        // Setup events
        this.childNavLinks.forEach((link, i) => {
          // update data-index because image-set feature may be enabled
          link.setAttribute('data-index', i);
  
          link.addEventListener('click', function(evt) {
            evt.preventDefault();
            this.goToSlide(this.getChildIndex(evt.currentTarget))
          }.bind(this));
          link.addEventListener('focus', function(evt) {
            this.goToSlide(this.getChildIndex(evt.currentTarget))
          }.bind(this));
          link.addEventListener('keydown', function(evt) {
            if (evt.keyCode === 13) {
              this.goToSlide(this.getChildIndex(evt.currentTarget))
            }
          }.bind(this));
        });
  
        // Setup optional arrows
        if (this.arrows.length) {
          this.arrows.forEach(arrow => {
            arrow.addEventListener('click', this.arrowClick.bind(this));
          });;
        }
      },
  
      getChildIndex: function(target) {
        return parseInt(target.dataset.index);
      },
  
      childNavGoTo: function(index) {
        this.childNavLinks.forEach(a => {
          a.classList.remove(classes.isActive);
        });
  
        var el = this.childNavLinks[index];
        el.classList.add(classes.isActive);
  
        if (!this.args.childNavScroller) {
          return;
        }
  
        if (this.args.childVertical) {
          var elTop = el.offsetTop;
          this.args.childNavScroller.scrollTop = elTop - 100;
        } else {
          var elLeft = el.offsetLeft;
          this.args.childNavScroller.scrollLeft = elLeft - 100;
        }
      },
  
      arrowClick: function(evt) {
        if (evt.currentTarget.classList.contains('product__thumb-arrow--prev')) {
          this.slideshow.previous();
        } else {
          this.slideshow.next();
        }
      }
    });
  
    return slideshow;
  })();
  
  /*============================================================================
    VariantAvailability
    - Cross out sold out or unavailable variants
    - To disable, set dynamicVariantsEnable to false in theme.liquid
    - Required markup:
      - class=variant-input-wrap to wrap select or button group
      - class=variant-input to wrap button/label
  ==============================================================================*/
  
  theme.VariantAvailability = (function() {
    var classes = {
      disabled: 'disabled'
    };
  
    function availability(args) {
      this.type = args.type;
      this.variantsObject = args.variantsObject;
      this.currentVariantObject = args.currentVariantObject;
      this.container = args.container;
      this.namespace = args.namespace;
  
      this.init();
    }
  
    availability.prototype = Object.assign({}, availability.prototype, {
      init: function() {
        this.container.on('variantChange' + this.namespace, this.setAvailability.bind(this));
  
        // Set default state based on current selected variant
        this.setAvailability(null, this.currentVariantObject);
      },
  
      setAvailability: function(evt, variant) {
        if (evt) {
          var variant = evt.detail.variant;
        }
  
        // Object to hold all options by value.
        // This will be what sets a button/dropdown as
        // sold out or unavailable (not a combo set as purchasable)
        var valuesToManage = {
          option1: [],
          option2: [],
          option3: []
        };
  
        var ignoreIndex = null;
        var availableVariants = this.variantsObject.filter(function(el) {
          if (!variant || variant.id === el.id) {
            return false;
          }
  
          if (variant.option2 === el.option2 && variant.option3 === el.option3) {
            return true;
          }
  
          if (variant.option1 === el.option1 && variant.option3 === el.option3) {
            return true;
          }
  
          if (variant.option1 === el.option1 && variant.option2 === el.option2) {
            return true;
          }
        });
  
        var variantObject = {
          variant: variant
        };
  
        var variants = Object.assign({}, {variant}, availableVariants);
  
        // Disable all options to start.
        // If coming from a variant change event, do not disable
        // options inside current index group
        this.container.querySelectorAll('.variant-input-wrap').forEach(group => {
          this.disableVariantGroup(group);
        });
  
        // Loop through each available variant to gather variant values
        for (var property in variants) {
          if (variants.hasOwnProperty(property)) {
            var item = variants[property];
            if (!item) {
              return;
            }
  
            var value1 = item.option1;
            var value2 = item.option2;
            var value3 = item.option3;
            var soldOut = item.available === false;
  
            if (value1 && ignoreIndex !== 'option1') {
              valuesToManage.option1.push({
                value: value1,
                soldOut: soldOut
              });
            }
            if (value2 && ignoreIndex !== 'option2') {
              valuesToManage.option2.push({
                value: value2,
                soldOut: soldOut
              });
            }
            if (value3 && ignoreIndex !== 'option3') {
              valuesToManage.option3.push({
                value: value3,
                soldOut: soldOut
              });
            }
          }
        }
  
        // Loop through all option levels and send each
        // value w/ args to function that determines to show/hide/enable/disable
        for (var [option, values] of Object.entries(valuesToManage)) {
          this.manageOptionState(option, values);
        }
      },
  
      manageOptionState: function(option, values) {
        var group = this.container.querySelector('.variant-input-wrap[data-index="'+ option +'"]');
  
        // Loop through each option value
        values.forEach(obj => {
          this.enableVariantOption(group, obj);
        });
      },
  
      enableVariantOptionByValue: function(array, index) {
        var group = this.container.querySelector('.variant-input-wrap[data-index="'+ index +'"]');
  
        for (var i = 0; i < array.length; i++) {
          this.enableVariantOption(group, array[i]);
        }
      },
  
      enableVariantOption: function(group, obj) {
        // Selecting by value so escape it
        var value = obj.value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g,'\\$1');
  
        if (this.type === 'dropdown') {
          group.querySelector('option[value="'+ value +'"]').disabled = false;
        } else {
          if(group) {            
            var buttonGroup = group.querySelector('.variant-input[data-value="'+ value +'"]');
            var input = buttonGroup.querySelector('input');
            var label = buttonGroup.querySelector('label');
    
            // Variant exists - enable & show variant
            input.classList.remove(classes.disabled);
            label.classList.remove(classes.disabled);
    
            // Variant sold out - cross out option (remains selectable)
            if (obj.soldOut) {
              input.classList.add(classes.disabled);
              label.classList.add(classes.disabled);
            }
          }
        }
      },
  
      disableVariantGroup: function(group) {
        if (this.type === 'dropdown') {
          group.querySelectorAll('option').forEach(option => {
            option.disabled = true;
          });
        } else {
          group.querySelectorAll('input').forEach(input => {
            input.classList.add(classes.disabled);
          });
          group.querySelectorAll('label').forEach(label => {
            label.classList.add(classes.disabled);
          });
        }
      }
  
    });
  
    return availability;
  })();
  
  // Video modal will auto-initialize for any anchor link that points to YouTube
  // MP4 videos must manually be enabled with:
  //   - .product-video-trigger--mp4 (trigger button)
  //   - .product-video-mp4-sound video player element (cloned into modal)
  //     - see media.liquid for example of this
  theme.videoModal = function() {
    var youtubePlayer;
  
    var videoHolderId = 'VideoHolder';
    var selectors = {
      youtube: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]',
      mp4Trigger: '.product-video-trigger--mp4',
      mp4Player: '.product-video-mp4-sound'
    };
  
    var youtubeTriggers = document.querySelectorAll(selectors.youtube);
    var mp4Triggers = document.querySelectorAll(selectors.mp4Trigger);
  
    if (!youtubeTriggers.length && !mp4Triggers.length) {
      return;
    }
  
    var videoHolderDiv = document.getElementById(videoHolderId);
  
    if (youtubeTriggers.length) {
      theme.LibraryLoader.load('youtubeSdk');
    }
  
    var modal = new theme.Modals('VideoModal', 'video-modal', {
      closeOffContentClick: true,
      bodyOpenClass: ['modal-open', 'video-modal-open'],
      solid: true
    });
  
    youtubeTriggers.forEach(btn => {
      btn.addEventListener('click', triggerYouTubeModal);
    });
  
    mp4Triggers.forEach(btn => {
      btn.addEventListener('click', triggerMp4Modal);
    });
  
    document.addEventListener('modalClose.VideoModal', closeVideoModal);
  
    function triggerYouTubeModal(evt) {
      // If not already loaded, treat as normal link
      if (!theme.config.youTubeReady) {
        return;
      }
  
      evt.preventDefault();
      emptyVideoHolder();
  
      modal.open(evt);
  
      var videoId = getYoutubeVideoId(evt.currentTarget.getAttribute('href'));
      youtubePlayer = new theme.YouTube(
        videoHolderId,
        {
          videoId: videoId,
          style: 'sound',
          events: {
            onReady: onYoutubeReady
          }
        }
      );
    }
  
    function triggerMp4Modal(evt) {
      emptyVideoHolder();
  
      var el = evt.currentTarget;
      var player = el.parentNode.querySelector(selectors.mp4Player);
  
      // Clone video element and place it in the modal
      var playerClone = player.cloneNode(true);
      playerClone.classList.remove('hide');
  
      videoHolderDiv.append(playerClone);
      modal.open(evt);
  
      // Play new video element
      videoHolderDiv.querySelector('video').play();
    }
  
    function onYoutubeReady(evt) {
      evt.target.unMute();
      evt.target.playVideo();
    }
  
    function getYoutubeVideoId(url) {
      var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
      var match = url.match(regExp);
      return (match&&match[7].length==11)? match[7] : false;
    }
  
    function emptyVideoHolder() {
      videoHolderDiv.innerHTML = '';
    }
  
    function closeVideoModal() {
      if (youtubePlayer && typeof youtubePlayer.destroy === 'function') {
        youtubePlayer.destroy();
      } else {
        emptyVideoHolder();
      }
    }
  };
  
  

  theme.announcementBar = (function() {
    var args = {
      autoPlay: 5000,
      avoidReflow: true,
      cellAlign: theme.config.rtl ? 'right' : 'left'
    };
    var bar;
    var flickity;
  
    function init() {
      bar = document.getElementById('AnnouncementSlider');
      if (!bar) {
        return;
      }
  
      unload();
  
      if (bar.dataset.blockCount === 1) {
        return;
      }
  
      if (theme.config.bpSmall || bar.dataset.compact === 'true') {
        initSlider();
      }
  
      document.addEventListener('matchSmall', function() {
        unload();
        initSlider();
      });
  
      document.addEventListener('unmatchSmall', function() {
        unload();
        if (bar.dataset.compact === 'true') {
          initSlider();
        }
      });
    }
  
    function initSlider() {
      flickity = new theme.Slideshow(bar, args);
    }
  
    // Go to slide if selected in the editor
    function onBlockSelect(id) {
      var slide = bar.querySelector('#AnnouncementSlide-' + id);
      var index = parseInt(slide.dataset.index);
  
      if (flickity && typeof flickity.pause === 'function') {
        flickity.goToSlide(index);
        flickity.pause();
      }
    }
  
    function onBlockDeselect() {
      if (flickity && typeof flickity.play === 'function') {
        flickity.play();
      }
    }
  
    function unload() {
      if (flickity && typeof flickity.destroy === 'function') {
        flickity.destroy();
      }
    }
  
    return {
      init: init,
      onBlockSelect: onBlockSelect,
      onBlockDeselect: onBlockDeselect,
      unload: unload
    };
  })();
  
  theme.customerTemplates = function() {
    checkUrlHash();
    initEventListeners();
    resetPasswordSuccess();
    customerAddressForm();
  
    function checkUrlHash() {
      var hash = window.location.hash;
  
      // Allow deep linking to recover password form
      if (hash === '#recover') {
        toggleRecoverPasswordForm();
      }
    }
  
    function toggleRecoverPasswordForm() {
      var passwordForm = document.getElementById('RecoverPasswordForm').classList.toggle('hide');
      var loginForm = document.getElementById('CustomerLoginForm').classList.toggle('hide');
    }
  
    function initEventListeners() {
      // Show reset password form
      var recoverForm = document.getElementById('RecoverPassword');
      if (recoverForm) {
        recoverForm.addEventListener('click', function(evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }
  
      // Hide reset password form
      var hideRecoverPassword = document.getElementById('HideRecoverPasswordLink');
      if (hideRecoverPassword) {
        hideRecoverPassword.addEventListener('click', function(evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }
    }
  
    function resetPasswordSuccess() {
      var formState = document.querySelector('.reset-password-success');
  
      // check if reset password form was successfully submitted
      if (!formState) {
        return;
      }
  
      // show success message
      document.getElementById('ResetSuccess').classList.remove('hide');
    }
  
    function customerAddressForm() {
      var newAddressForm = document.getElementById('AddressNewForm');
      var addressForms = document.querySelectorAll('.js-address-form');
  
      if (!newAddressForm || !addressForms.length) {
        return;
      }
  
      // Country/province selector can take a short time to load
      setTimeout(function() {
        document.querySelectorAll('.js-address-country').forEach(el => {
          var countryId = el.dataset.countryId;
          var provinceId = el.dataset.provinceId;
          var provinceContainerId = el.dataset.provinceContainerId;
  
          new Shopify.CountryProvinceSelector(
            countryId,
            provinceId,
            {
              hideElement: provinceContainerId
            }
          );
        });
      }, 1000);
  
      // Toggle new/edit address forms
      document.querySelectorAll('.address-new-toggle').forEach(el => {
        el.addEventListener('click', function() {
          newAddressForm.classList.toggle('hide');
        });
      });
  
      document.querySelectorAll('.address-edit-toggle').forEach(el => {
        el.addEventListener('click', function(evt) {
          var formId = evt.currentTarget.dataset.formId;
          document.getElementById('EditAddress_' + formId).classList.toggle('hide');
        });
      });
  
      document.querySelectorAll('.address-delete').forEach(el => {
        el.addEventListener('click', function(evt) {
          var formId = evt.currentTarget.dataset.formId;
          var confirmMessage = evt.currentTarget.dataset.confirmMessage;
  
          if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
            if (Shopify) {
              Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
            }
          }
        })
      });
    }
  };
  
  theme.CartDrawer = (function() {
    var selectors = {
      drawer: '#CartDrawer',
      form: '#CartDrawerForm'
    };
  
    function CartDrawer() {
      this.form = document.querySelector(selectors.form);
      this.drawer = new theme.Drawers('CartDrawer', 'cart');
  
      this.init();
    }
  
    CartDrawer.prototype = Object.assign({}, CartDrawer.prototype, {
      init: function() {
        this.cartForm = new theme.CartForm(this.form);
        this.cartForm.buildCart();
  
        document.addEventListener('ajaxProduct:added', function(evt) {
          this.cartForm.buildCart();
          this.open();
        }.bind(this));
  
        // Dev-friendly way to open cart
        document.addEventListener('cart:open', this.open.bind(this));
        document.addEventListener('cart:close', this.close.bind(this));
      },
  
      open: function() {      
        this.drawer.open();
      },
  
      close: function() {
        this.drawer.close();
      }
    });
  
    return CartDrawer;
  })();
  
  theme.headerNav = (function() {
    var selectors = {
      wrapper: '#HeaderWrapper',
      siteHeader: '#SiteHeader',
      searchBtn: '.js-search-header',
      closeSearch: '#SearchClose',
      searchContainer: '.site-header__search-container',
      logo: '#LogoContainer img',
      megamenu: '.megamenu',
      navItems: '.site-nav__item',
      navLinks: '.site-nav__link',
      navLinksWithDropdown: '.site-nav__link--has-dropdown',
      navDropdownLinks: '.site-nav__dropdown-link--second-level'
    };
  
    var classes = {
      hasDropdownClass: 'site-nav--has-dropdown',
      hasSubDropdownClass: 'site-nav__deep-dropdown-trigger',
      dropdownActive: 'is-focused'
    };
  
    var config = {
      namespace: '.siteNav',
      wrapperOverlayed: false,
      overlayedClass: 'is-light',
      overlayEnabledClass: 'header-wrapper--sticky',
      stickyEnabled: false,
      stickyActive: false,
      stickyClass: 'site-header--stuck',
      stickyHeaderWrapper: 'StickyHeaderWrap',
      openTransitionClass: 'site-header--opening',
      lastScroll: 0
    };
  
    // Elements used in resize functions, defined in init
    var wrapper;
    var siteHeader;
  
    function init() {
      wrapper = document.querySelector(selectors.wrapper);
      siteHeader = document.querySelector(selectors.siteHeader);
  
      config.stickyEnabled = (siteHeader.dataset.sticky === 'true');
      if (config.stickyEnabled) {
        config.wrapperOverlayed = wrapper.classList.contains(config.overlayedClass);
        stickyHeaderCheck();
      }
  
      theme.settings.overlayHeader = (siteHeader.dataset.overlay === 'true');
      // Disable overlay header if on collection template with no collection image
      if (theme.settings.overlayHeader && Shopify && Shopify.designMode) {
        if (document.body.classList.contains('template-collection') && !document.querySelector('.collection-hero')) {
          this.disableOverlayHeader();
        }
      }
  
      accessibleDropdowns();
      searchDrawer();
  
      window.on('load' + config.namespace, resizeLogo);
      window.on('resize' + config.namespace, theme.utils.debounce(150, resizeLogo));
    }
  
    // If the header setting to overlay the menu on the collection image
    // is enabled but the collection setting is disabled, we need to undo
    // the init of the sticky nav
    function disableOverlayHeader() {
      wrapper.classList.remove(config.overlayEnabledClass, config.overlayedClass);
      config.wrapperOverlayed = false;
      theme.settings.overlayHeader = false;
    }
  
    function stickyHeaderCheck() {
      // Disable sticky header if any mega menu is taller than window
      theme.config.stickyHeader = doesMegaMenuFit();
  
      if (theme.config.stickyHeader) {
        config.forceStopSticky = false;
        stickyHeader();
      } else {
        config.forceStopSticky = true;
      }
    }
  
    function doesMegaMenuFit() {
      var largestMegaNav = 0;
      siteHeader.querySelectorAll(selectors.megamenu).forEach(nav => {
        var h = nav.offsetHeight;
        if (h > largestMegaNav) {
          largestMegaNav = h;
        }
      });
  
      // 120 ~ space of visible header when megamenu open
      if (window.innerHeight < (largestMegaNav + 120)) {
        return false;
      }
  
      return true;
    }
  
    function stickyHeader() {
      config.lastScroll = 0;
  
      var wrapWith = document.createElement('div');
      wrapWith.id = config.stickyHeaderWrapper;
      theme.utils.wrap(siteHeader, wrapWith);
  
      stickyHeaderHeight();
  
      window.on('resize' + config.namespace, theme.utils.debounce(50, stickyHeaderHeight));
      window.on('scroll' + config.namespace, theme.utils.throttle(20, stickyHeaderScroll));
      window.on('scroll' + config.namespace, theme.utils.throttle(50, stickyHeaderHeight));
  
      // This gets messed up in the editor, so here's a fix
      if (Shopify && Shopify.designMode) {
        setTimeout(function() {
          stickyHeaderHeight();
        }, 250);
      }
    }
  
    function stickyHeaderHeight() {
      if (!config.stickyEnabled) {
        return;
      }
      var h = siteHeader.offsetHeight;
      var stickyHeader = document.querySelector('#' + config.stickyHeaderWrapper);
      stickyHeader.style.height = h + 'px';
    }
  
    function stickyHeaderScroll() {
      if (!config.stickyEnabled) {
        return;
      }
  
      if (config.forceStopSticky) {
        return;
      }
  
      requestAnimationFrame(scrollHandler);
  
      config.lastScroll = window.scrollY;
    }
  
    function scrollHandler() {
      if (window.scrollY > 250) {
        if (config.stickyActive) {
          return;
        }
  
        config.stickyActive = true;
  
        siteHeader.classList.add(config.stickyClass);
        if (config.wrapperOverlayed) {
          wrapper.classList.remove(config.overlayedClass);
        }
  
        // Add open transition class after element is set to fixed
        // so CSS animation is applied correctly
        setTimeout(function() {
          siteHeader.classList.add(config.openTransitionClass);
        }, 100);
      } else {
        if (!config.stickyActive) {
          return;
        }
  
        config.stickyActive = false;
  
        siteHeader.classList.remove(config.openTransitionClass);
        siteHeader.classList.remove(config.stickyClass);
        if (config.wrapperOverlayed) {
          wrapper.classList.add(config.overlayedClass);
        }
      }
    }
  
    function accessibleDropdowns() {
      var hasActiveDropdown = false;
      var hasActiveSubDropdown = false;
      var closeOnClickActive = false;
  
      // Touch devices open dropdown on first click, navigate to link on second
      if (theme.config.isTouch) {
        document.querySelectorAll(selectors.navLinksWithDropdown).forEach(el => {
          el.on('touchend' + config.namespace, function(evt) {
            var parent = evt.currentTarget.parentNode;
            if (!parent.classList.contains(classes.dropdownActive)) {
              evt.preventDefault();
              closeDropdowns();
              openFirstLevelDropdown(evt.currentTarget);
            } else {
              window.location.replace(evt.currentTarget.getAttribute('href'));
            }
          });
        });
      }
  
      // Open/hide top level dropdowns
      document.querySelectorAll(selectors.navLinks).forEach(el => {
        el.on('focusin' + config.namespace, accessibleMouseEvent);
        el.on('mouseover' + config.namespace, accessibleMouseEvent);
        el.on('mouseleave' + config.namespace, closeDropdowns);
      });
  
      document.querySelectorAll(selectors.navDropdownLinks).forEach(el => {
        if (theme.config.isTouch) {
          el.on('touchend' + config.namespace, function(evt) {
            var parent = evt.currentTarget.parentNode;
  
            // Open third level menu or go to link based on active state
            if (parent.classList.contains(classes.hasSubDropdownClass)) {
              if (!parent.classList.contains(classes.dropdownActive)) {
                evt.preventDefault();
                closeThirdLevelDropdown();
                openSecondLevelDropdown(evt.currentTarget);
              } else {
                window.location.replace(evt.currentTarget.getAttribute('href'));
              }
            } else {
              // No third level nav, go to link
              window.location.replace(evt.currentTarget.getAttribute('href'));
            }
          });
        }
  
        // Open/hide sub level dropdowns
        el.on('focusin' + config.namespace, function(evt) {
          closeThirdLevelDropdown();
          openSecondLevelDropdown(evt.currentTarget, true);
        })
      });
  
      function accessibleMouseEvent(evt) {
        if (hasActiveDropdown) {
          closeSecondLevelDropdown();
        }
  
        if (hasActiveSubDropdown) {
          closeThirdLevelDropdown();
        }
  
        openFirstLevelDropdown(evt.currentTarget);
      }
  
      // Private dropdown functions
      function openFirstLevelDropdown(el) {
        var parent = el.parentNode;
        if (parent.classList.contains(classes.hasDropdownClass)) {
          parent.classList.add(classes.dropdownActive);
          hasActiveDropdown = true;
        }
  
        if (!theme.config.isTouch) {
          if (!closeOnClickActive) {
            var eventType = theme.config.isTouch ? 'touchend' : 'click';
            closeOnClickActive = true;
            document.documentElement.on(eventType + config.namespace, function() {
              closeDropdowns();
              document.documentElement.off(eventType + config.namespace);
              closeOnClickActive = false;
            }.bind(this));
          }
        }
      }
  
      function openSecondLevelDropdown(el, skipCheck) {
        var parent = el.parentNode;
        if (parent.classList.contains(classes.hasSubDropdownClass) || skipCheck) {
          parent.classList.add(classes.dropdownActive);
          hasActiveSubDropdown = true;
        }
      }
  
      function closeDropdowns() {
        closeSecondLevelDropdown();
        closeThirdLevelDropdown();
      }
  
      function closeSecondLevelDropdown() {
        document.querySelectorAll(selectors.navItems).forEach(el => {
          el.classList.remove(classes.dropdownActive)
        });
      }
  
      function closeThirdLevelDropdown() {
        document.querySelectorAll(selectors.navDropdownLinks).forEach(el => {
          el.parentNode.classList.remove(classes.dropdownActive);
        });
      }
    }
  
    function searchDrawer() {
      document.querySelectorAll(selectors.searchBtn).forEach(btn => {
        btn.addEventListener('click', openSearchDrawer);
      });
  
      document.querySelector(selectors.closeSearch).addEventListener('click', closeSearchDrawer);
    }
  
    function openSearchDrawer(evt) {
      evt.preventDefault();
      evt.stopImmediatePropagation();
      var container = document.querySelector(selectors.searchContainer);
      theme.utils.prepareTransition(container, function() {
        container.classList.add('is-active');
      }.bind(this));
  
      document.documentElement.classList.add('js-drawer-open', 'js-drawer-open--search');
  
      setTimeout(function() {
        theme.a11y.trapFocus({
          container: container,
          namespace: 'header_search',
          elementToFocus: container.querySelector('.site-header__search-input')
        });
      }, 100);
  
      // If sticky is enabled, scroll to top on mobile when close to it
      // so you don't get an invisible search box
      if (theme.config.bpSmall && config.stickyEnabled && config.lastScroll < 300) {
        window.scrollTo(0,0);
      }
  
      // Bind events
      theme.a11y.lockMobileScrolling(config.namespace);
  
      bindSearchEvents();
    }
  
    function closeSearchDrawer(evt) {
      // Do not close if click event came from inside drawer
      if (evt) {
        // evt.path is non-standard, so have fallback
        var path = evt.path || (evt.composedPath && evt.composedPath());
        for (var i = 0; i < path.length; i++) {
          if (path[i].classList) {
            if (path[i].classList.contains('site-header__search-btn')) {
              break;
            }
  
            if (path[i].classList.contains('site-header__search-container')) {
              return;
            }
          }
        }
      }
  
      // deselect any focused form elements
      document.activeElement.blur();
  
      document.documentElement.classList.add('js-drawer-closing');
      document.documentElement.classList.remove('js-drawer-open', 'js-drawer-open--search');
  
      window.setTimeout(function() {
        document.documentElement.classList.remove('js-drawer-closing');
      }.bind(this), 500);
  
      var container = document.querySelector(selectors.searchContainer);
      theme.utils.prepareTransition(container, function() {
        container.classList.remove('is-active');
      }.bind(this));
  
      theme.a11y.removeTrapFocus({
        container: container,
        namespace: 'header_search'
      });
  
      theme.a11y.unlockMobileScrolling(config.namespace);
  
      unbindSearchEvents();
    }
  
    function bindSearchEvents() {
      window.on('keyup' + config.namespace, function(evt) {
        if (evt.keyCode === 27) {
          closeSearchDrawer();
        }
      }.bind(this));
  
      // Clicking out of container closes it
      document.documentElement.on('click' + config.namespace, function(evt) {
        closeSearchDrawer(evt);
      }.bind(this));
    }
  
    function unbindSearchEvents() {
      window.off('keyup' + config.namespace);
      document.documentElement.off('click' + config.namespace);
    }
  
    function resizeLogo(evt) {
      document.querySelectorAll(selectors.logo).forEach(logo => {
        var logoWidthOnScreen = logo.clientWidth;
        var containerWidth = logo.closest('.header-item').clientWidth;
  
        // If image exceeds container, let's make it smaller
        if (logoWidthOnScreen > containerWidth) {
          logo.style.maxWidth = containerWidth;
        }
        else {
          logo.removeAttribute('style')
        }
      });
    }
    return {
      init: init,
      disableOverlayHeader: disableOverlayHeader
    };
  })();
  
  window.onpageshow = function(evt) {
    // Removes unload class when returning to page via history
    if (evt.persisted) {
      document.body.classList.remove('unloading');
      document.querySelectorAll('.cart__checkout').forEach(el => {
        el.classList.remove('btn--loading');
      });
    }
  };
  
  theme.predictiveSearch = (function() {
    var currentString = '';
    var isLoading = false;
    var searchTimeout;
    var namespace = '.predictive';
  
    var selectors = {
      form: '#HeaderSearchForm',
      input: 'input[type="search"]',
      wrapper: '#PredictiveWrapper',
      resultDiv: '#PredictiveResults',
  
      searchButton: '[data-predictive-search-button]'
    };
  
    var cache = {};
    var config = {
      imageSize: 'square'
    }
  
    var classes = {
      isActive: 'predicitive-active'
    };
  
    var keys = {
      up_arrow: 38,
      down_arrow: 40,
      tab: 9
    };
    function initializeSliders() {
      cache.wrapper.querySelectorAll('.grid-product__secondary-image__slider').forEach(slider => {
        let sliderElement = slider.querySelector('[product-grid-secondary-slider]');
        let prevArrow = slider.querySelector('.product-grid-secondary-slider-prev');
        let nextArrow = slider.querySelector('.product-grid-secondary-slider-next');
        let sliderElement_mobile = slider.querySelector('[product-grid-secondary-slider-mobile]');
        let prevArrow_mobile = slider.querySelector('.product-grid-secondary-slider-mobile-prev');
        let nextArrow_mobile = slider.querySelector('.product-grid-secondary-slider-mobile-next');

        if ($(sliderElement).hasClass('slick-initialized')) {
          $(sliderElement).slick('unslick');
        }

        $(sliderElement).slick({
          slidesToScroll: 1,
          slidesToShow: 1,
          arrows: true,
          prevArrow: $(prevArrow),
          nextArrow: $(nextArrow),
          dots: true,
          autoplay: false
        });

        if ($(sliderElement_mobile).hasClass('slick-initialized')) {
          $(sliderElement_mobile).slick('unslick');
        }

        $(sliderElement_mobile).slick({
          slidesToScroll: 1,
          slidesToShow: 1,
          arrows: true,
          prevArrow: $(prevArrow_mobile),
          nextArrow: $(nextArrow_mobile),
          dots: true,
          autoplay: false
        });
      });
    }
  
    function init() {
      // Only some languages support predictive search
      if (document.getElementById('shopify-features')) {
        var supportedShopifyFeatures = JSON.parse(document.getElementById('shopify-features').innerHTML);
        if (!supportedShopifyFeatures.predictiveSearch) {
          return;
        }
      }
  
      cache.wrapper = document.querySelector(selectors.wrapper);
  
      if (!cache.wrapper) {
        return;
      }
  
      config.imageSize = cache.wrapper.dataset.imageSize;
  
      cache.form = document.querySelector(selectors.form);
      cache.form.setAttribute('autocomplete', 'off');
      cache.form.on('submit' + namespace, submitSearch);
  
      cache.input = cache.form.querySelector(selectors.input);
      cache.input.on('keyup' + namespace, handleKeyup);
      cache.input.addEventListener('focus', function () {
        cache.wrapper.classList.remove('hide');
        if (!$('.popular_items_slider_search').hasClass('slick-initialized')) {
          $('.popular_items_slider_search').slick({
            slidesToShow: 4,
            arrows: true,
            responsive: [
              {
                breakpoint: 1200,
                settings: 'unslick',
              },
            ]
          });
        }

        initializeSliders();
        
        var footer = document.querySelector('[predictive-results__footer]');
        if (footer) {
          if (cache.input.value.trim() === "") {
            footer.classList.remove('hide');
          }
        }

        if (cache.input.value.trim() !== '') {
          search();  // Call the existing search function
        }
      });

  
      cache.submit = cache.wrapper.querySelector(selectors.searchButton);
      cache.submit.on('click' + namespace, triggerSearch);
  
      cache.results = document.querySelector(selectors.resultDiv);
    }
    function initPopularItemsSlider() {
      if (!$('.popular_items_slider_search').hasClass('slick-initialized')) {
        $('.popular_items_slider_search').slick({
          slidesToShow: 4,
          arrows: true,
          responsive: [
            { breakpoint: 1200, settings: 'unslick' }
          ]
        });
      }
    }
  
    function reset() {
      cache.wrapper.classList.add('noInputs');
      cache.results.innerHTML = '';
      clearTimeout(searchTimeout);

      var footer = document.querySelector('[predictive-results__footer]');
      if (footer) {
        footer.classList.remove('hide');
      }
       initPopularItemsSlider();
       initializeSliders();
    }
  
    function triggerSearch() {
      cache.form.submit();
    }
  
    // Append * wildcard to search
    function submitSearch(evt) {
      evt.preventDefault ? evt.preventDefault() : evt.returnValue = false;
  
      var obj = {};
      var formData = new FormData(evt.target);
      for (var key of formData.keys()) {
        obj[key] = formData.get(key);
      }
  
      if (obj.q) {
        obj.q += '*';
      }
  
      var params = paramUrl(obj);
  
      window.location.href = '/search?' + params;
      return false;
    }
  
    function handleKeyup(evt) {
      if (evt.keyCode === keys.up_arrow) {
        return;
      }
  
      if (evt.keyCode === keys.down_arrow) {
        return;
      }
  
      if (evt.keyCode === keys.tab) {
        return;
      }
  
      search();
    }
  
    function search() {
      var keyword = cache.input.value;
  
      if (keyword === '') {
        reset();
        return;
      }
  
      var q = _normalizeQuery(keyword);
  
      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(
        function () {
          predictQuery(q);
        }.bind(this),
        500
      );
    }
  
    function predictQuery(q) {
      if (isLoading) {
        return;
      }
  
      // Do not re-search the same thing
      if (currentString === q) {
        return;
      }
  
      currentString = q;
      isLoading = true;
  
      var searchObj = {
        'q': q,
        'resources[type]': theme.settings.predictiveSearchType,
        'resources[limit]': 8,
        'resources[limit_scope]': 'each',
        'resources[options][unavailable_products]': 'last',
        'resources[options][fields]': 'title,product_type,variants.title'
      };
  
      var params = paramUrl(searchObj);
  
      // fetch('/search/suggest.json?' + params)
      // .then(response => response.json())
      // .then(suggestions => {
      //   isLoading = false;
      //   var data = {};
      //   var resultCount = 0;
  
      //   cache.wrapper.classList.remove('hide');
      //   var resultTypes = Object.entries(suggestions.resources.results);
  
      //   Object.keys(resultTypes).forEach(function (i) {
      //     var obj = resultTypes[i];
      //     var type = obj[0];
      //     var results = obj[1];
      //     resultCount += results.length;
  
      //     switch(type) {
      //       case 'products':
      //         data[type] = buildProducts(results);
      //         break;
      //       case 'collections':
      //         data[type] = buildCollections(results);
      //         break;
      //       case 'pages':
      //         data[type] = buildPages(results);
      //         break;
      //       case 'articles':
      //         data[type] = buildArticles(results);
      //         break;
      //     }
      //   });
  
      //   if (resultCount === 0) {
      //     reset();
      //     return;
      //   }
  
      //   // Build and append result markup
      //   var output = buildOutput(data);
      //   console.log("output0----", output);
      //   cache.results.innerHTML = '';
        
      //   cache.results.innerHTML = output;
      // });
      fetch('/search/suggest.json?' + params)
          .then(response => response.json())
          .then(suggestions => {
            isLoading = false;
            var data = {};
            var resultCount = 0;

            // 
            

            cache.wrapper.classList.remove('noInputs');
            var resultTypes = Object.entries(suggestions.resources.results);

            // Helper: Promises to fetch full product data
            const productHandles = suggestions.resources.results.products?.map(p => p.handle) || [];
            const fullProductDataPromise = Promise.all(
              productHandles.map(handle =>
                fetch(`/products/${handle}.js`).then(res => res.json())
              )
            );

            // Process all other types (like collections)
            resultTypes.forEach(function ([type, results]) {
              if (type === 'collections') {
                resultCount += results.length;
                data[type] = buildCollections(results);
              }
            });

            fullProductDataPromise.then(fullProducts => {
              if (fullProducts.length > 0) {
                resultCount += fullProducts.length;
                data['products'] = buildProducts(fullProducts); 
              }

              if (resultCount === 0) {
                cache.results.innerHTML = `
                  <div class="predictive__no-results">
                    Sorry, there are no results found for '<strong>${cache.input.value}</strong>'. Why not browse our popular items and trending categories instead?
                  </div>
                `;
                
                var footer = document.querySelector('[predictive-results__footer]');
                if (footer) {
                  footer.classList.remove('hide');
                }

                initPopularItemsSlider();
                initializeSliders();
                return;
              }

              // ✅ Build and append result markup
              var output = buildOutput(data);

              cache.results.innerHTML = '';
              cache.results.innerHTML = output;

              var footer = document.querySelector('[predictive-results__footer]');
              if (footer) {
                footer.classList.add('hide');
              }

              // ✅ Fetch total result count from normal search page
              fetch('/search?q=' + encodeURIComponent(cache.input.value))
                .then(res => res.text())
                .then(html => {
                  var parser = new DOMParser();
                  var doc = parser.parseFromString(html, 'text/html');
                  var resultHeader = doc.querySelector('[data-search-resultscount]');
                  console.log(resultHeader,"resultHeader")
                  if (resultHeader) {
                    var totalCount = resultHeader.getAttribute('data-search-resultscount');
                    var productBlock = cache.results.querySelector('[data-type-products]');

                    if (productBlock) {
                      // Remove existing count
                      var existingCount = productBlock.querySelector('.predictive__count__wrapper');
                      if (existingCount) existingCount.remove();

                      // Create and insert new count
                      var count_wrapper = document.createElement('div');
                      count_wrapper.className = "predictive__count__wrapper";

                      var countEl = document.createElement('div');
                      countEl.className = 'predictive__count heading_right_menu-title';
                      countEl.innerHTML = `RESULTS (${totalCount})`;

                      var countView = document.createElement('div');
                      countView.className = 'predictive__view-all hide-in-desktop';
                      countView.innerHTML = `<a href="/search?q=${encodeURIComponent(cache.input.value)}" class="btn custom-btn custom-btn--secondary">View All</a>`;

                      count_wrapper.appendChild(countEl);
                      count_wrapper.appendChild(countView);
                      productBlock.insertBefore(count_wrapper, productBlock.firstChild);
                    }
                  }
                });
            });
          });
    }
  
    function buildProducts(results) {
      var output = '';
      var products = [];
  
      results.forEach(product => {
        var new_product = {
          title: product.title,
          url: product.url,
          // image_responsive_url: theme.Images.lazyloadImagePath(product.image),
          // image_aspect_ratio: product.featured_image.aspect_ratio
        };
  
        products.push(product);
      });
  
      if (products.length) {
        var outerHTMLBannerMain = null;  // Initialize this variable before the conditional block
        var markup = theme.buildProductGridItem(products, 'small--one-half medium-up--two-quarters medium-up--six-sixths', 8, config.imageSize, true);

        if (products.length <= 2) {
          let bannerElementSearch = document.querySelector('[searchItemBanner]');

          if (bannerElementSearch) {
            let outerHTMLBanner = bannerElementSearch.outerHTML;
            // console.log("updatedBannerHT---", outerHTMLBanner);
            var parser = new DOMParser();
            let outerHTMLBannerHTML = parser.parseFromString(outerHTMLBanner, 'text/html');
            outerHTMLBannerHTML.querySelector("[searchItemBanner]").classList.remove("hide");
            outerHTMLBannerMain = outerHTMLBannerHTML.querySelector("[searchItemBanner]");
          }
        }                  

        const viewAllClass = products.length < 4 ? 'predictive__view-all-left' : '';

        output = `
          <div data-type-products>
            <div class="grid grid--uniform">
              ${markup}
              ${outerHTMLBannerMain ? outerHTMLBannerMain.outerHTML : ''}
            </div>
            <div class="predictive__view-all hide-in-mobile ${viewAllClass}">
              <a href="/search?q=${encodeURIComponent(cache.input.value)}" class="btn custom-btn custom-btn--secondary">View All</a>
            </div>
          </div>
        `;
      }
  
      return output;
    }
  
    function buildCollections(collections) {
      var output = '';
  
      if (collections.length) {
        var markup = theme.buildCollectionItem(collections);
  
        output = `
          <div data-type-collections>
            <p class="h6 predictive__label heading_left_menu-title">${theme.strings.searchResults}</p>
            <ul class="no-bullets heading_left_menu-list">
              ${markup}
            </ul>
          </div>
        `;
      }
  
      return output;
    }
  
    
  
    // Overwrite full sized image returned form API
    // with lazyloading-friendly path
    function buildArticles(articles) {
      var output = '';
  
      articles.forEach(article => {
        if (article.image) {
          article.image = theme.Images.getSizedImageUrl(article.image, '200x200_crop_center');
        }
      });
  
      if (articles.length) {
        var markup = theme.buildArticleItem(articles, config.imageSize);
  
        output = `
          <div data-type-articles>
            <p class="h6 predictive__label">${theme.strings.searchArticles}</p>
            <div class="grid grid--uniform">
              ${markup}
            </div>
          </div>
        `;
      }
  
      return output;
    }
  
    // Combine all search result markup and print to page
    function buildOutput(data) {
      var output = '';
  
      if (data.products && data.products !== '') {
        output += data.products;
      }
  
      if (data.collections && data.collections !== '') {
        output += data.collections;
      }
  
     
      return output;
    }
  
    function _normalizeQuery(string) {
      if (typeof string !== 'string') {
        return null;
      }
  
      return string
        .trim()
        .replace(/\ /g, '-')
        .toLowerCase();
    }
  
    function paramUrl(obj) {
      return Object.keys(obj).map(function(key) {
        return key + '=' + encodeURIComponent(obj[key]);
      }).join('&')
    }
  
    return {
      init: init
    };
  })();
  
  theme.buildProductGridItem = function(items, gridWidth, rowOf, imageSize, disableQuickView = false) {
  var output = '';
  var output_quickView = '';

  items.forEach(product => {
    // Only create quickview markup if not disabled
    if (!disableQuickView) {
      var markup_quickView = `<div id="QuickShopModal-${product.id}" class="modal modal--square modal--quick-shop" data-product-id="${product.id}">
                                <div class="modal__inner">
                                  <div class="modal__centered">
                                    <div class="modal__centered-content">
                                      <div id="QuickShopHolder-${product.handle}"></div>
                                    </div>
                                    <button type="button" class="modal__close js-modal-close text-link">
                                      <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"><path d="M19 17.61l27.12 27.13m0-27.12L19 44.74"/></svg> 
                                    </button>
                                  </div>
                                </div>
                              </div>`;
      output_quickView += markup_quickView;
    }

    var image = theme.buildProductImage(product, imageSize);

    var on_sale = false;
    if (product.compare_at_price > product.price) {
      on_sale = true;
    }

    var has_variant = false;
    if (product.variants && product.variants.length > 1) {
      has_variant = true;
    }

    var markup = `
      <div class="grid__item grid-product-custom grid-product ${gridWidth} aos-animate" data-aos="row-of-${rowOf}" data-product-handle="${product.handle}" data-product-id="${product.id}">
        <div class="grid-product__content">            
          <div class="grid-product__image-mask">
          ${disableQuickView == true 
          ? `<button type="${product.available == false ? 'button' : 'submit'}" name="add" data-add-to-cart class="quick-product__btn product-grid-item-quick-atc-btn add-to-cart" 
                ${product.available == false ? 'disabled="disabled"' : ''} 
                onclick="add_to_cart_grid(${has_variant == false ? product.variants[0].id : product.id},1)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> 
                    <g clip-path="#clip0_583_2511"> <path d="M19.6566 19.5H4.34347C4.15912 19.5 3.98112 19.4327 3.84299 19.3106C3.70485 19.1885 3.61611 19.0202 3.59347 18.8372L2.25753 7.5872C2.24517 7.48165 2.25539 7.37467 2.28751 7.27336C2.31962 7.17204 2.37291 7.07872 2.44382 6.99956C2.51474 6.9204 2.60167 6.85721 2.69885 6.81419C2.79603 6.77117 2.90125 6.7493 3.00753 6.75002H20.9925C21.0988 6.7493 21.204 6.77117 21.3012 6.81419C21.3984 6.85721 21.4853 6.9204 21.5562 6.99956C21.6272 7.07872 21.6804 7.17204 21.7126 7.27336C21.7447 7.37467 21.7549 7.48165 21.7425 7.5872L20.4066 18.8372C20.3839 19.0202 20.2952 19.1885 20.1571 19.3106C20.0189 19.4327 19.8409 19.5 19.6566 19.5Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M8.25 9.75V6C8.25 5.00544 8.64509 4.05161 9.34835 3.34835C10.0516 2.64509 11.0054 2.25 12 2.25C12.9946 2.25 13.9484 2.64509 14.6517 3.34835C15.3549 4.05161 15.75 5.00544 15.75 6V9.75" stroke="white" stroke-linecap="round" stroke-linejoin="round"></path> </g> <defs> <clipPath id="clip0_583_2511"> <rect width="24" height="24" fill="white"></rect> </clipPath> </defs> 
                  </svg>
                </button>`
          : has_variant == true 
            ? `<div class="quick-product__btn quick-product__btn--not-ready  js-modal-open-quick-modal-${product.id}">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <g clip-path="#clip0_583_2511"> 
                      <path d="M19.6566 19.5H4.34347C4.15912 19.5 3.98112 19.4327 3.84299 19.3106C3.70485 19.1885 3.61611 19.0202 3.59347 18.8372L2.25753 7.5872C2.24517 7.48165 2.25539 7.37467 2.28751 7.27336C2.31962 7.17204 2.37291 7.07872 2.44382 6.99956C2.51474 6.9204 2.60167 6.85721 2.69885 6.81419C2.79603 6.77117 2.90125 6.7493 3.00753 6.75002H20.9925C21.0988 6.7493 21.204 6.77117 21.3012 6.81419C21.3984 6.85721 21.4853 6.9204 21.5562 6.99956C21.6272 7.07872 21.6804 7.17204 21.7126 7.27336C21.7447 7.37467 21.7549 7.48165 21.7425 7.5872L20.4066 18.8372C20.3839 19.0202 20.2952 19.1885 20.1571 19.3106C20.0189 19.4327 19.8409 19.5 19.6566 19.5Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M8.25 9.75V6C8.25 5.00544 8.64509 4.05161 9.34835 3.34835C10.0516 2.64509 11.0054 2.25 12 2.25C12.9946 2.25 13.9484 2.64509 14.6517 3.34835C15.3549 4.05161 15.75 5.00544 15.75 6V9.75" stroke="white" stroke-linecap="round" stroke-linejoin="round">
                      </path> 
                    </g> 
                    <defs> 
                      <clipPath id="clip0_583_2511"> 
                        <rect width="24" height="24" fill="white">
                        </rect> 
                      </clipPath> 
                    </defs>
                  </svg>
                </div>`
            : `<button type="${product.available == false ? 'button' : 'submit'}" name="add" data-add-to-cart class="quick-product__btn product-grid-item-quick-atc-btn add-to-cart" 
                  ${product.available == false ? 'disabled="disabled"' : ''} 
                  onclick="add_to_cart_grid(${has_variant == false ? product.variants[0].id : product.id},1)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> 
                    <g clip-path="#clip0_583_2511"> <path d="M19.6566 19.5H4.34347C4.15912 19.5 3.98112 19.4327 3.84299 19.3106C3.70485 19.1885 3.61611 19.0202 3.59347 18.8372L2.25753 7.5872C2.24517 7.48165 2.25539 7.37467 2.28751 7.27336C2.31962 7.17204 2.37291 7.07872 2.44382 6.99956C2.51474 6.9204 2.60167 6.85721 2.69885 6.81419C2.79603 6.77117 2.90125 6.7493 3.00753 6.75002H20.9925C21.0988 6.7493 21.204 6.77117 21.3012 6.81419C21.3984 6.85721 21.4853 6.9204 21.5562 6.99956C21.6272 7.07872 21.6804 7.17204 21.7126 7.27336C21.7447 7.37467 21.7549 7.48165 21.7425 7.5872L20.4066 18.8372C20.3839 19.0202 20.2952 19.1885 20.1571 19.3106C20.0189 19.4327 19.8409 19.5 19.6566 19.5Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M8.25 9.75V6C8.25 5.00544 8.64509 4.05161 9.34835 3.34835C10.0516 2.64509 11.0054 2.25 12 2.25C12.9946 2.25 13.9484 2.64509 14.6517 3.34835C15.3549 4.05161 15.75 5.00544 15.75 6V9.75" stroke="white" stroke-linecap="round" stroke-linejoin="round"></path> </g> <defs> <clipPath id="clip0_583_2511"> <rect width="24" height="24" fill="white"></rect> </clipPath> </defs> 
                  </svg>
                </button>`}            
            ${product.available == false ? '<div class="grid-product__tag grid-product__tag--sold-out">Sold out</div>' : ''}
            ${on_sale == true ? '<div class="grid-product__tag grid-product__tag--sale">Sale</div>' : ''}
            ${window.enable_wishlist == true ? `<wishlist-product wishlist 
              data-id="${product.id}"
              data-title="${product.title}"
              data-handle="${product.url}"
              data-var="${has_variant == false ? product.variants[0].id : product.id}"
              class="wishlist-Product">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <g clip-path="url(#clip0_2155_141790)">
                  <path d="M12 21C12 21 2.25 15.75 2.25 9.5625C2.25 8.21984 2.78337 6.93217 3.73277 5.98277C4.68217 5.03337 5.96984 4.5 7.3125 4.5C9.43031 4.5 11.2444 5.65406 12 7.5C12.7556 5.65406 14.5697 4.5 16.6875 4.5C18.0302 4.5 19.3178 5.03337 20.2672 5.98277C21.2166 6.93217 21.75 8.21984 21.75 9.5625C21.75 15.75 12 21 12 21Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/></path>
                </g>
                <defs>
                  <clipPath id="clip0_2155_141790">
                    <rect width="24" height="24" fill="white"/></rect>
                  </clipPath>
                </defs>
              </svg>
            </wishlist-product>` : ''}
            ${image}
          </div>
          <div class="grid-product__meta">
            <a href="${product.url}" class="grid-product__link">
              <div class="grid-product__title">${product.title}</div>
              <div class="grid-product__price_recently">
                <s>${product.compare_at_price > 0 ? theme.Currency.formatMoney(product.compare_at_price) : ''}</s>
                ${theme.Currency.formatMoney(product.price)}
              </div>
            </a>
          </div>            
        </div>
      </div>
    `;

    output += markup;
  });

  return output;
  }
  
  theme.buildProductQuickVew = function(items) {  
    var output_quickView = '';
    items.forEach(product => {
      var markup_quickView = `<div id="QuickShopModal-${product.id}" class="modal modal--square modal--quick-shop" data-product-id="${product.id}">
                                <div class="modal__inner">
                                  <div class="modal__centered">
                                    <div class="modal__centered-content">
                                      <div id="QuickShopHolder-${product.handle}"></div>
                                    </div>
                              
                                    <button type="button" class="modal__close js-modal-close text-link">
                                      <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"><path d="M19 17.61l27.12 27.13m0-27.12L19 44.74"/></svg> 
                                    </button>
                                  </div>
                                </div>
                              </div>`;
      output_quickView += markup_quickView;
    });
    
    return output_quickView;
  }
  
  theme.buildProductImage = function(product, imageSize) {
    var size = imageSize ? imageSize : theme.settings.productImageSize;
    var output = '';

    if(product.featured_image.url) {
      var image_responsive_url = theme.Images.lazyloadImagePath(product.featured_image.url);
    } else {      
      var image_responsive_url = theme.Images.lazyloadImagePath(product.featured_image);
    }
    if (size === 'natural') {
      output = `
        <div class="image-wrap" style="height: 0; padding-bottom: ${product.image_aspect_ratio}%;">
          <img class="grid-product__image lazyload"
            data-src="${image_responsive_url}"
            data-widths="[180, 360, 540, 720, 900]"
            data-aspectratio="${product.image_aspect_ratio}"
            data-sizes="auto"
            alt="${product.title}">
        </div>`;
    } else {
      var classes = 'lazyload';
      if (!theme.settings.productImageCover) {
        classes += ' grid__image-contain';
      }
      output = `
      <a href="${product.url}" class="grid__image-ratio--product">
        <div class="grid__image-ratio grid__image-ratio--${size}">
          <img class="${classes}"
              data-src="${image_responsive_url}"
              data-widths="[360, 540, 720, 900, 1080]"
              data-aspectratio="${product.aspect_ratio}"
              data-sizes="auto"
              alt="${product.title}">
        </div>
      </a>
      `;
    }
  
    return output;
  }



  theme.hideB2G1OnDefault = function() {
    try {
      let el = document.getElementById("aex-pdp-b2g1-banner");
      el.classList.add("hide")
      let el1 = document.getElementsByClassName("aexb2g1-accordion-b2g1");

      for (let i = 0; i < el1.length; i++) {
        el1[i].classList.add("hide")
      }
    } catch (e) {
      
    }
  }

  theme.updateAnnouncementBar = function(text) {
    let announcements_top = document.getElementsByClassName("announcement-slider__slide")
    for (let i = 0; i < announcements_top.length; i++) {
      if (i != 0) {
        announcements_top[i].remove();
      }
    }
    
    let announcements = document.getElementsByClassName("announcement-text")
    for (let i = 0; i < announcements.length; i++) {
      announcements[i].innerHTML = text;
    }
  }

  theme.updateAnnouncementBaroffer = function(text) {
    let announcements_offer = document.getElementsByClassName("text-slider-wrap_offer")
    for (let i = 0; i < announcements_offer.length; i++) {
      if (i != 0) {
        announcements_offer[i].remove();
      }
    }
    
    let announcementsoffer = document.getElementsByClassName("update_text-slide_offer")
    for (let i = 0; i < announcementsoffer.length; i++) {
      announcementsoffer[i].innerHTML = text;
    }
  }

  theme.updateHomepageBanner = function(desk_img, mob_img, promo_url) {
    if (Cookies.get("BEB_PROMOTION")) {
      if(!window.location.href.includes('pages') && !window.location.href.includes('collections')) {
        
        let promo_grid_img = document.getElementById("aex-hero-desk");
        let promo_grid_img_mobile = document.getElementById("aex-hero-mob");
        let promo_link = document.querySelector(".hero__slide-link");
         
        if(desk_img != 'Null') {
          promo_grid_img.src = desk_img
          promo_grid_img.removeAttribute("data-src");
        }
        if(mob_img != 'Null') {
          promo_grid_img_mobile.src = mob_img
          promo_grid_img_mobile.removeAttribute("data-src");
        }
        if (promo_link && promo_url) {
          promo_link.href = promo_url;
        }
      }
    }
  }
    theme.updateOfferElementInPDP = function(code) {
    var all_elements = document.querySelectorAll('[any-5-product-off]');
    if(code.includes('50')) {
      if(all_elements.length > 0) {
        all_elements.forEach(element => {
          element.classList.remove('hide');
        });
      }
    } else {
      if(all_elements.length > 0) {
        all_elements.forEach(element => {
          if(!element.classList.contains('hide')) {
            element.classList.add('hide');
          }
        });
      }      
    }
  }

   theme.updateCartDrawer = function(code, min_items) {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      let totalQuantity = 0;
      if (cart.items.length > 0) {
        cart.items.forEach(item => {
          if (!item.has_components && item.price > 0) {
            totalQuantity += item.quantity;
          }
        });
      }
      window.cart_items_count = totalQuantity;
      const cartDiscountApply = document.querySelectorAll('.cart__discount-message');
      const cartDiscontNotapply = document.querySelectorAll('.cart__items [any-5-product-off]');


      if (code.includes('50')) {
        const main_any5progessBar = document.getElementById('any5progessBar');
        const main_freeShippingCalculator = document.getElementById('freeShippingCalculator');

        if (main_any5progessBar && main_freeShippingCalculator) {
          main_any5progessBar.classList.remove('hide');
          main_freeShippingCalculator.classList.add('hide');

          const min_items_number = Number(min_items);
          const remaining = min_items_number - window.cart_items_count;
          const progress = Math.min((window.cart_items_count / min_items_number) * 100, 100);
          const progressRounded = Math.round(progress);

          const main_any5progessBar_text = main_any5progessBar.querySelector('#any5progessBarText');
          const main_any5progessBar_after = main_any5progessBar.querySelector('#any5progessBarText_after');
          var main_total_items = main_any5progessBar.querySelector('#any5progessBar-items');
          const main_any5progessBar_bar = main_any5progessBar.querySelector('#any5progessBarMain');

          if (main_any5progessBar_bar) {
            main_any5progessBar_bar.style.width = `${progressRounded}%`;
          }

          if (remaining > 0) {
            main_any5progessBar_text.classList.remove('hide');
            cartDiscountApply.forEach(el => el.classList.add('hide'));
            cartDiscontNotapply.forEach(el => el.classList.remove('hide'));
            if(remaining === 1) {
              main_any5progessBar_text.innerHTML = main_any5progessBar_text.innerHTML.replace('Pieces ', 'Piece ');
              main_any5progessBar_text.innerHTML = main_any5progessBar_text.innerHTML.replace('Stücke ', 'Stück ');
            } else {
              main_any5progessBar_text.innerHTML = main_any5progessBar_text.innerHTML.replace('Piece ', 'Pieces ');
              main_any5progessBar_text.innerHTML = main_any5progessBar_text.innerHTML.replace('Stück ', 'Stücke ');
            }
            var main_total_items = main_any5progessBar.querySelector('#any5progessBar-items');
            if (main_total_items) {
              main_total_items.innerHTML = remaining > 0 ? remaining : 0;
            }
            if(!main_any5progessBar_after.classList.contains('hide')) {
              main_any5progessBar_after.classList.add('hide');
            }
          } else {
            main_any5progessBar_text.classList.add('hide');
            main_any5progessBar_after.classList.remove('hide');
            cartDiscountApply.forEach(el => el.classList.remove('hide'));
            cartDiscontNotapply.forEach(el => el.classList.add('hide'));
          }
        }
      } 
    })
    .catch(error => {
      console.error('Error fetching cart:', error);
    });
}


  theme.updateCollectionBanner = function(deskimg, mobimg) {
    if (Cookies.get("BEB_PROMOTION")) {
      if(window.location.href.includes('collections')) {        
        let promo_grid_text = document.getElementById("promo-grid__content");
        let promo_grid_img = document.getElementById("aex-promo-grid-bg");
        let promo_grid_img_mobile = document.getElementById("aex-promo-grid-bg-mobile");
      
        if (promo_grid_text != null) {
          promo_grid_text.style.display = "none";
        }
  
        let promo_grid__bg_container = document.getElementById("promo-grid__bg_container");
  
         if(promo_grid_img != null && promo_grid_img_mobile != null) {
            let promo_grid_framed = document.getElementsByClassName("promo-grid__container--framed");
      
            if (promo_grid_img != null) {
              if(deskimg != 'Null') {
                promo_grid_img.src = deskimg
              }
              if(mobimg != 'Null') {
                promo_grid_img_mobile.src = mobimg
              }
      
              for(let i = 0; i < promo_grid_framed.length; i++){
                promo_grid_framed[i].classList.remove("promo-grid__container--framed")
              }
            }
         } else {       
            if(deskimg != 'Null') {
              promo_grid__bg_container.style.position = 'static';
              const deskimage = document.createElement("img");
              deskimage.className = "aex-promo-bg-desktop image-fit promo-grid__bg-image promo-grid__bg-image--12345 lazyload";
              deskimage.src = deskimg;  
              deskimage.setAttribute("data-sizes", "auto");                      
              deskimage.id = "aex-promo-grid-bg";
              deskimage.loading = "lazy";
              
              const mobimage = document.createElement("img");
              mobimage.className = "aex-promo-bg-mobile image-fit promo-grid__bg-image promo-grid__bg-image--12345 lazyload";
              mobimage.src = mobimg;  
              mobimage.setAttribute("data-sizes", "auto");                      
              mobimage.id = "aex-promo-grid-bg-mobile";
              mobimage.loading = "lazy";
      
              promo_grid__bg_container.appendChild(deskimage);
              promo_grid__bg_container.appendChild(mobimage);
            }
         }
      }
    }
  }

  theme.updateofferTextPDP = function(text) {
    window.offerTextBebPDP = text;
    let offerTextPDP = document.getElementById("offerTextPDP");
    if(offerTextPDP != null && text.trim() != '') {
      offerTextPDP.innerHTML = text;
    }
  }

 
  theme.buildCollectionItem = function(items) {
    var output = '';
  
    items.forEach(collection => {
      var markup = `
        <li class="heading_left_menu-list-item heading_left_menu-list-item-bubble">
          <a href="${collection.url}">
            ${collection.title}
          </a>
        </li>
      `;
  
      output += markup;
    });
  
    return output;
  }
  
  theme.buildPageItem = function(items) {
    var output = '';
  
    items.forEach(page => {
      var markup = `
        <li>
          <a href="${page.url}">
            ${page.title}
          </a>
        </li>
      `;
  
      output += markup;
    });
  
    return output;
  }
  
  theme.buildArticleItem = function(items, imageSize) {
    var output = '';
  
    items.forEach(article => {
      var image = theme.buildPredictiveImage(article);
      var markup = `
        <div class="grid__item grid-product small--one-half medium-up--one-quarter" data-aos="row-of-4">
          <a href="${article.url}" class="grid-product__link grid-product__link--inline">
            <div class="grid-product__image-mask">
              <div
                class="grid__image-ratio grid__image-ratio--object grid__image-ratio--${imageSize}">
                <div class="predictive__image-wrap">
                  ${image}
                </div>
              </div>
            </div>
            <div class="grid-product__meta">
              ${article.title}
            </div>
          </a>
        </div>
      `;
  
      output += markup;
    });
  
    return output;
  }
  
  theme.buildPredictiveImage = function(obj) {
    var imageMarkup = '';
    if (obj.image) {
      imageMarkup = `<img class="lazyload"
            data-src="${obj.image}"
            data-widths="[360, 540, 720]"
            data-sizes="auto">`;
    }
    return imageMarkup;
  }
  

  theme.Maps = (function() {
    var config = {
      zoom: 14
    };
    var apiStatus = null;
    var mapsToLoad = [];
  
    var errors = {};
  
    var selectors = {
      section: '[data-section-type="map"]',
      map: '[data-map]',
      mapOverlay: '.map-section__overlay'
    };
  
    // Global function called by Google on auth errors.
    // Show an auto error message on all map instances.
    window.gm_authFailure = function() {
      if (!Shopify.designMode) {
        return;
      }
  
      document.querySelectorAll(selectors.section).forEach(section => {
        section.classList.add('map-section--load-error');
      });
  
      document.querySelectorAll(selectors.map).forEach(map => {
        map.parentNode.removeChild(map);
      });
  
      window.mapError(theme.strings.authError);
    };
  
    window.mapError = function(error) {
      var message = document.createElement('div');
      message.classList.add('map-section__error', 'errors', 'text-center');
      message.innerHTML = error;
      document.querySelectorAll(selectors.mapOverlay).forEach(overlay => {
        overlay.parentNode.prepend(message);
      });
      document.querySelectorAll('.map-section__link').forEach(link => {
        link.classList.add('hide');
      });
    };
  
    function Map(container) {
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');
      this.namespace = '.map-' + this.sectionId;
      this.map = container.querySelector(selectors.map);
      this.key = this.map.dataset.apiKey;
  
      errors = {
        addressNoResults: theme.strings.addressNoResults,
        addressQueryLimit: theme.strings.addressQueryLimit,
        addressError: theme.strings.addressError,
        authError: theme.strings.authError
      };
  
      if (!this.key) {
        return;
      }
  
      theme.initWhenVisible({
        element: this.container,
        callback: this.prepMapApi.bind(this),
        threshold: 20
      });
    }
  
    // API has loaded, load all Map instances in queue
    function initAllMaps() {
      mapsToLoad.forEach(instance => {
        instance.createMap();
      });
    }
  
    function geolocate(map) {
      var geocoder = new google.maps.Geocoder();
  
      if (!map) {
        return;
      }
  
      var address = map.dataset.addressSetting;
  
      var deferred = new Promise((resolve, reject) => {
        geocoder.geocode({ address: address }, function(results, status) {
          if (status !== google.maps.GeocoderStatus.OK) {
            reject(status);
          }
          resolve(results);
        });
      });
  
      return deferred;
    }
  
    Map.prototype = Object.assign({}, Map.prototype, {
      prepMapApi: function() {
        if (apiStatus === 'loaded') {
          this.createMap();
        } else {
          mapsToLoad.push(this);
  
          if (apiStatus !== 'loading') {
            apiStatus = 'loading';
            if (typeof window.google === 'undefined' || typeof window.google.maps === 'undefined' ) {
  
              var script = document.createElement('script');
              script.onload = function () {
                apiStatus = 'loaded';
                initAllMaps();
              };
              script.src = 'https://maps.googleapis.com/maps/api/js?key=' + this.key;
              document.head.appendChild(script);
            }
          }
        }
      },
  
      createMap: function() {
        var mapDiv = this.map;
  
        return geolocate(mapDiv)
          .then(
            function(results) {
              var mapOptions = {
                zoom: config.zoom,
                backgroundColor: 'none',
                center: results[0].geometry.location,
                draggable: false,
                clickableIcons: false,
                scrollwheel: false,
                disableDoubleClickZoom: true,
                disableDefaultUI: true
              };
  
              var map = (this.map = new google.maps.Map(mapDiv, mapOptions));
              var center = (this.center = map.getCenter());
  
              var marker = new google.maps.Marker({
                map: map,
                position: map.getCenter()
              });
  
              google.maps.event.addDomListener(
                window,
                'resize',
                theme.utils.debounce(250, function() {
                  google.maps.event.trigger(map, 'resize');
                  map.setCenter(center);
                  mapDiv.removeAttribute('style');
                })
              );
  
              if (Shopify.designMode) {
                if (window.AOS) { AOS.refreshHard() }
              }
            }.bind(this)
          )
          .catch(function(status) {
            var errorMessage;
  
            switch (status) {
              case 'ZERO_RESULTS':
                errorMessage = errors.addressNoResults;
                break;
              case 'OVER_QUERY_LIMIT':
                errorMessage = errors.addressQueryLimit;
                break;
              case 'REQUEST_DENIED':
                errorMessage = errors.authError;
                break;
              default:
                errorMessage = errors.addressError;
                break;
            }
  
            // Show errors only to merchant in the editor.
            if (Shopify.designMode) {
              window.mapError(errorMessage);
            }
          });
      },
  
      onUnload: function() {
        if (this.map.length === 0) {
          return;
        }
        // Causes a harmless JS error when a section without an active map is reloaded
        if (google && google.maps && google.maps.event) {
          google.maps.event.clearListeners(this.map, 'resize');
        }
      }
    });
  
    return Map;
  })();
  
  theme.NewsletterPopup = (function() {
    function NewsletterPopup(container) {
      this.container = container;
      var sectionId = this.container.getAttribute('data-section-id');
      this.cookieName = 'newsletter-' + sectionId;
  
      if (!container) {
        return;
      }
  
      // Prevent popup on Shopify robot challenge page
      if (window.location.pathname === '/challenge') {
        return;
      }
  
      this.data = {
        secondsBeforeShow: container.dataset.delaySeconds,
        daysBeforeReappear: container.dataset.delayDays,
        cookie: Cookies.get(this.cookieName),
        testMode: container.dataset.testMode
      };
  
      this.modal = new theme.Modals('NewsletterPopup-' + sectionId, 'newsletter-popup-modal');
  
      // Open modal if errors or success message exist
      if (container.querySelector('.errors') || container.querySelector('.note--success')) {
        this.modal.open();
      }
  
      // Set cookie as opened if success message
      if (container.querySelector('.note--success')) {
        this.closePopup(true);
        return;
      }
  
      document.addEventListener('modalClose.' + container.id, this.closePopup.bind(this));
  
      if (!this.data.cookie || this.data.testMode === 'true') {
        this.initPopupDelay();
      }
    }
  
    NewsletterPopup.prototype = Object.assign({}, NewsletterPopup.prototype, {
      initPopupDelay: function() {
        if (Shopify && Shopify.designMode) {
          return;
        }
        setTimeout(function() {
          this.modal.open();
        }.bind(this), this.data.secondsBeforeShow * 1000);
      },
  
      closePopup: function(success) {
        // Remove a cookie in case it was set in test mode
        if (this.data.testMode === 'true') {
          Cookies.remove(this.cookieName, { path: '/' });
          return;
        }
  
        var expiry = success ? 200 : this.data.daysBeforeReappear;
        Cookies.set(this.cookieName, 'opened', { path: '/', expires: expiry });
      },
  
      onLoad: function() {
        this.modal.open();
      },
  
      onSelect: function() {
        this.modal.open();
      },
  
      onDeselect: function() {
        this.modal.close();
      }
    });
  
    return NewsletterPopup;
  })();
  
  theme.PasswordHeader = (function() {
    function PasswordHeader() {
      this.init();
    }
  
    PasswordHeader.prototype = Object.assign({}, PasswordHeader.prototype, {
      init: function() {
        if (!document.querySelector('#LoginModal')) {
          return;
        }
  
        var passwordModal = new theme.Modals('LoginModal', 'login-modal', {
          focusIdOnOpen: 'password',
          solid: true
        });
  
        // Open modal if errors exist
        if (document.querySelectorAll('.errors').length) {
          passwordModal.open();
        }
      }
    });
  
    return PasswordHeader;
  })();
  
  theme.Photoswipe = (function() {
    var selectors = {
      trigger: '.js-photoswipe__zoom',
      images: '.photoswipe__image',
      slideshowTrack: '.flickity-viewport ',
      activeImage: '.is-selected'
    };
  
    function Photoswipe(container, sectionId) {
      this.container = container;
      this.sectionId = sectionId;
      this.namespace = '.photoswipe-' + this.sectionId;
      this.gallery;
      this.images;
      this.items;
      this.inSlideshow = false;
  
      if (!container || container.dataset.zoom === 'false') {
        return;
      }
  
      if (container.dataset.hasSlideshow === 'true') {
        this.inSlideshow = true;
      }
  
      this.init();
    }
  
    Photoswipe.prototype = Object.assign({}, Photoswipe.prototype, {
      init: function() {
        this.container.querySelectorAll(selectors.trigger).forEach(trigger => {
          trigger.on('click' + this.namespace, this.triggerClick.bind(this));
        });
      },
  
      triggerClick: function(evt) {
        this.items = this.getImageData();
  
        var image = this.inSlideshow ? this.container.querySelector(selectors.activeImage) : evt.currentTarget;
  
        var index = this.inSlideshow ? this.getChildIndex(image) : image.dataset.index;
  
        this.initGallery(this.items, index);
      },
  
      // Because of image set feature, need to get index based on location in parent
      getChildIndex: function(el) {
        var i = 0;
        while( (el = el.previousSibling) != null ) {
          i++;
        }
  
        // 1-based index required
        return i + 1;
      },
  
      getImageData: function() {
        this.images = this.inSlideshow
                        ? this.container.querySelectorAll(selectors.slideshowTrack + selectors.images)
                        : this.container.querySelectorAll(selectors.images);
  
        var items = [];
        var options = {};
  
        this.images.forEach(el => {
          var item = {
            msrc: el.currentSrc || el.src,
            src: el.getAttribute('data-photoswipe-src'),
            w: el.getAttribute('data-photoswipe-width'),
            h: el.getAttribute('data-photoswipe-height'),
            el: el,
            initialZoomLevel: 0.5
          }
  
          items.push(item);
        });
  
        return items;
      },
  
      initGallery: function(items, index) {
        var pswpElement = document.querySelectorAll('.pswp')[0];
  
        var options = {
          allowPanToNext: false,
          captionEl: false,
          closeOnScroll: false,
          counterEl: false,
          history: false,
          index: index - 1,
          pinchToClose: false,
          preloaderEl: false,
          scaleMode: 'zoom',
          shareEl: false,
          tapToToggleControls: false,
          getThumbBoundsFn: function(index) {
            var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
            var thumbnail = items[index].el;
            var rect = thumbnail.getBoundingClientRect();
            return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
          }
        }
  
        this.gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
  
        this.gallery.init();
        this.gallery.listen('afterChange', this.afterChange.bind(this));
      },
  
      afterChange: function() {
        var index = this.gallery.getCurrentIndex();
        this.container.dispatchEvent(new CustomEvent('photoswipe:afterChange', {
          detail: {
            index: index
          }
        }));
      }
    });
  
    return Photoswipe;
  })();
  
  
  theme.Recommendations = (function() {
    var selectors = {
      placeholder: '.product-recommendations-placeholder',
      sectionClass: ' .product-recommendations',
      productResults: '.grid-product'
    }
  
    function Recommendations(container) {
      this.container = container;
      this.sectionId = container.getAttribute('data-section-id');
      this.url = container.dataset.url;
  
      selectors.recommendations = 'Recommendations-' + this.sectionId;
  
      theme.initWhenVisible({
        element: container,
        callback: this.init.bind(this),
        threshold: 500
      });
    }
  
    Recommendations.prototype = Object.assign({}, Recommendations.prototype, {
      init: function() {
        var section = document.getElementById(selectors.recommendations);
  
        if (!section || section.dataset.enable === 'false') {
          return;
        }
  
        var id = section.dataset.productId;
        var limit = section.dataset.limit;
  
        var url = this.url + '?section_id=product-recommendations&limit='+ limit +'&product_id=' + id;
  
        // When section his hidden and shown, make sure it starts empty
        if (Shopify.designMode) {
          var wrapper = section.querySelector(selectors.sectionClass)
          if (wrapper) {
            wrapper.innerHTML = '';
          }
        }
  
        fetch(url).then(function(response) {
          return response.text();
        }).then(function(html) {
          // Convert the HTML string into a document object
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var div = doc.querySelector(selectors.sectionClass);
          var placeholder = section.querySelector(selectors.placeholder);
          if (!placeholder) {
            return;
          }
  
          placeholder.innerHTML = '';
  
          if (!div) {
            this.container.classList.add('hide');
            return;
          }
  
          placeholder.appendChild(div);
  
          theme.reinitProductGridItem(section);
  
          document.dispatchEvent(new CustomEvent('recommendations:loaded', {
            detail: {
              section: section
            }
          }));
  
          // If no results, hide the entire section
          var results = div.querySelectorAll(selectors.productResults);
          if (results.length === 0) {
            this.container.classList.add('hide');
          }
        }.bind(this));
      }
    });
  
    return Recommendations;
  })();
  
  theme.SlideshowSection = (function() {
  
    var selectors = {
      parallaxContainer: '.parallax-container'
    };
  
    function SlideshowSection(container) {
      this.container = container;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('#Slideshow-' + sectionId);
      this.namespace = '.' + sectionId;
  
      this.initialIndex = 0;
  
      if (!this.slideshow) { return }
  
      // Get shopify-created div that section markup lives in,
      // then get index of it inside its parent
      var sectionEl = container.parentElement;
      var sectionIndex = [].indexOf.call(sectionEl.parentElement.children, sectionEl);
  
      if (sectionIndex === 0) {
        this.init();
      } else {
        theme.initWhenVisible({
          element: this.container,
          callback: this.init.bind(this)
        });
      }
  
    }
  
    SlideshowSection.prototype = Object.assign({}, SlideshowSection.prototype, {
      init: function() {
        var slides = this.slideshow.querySelectorAll('.slideshow__slide');
  
        if (this.container.hasAttribute('data-immediate-load')) {
          this.slideshow.classList.remove('loading', 'loading--delayed');
          this.slideshow.classList.add('loaded');
        } else {
          // Wait for image to load before marking as done
          theme.loadImageSection(this.slideshow);
        }
  
        if (slides.length > 1) {
          var sliderArgs = {
            prevNextButtons: this.slideshow.hasAttribute('data-arrows'),
            pageDots: this.slideshow.hasAttribute('data-dots'),
            fade: true,
            setGallerySize: false,
            initialIndex: this.initialIndex,
            autoPlay: this.slideshow.dataset.autoplay === 'true'
              ? parseInt(this.slideshow.dataset.speed)
              : false
          };
  
          this.flickity = new theme.Slideshow(this.slideshow, sliderArgs);
        } else {
          // Add loaded class to first slide
          slides[0].classList.add('is-selected');
        }
  
        if (this.container.hasAttribute('data-parallax')) {
          // Create new parallax for each slideshow image
          this.container.querySelectorAll(selectors.parallaxContainer).forEach(function(el, i) {
            new theme.Parallax(el, {
              namespace: this.namespace + '-parallax-' + i
            });
          }.bind(this));
        }
      },
  
      forceReload: function() {
        this.onUnload();
        this.init();
      },
  
      onUnload: function() {
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      },
  
      onDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      },
  
      onBlockSelect: function(evt) {
        var slide = this.slideshow.querySelector('.slideshow__slide--' + evt.detail.blockId)
        var index = parseInt(slide.dataset.index);
  
        if (this.flickity && typeof this.flickity.pause === 'function') {
          this.flickity.goToSlide(index);
          this.flickity.pause();
        } else {
          // If section reloads, slideshow might not have been setup yet, wait a second and try again
          this.initialIndex = index;
          setTimeout(function() {
            if (this.flickity && typeof this.flickity.pause === 'function') {
              this.flickity.pause();
            }
          }.bind(this), 1000);
        }
      },
  
      onBlockDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          if (this.flickity.args.autoPlay) {
            this.flickity.play();
          }
        }
      }
    });
  
    return SlideshowSection;
  })();
  
  theme.StoreAvailability = (function() {
    var selectors = {
      drawerOpenBtn: '.js-drawer-open-availability',
      modalOpenBtn: '.js-modal-open-availability',
      productTitle: '[data-availability-product-title]'
    };
  
    function StoreAvailability(container) {
      this.container = container;
      this.baseUrl = container.dataset.baseUrl;
      this.productTitle = container.dataset.productName;
    }
  
    StoreAvailability.prototype = Object.assign({}, StoreAvailability.prototype, {
      updateContent: function(variantId) {
        var variantSectionUrl =
          this.baseUrl +
          '/variants/' +
          variantId +
          '/?section_id=store-availability';
  
        var self = this;
  
        fetch(variantSectionUrl)
          .then(function(response) {
            return response.text();
          })
          .then(function(html) {
            if (html.trim() === '') {
              if(this) { 
              this.container.innerHTML = '';
              }
              return;
            }
  
            self.container.innerHTML = html;
            self.container.innerHTML = self.container.firstElementChild.innerHTML;
  
            // Setup drawer if have open button
            if (self.container.querySelector(selectors.drawerOpenBtn)) {
              self.drawer = new theme.Drawers('StoreAvailabilityDrawer', 'availability');
            }
  
            // Setup modal if have open button
            if (self.container.querySelector(selectors.modalOpenBtn)) {
              self.modal = new theme.Modals('StoreAvailabilityModal', 'availability');
            }
  
            var title = self.container.querySelector(selectors.productTitle);
            if (title) {
              title.textContent = self.productTitle;
            }
          });
      }
    });
  
    return StoreAvailability;
  })();
  
  theme.VideoSection = (function() {
    var selectors = {
      videoParent: '.video-parent-section'
    };
  
    function videoSection(container) {
      this.container = container;
      this.sectionId = container.getAttribute('data-section-id');
      this.namespace = '.video-' + this.sectionId;
      this.videoObject;
  
      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 500
      });
    }
  
    videoSection.prototype = Object.assign({}, videoSection.prototype, {
      init: function() {
        var dataDiv = this.container.querySelector('.video-div');
        if (!dataDiv) {
          return;
        }
        var type = dataDiv.dataset.type;
  
        switch(type) {
          case 'youtube':
            var videoId = dataDiv.dataset.videoId;
            this.initYoutubeVideo(videoId);
            break;
          case 'vimeo':
            var videoId = dataDiv.dataset.videoId;
            this.initVimeoVideo(videoId);
            break;
          case 'mp4':
            this.initMp4Video();
            break;
        }
      },
  
      initYoutubeVideo: function(videoId) {
        this.videoObject = new theme.YouTube(
          'YouTubeVideo-' + this.sectionId,
          {
            videoId: videoId,
            videoParent: selectors.videoParent
          }
        );
      },
  
      initVimeoVideo: function(videoId) {
        this.videoObject = new theme.VimeoPlayer(
          'Vimeo-' + this.sectionId,
          videoId,
          {
            videoParent: selectors.videoParent
          }
        );
      },
  
      initMp4Video: function() {
        var mp4Video = 'Mp4Video-' + this.sectionId;
        var mp4Div = document.getElementById(mp4Video);
        var parent = mp4Div.closest(selectors.videoParent);
  
        if (mp4Div) {
          parent.classList.add('loaded');
  
          var playPromise = document.querySelector('#' + mp4Video).play();
  
          // Edge does not return a promise (video still plays)
          if (playPromise !== undefined) {
            playPromise.then(function() {
                // playback normal
              }).catch(function() {
                mp4Div.setAttribute('controls', '');
                parent.classList.add('video-interactable');
              });
          }
        }
      },
  
      onUnload: function(evt) {
        var sectionId = evt.target.id.replace('shopify-section-', '');
        if (this.videoObject && typeof this.videoObject.destroy === 'function') {
          this.videoObject.destroy();
        }
      }
    });
  
    return videoSection;
  })();
  

  theme.BackgroundImage = (function() {
  
    var selectors = {
      parallaxContainer: '.parallax-container'
    };
  
    function backgroundImage(container) {
      this.container = container;
      if (!container) {
        return;
      }
  
      var sectionId = container.getAttribute('data-section-id');
      this.namespace = '.' + sectionId;
  
      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this)
      });
    }
  
    backgroundImage.prototype = Object.assign({}, backgroundImage.prototype, {
      init: function() {
        if (this.container.dataset && this.container.dataset.parallax) {
          var parallaxContainer = this.container.querySelector(selectors.parallaxContainer);
          var args = {
            namespace: this.namespace + '-parallax',
            desktopOnly: true
          };
  
          theme.parallaxSections[this.namespace] = new theme.Parallax(parallaxContainer, args);
        }
      },
  
      onUnload: function(evt) {
        if (!this.container) { return }
        if (theme.parallaxSections[this.namespace] && typeof theme.parallaxSections[this.namespace].destroy === 'function') {
          theme.parallaxSections[this.namespace].destroy();
        }
        delete theme.parallaxSections[this.namespace];
      }
    });
  
    return backgroundImage;
  })();
  
  theme.Blog = (function() {
  
    function Blog(container) {
      this.tagFilters();
    }
  
    Blog.prototype = Object.assign({}, Blog.prototype, {
      tagFilters: function() {
        var filterBy = document.getElementById('BlogTagFilter');
  
        if (!filterBy) {
          return;
        }
  
        filterBy.addEventListener('change', function() {
          location.href = filterBy.value;
        });
      }
    });
  
    return Blog;
  })();
  
  theme.CollectionHeader = (function() {
    var hasLoadedBefore = false;
  
    function CollectionHeader(container) {
      this.namespace = '.collection-header';
  
      var heroImageContainer = container.querySelector('.collection-hero');
      if (heroImageContainer) {
        if (hasLoadedBefore) {
          this.checkIfNeedReload();
        }
        theme.loadImageSection(heroImageContainer);
  
        if (container.dataset && container.dataset.parallax) {
          var parallaxContainer = container.querySelector('.parallax-container');
          var args = {
            namespace: this.namespace + '-parallax'
          };
          theme.parallaxSections[this.namespace] = new theme.Parallax(parallaxContainer, args);
        }
      } else if (theme.settings.overlayHeader) {
        theme.headerNav.disableOverlayHeader();
      }
  
      hasLoadedBefore = true;
    }
  
    CollectionHeader.prototype = Object.assign({}, CollectionHeader.prototype, {
      // A liquid variable in the header needs a full page refresh
      // if the collection header hero image setting is enabled
      // and the header is set to sticky. Only necessary in the editor.
      checkIfNeedReload: function() {
        if (!Shopify.designMode) {
          return;
        }
  
        if (theme.settings.overlayHeader) {
          var header = document.querySelector('.header-wrapper');
          if (!header.classList.contains('header-wrapper--overlay')) {
            location.reload();
          }
        }
      },
  
      onUnload: function() {
        if (theme.parallaxSections[this.namespace]) {
          theme.parallaxSections[this.namespace].destroy();
          delete theme.parallaxSections[this.namespace];
        }
      }
    });
  
    return CollectionHeader;
  })();
  
  theme.CollectionSidebar = (function() {
    var drawerStyle = false;
    var selectors = {
      sidebar: '#CollectionSidebar',
    };
  
    function CollectionSidebar(container) {
      this.container = container.querySelector(selectors.sidebar);
    }
  
    CollectionSidebar.prototype = Object.assign({}, CollectionSidebar.prototype, {
      init: function() {
        // Do not load when no sidebar exists
        if(!this.container) {
          return;
        }
  
        this.onUnload();
  
        drawerStyle = this.container.dataset.style === 'drawer';
        theme.FilterDrawer = new theme.Drawers('FilterDrawer', 'collection-filters', true);
      },
  
      forceReload: function() {
        this.init();
      },
  
      onSelect: function() {
        if (theme.FilterDrawer) {
          if (!drawerStyle) {
            theme.FilterDrawer.close();
            return;
          }
  
          if (drawerStyle || theme.config.bpSmall) {
            theme.FilterDrawer.open();
          }
        }
      },
  
      onDeselect: function() {
        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }
      },
  
      onUnload: function() {
        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }
      }
    });
  
    return CollectionSidebar;
  })();
  
  theme.Collection = (function() {
    var isAnimating = false;
    var useEndlessScoll = false;
    var useEndlessClick = false;
  
    var selectors = {
      sortSelect: '#SortBy',
      sortbySelect: '#sort_by',
      
  
      colorSwatchImage: '.grid-product__color-image',
      colorSwatch: '.color-swatch--with-image',
  
      collectionGrid: '.collection-grid__wrapper',
      trigger: '.collapsible-trigger',
      sidebar: '#CollectionSidebar',
      filterSidebar: '.collapsible-content--sidebar',
      activeTagList: '.tag-list--active-tags',
      tags: '.tag-list input',
      activeTags: '.tag-list a',
      tagsForm: '.filter-form',
      filters: '.collection-filter',
      priceRange: '.price-range',
    };
  
    var classes = {
      activeTag: 'tag--active',
      removeTagParent: 'tag--remove',
      filterSidebar: 'collapsible-content--sidebar',
      isOpen: 'is-open',
    };
  
    function Collection(container) {
      this.container = container;
      this.sectionId = container.getAttribute('data-section-id');
      this.namespace = '.collection-' + this.sectionId;
      this.sidebar = new theme.CollectionSidebar(container);
      this.ajaxRenderer = new theme.AjaxRenderer({
        sections: [
          {
            sectionId: this.sectionId,
            nodeId: 'CollectionAjaxContent',
          },
        ],
        onReplace: this.onReplaceAjaxContent.bind(this),
        preserveParams: ['q'],
      });
  
      this.init();
    }
  
    Collection.prototype = Object.assign({}, Collection.prototype, {
      init: function() {
        this.initSort();
        this.colorSwatchHovering();
        this.initFilters();
        this.initPriceRange();
        this.initEndlessScroll();
        this.sidebar.init();
      },
  
      initSort: function() {
        this.sortSelect = document.querySelector(selectors.sortSelect);
  
        if (this.sortSelect) {
          this.defaultSort = this.getDefaultSortValue();
          this.sortSelect.on('change' + this.namespace, this.onSortChange.bind(this));
          this.initParams();
        }
        this.sortbySelect = document.querySelector(selectors.sortbySelect);
        if (this.sortbySelect) {
            // document.querySelectorAll('input[name="short_by"]').forEach(radioButton => {
            //    radioButton.addEventListener('change', this.onSortChange.bind(this)); 
            // });
            this.initParams();
        }
      },
  
      initParams: function() {
        this.queryParams = {};
  
        if (location.search.length) {
          var aKeyValue;
          var aCouples = location.search.substr(1).split('&');
          for (var i = 0; i < aCouples.length; i++) {
            aKeyValue = aCouples[i].split('=');
            if (aKeyValue.length > 1) {
              this.queryParams[
                decodeURIComponent(aKeyValue[0])
              ] = decodeURIComponent(aKeyValue[1]);
            }
          }
        }
      },
  
      getSortValue: function() {
        if(this.sortSelect || this.defaultSort){
          return this.sortSelect.value
        }
        else {
           return document.querySelector('[name="short_by"]:checked').value;
        }
      },
    

      getDefaultSortValue: function() {
        return this.sortSelect.getAttribute('data-default-sortby');
      },
  
      onSortChange: function() {
        console.log(this,"this")
        // this.queryParams.sort_by = this.getSortValue();
  
        // if (this.queryParams.page) {
        //   delete this.queryParams.page;
        // }
  
        // window.location.search = new URLSearchParams(Object.entries(this.queryParams));
      },
  
      colorSwatchHovering: function() {
        var colorImages = this.container.querySelectorAll(selectors.colorSwatchImage);
        if (!colorImages.length) {
          return;
        }
  
        this.container.querySelectorAll(selectors.colorSwatch).forEach(swatch => {
          swatch.addEventListener('mouseenter', function() {
            var id = swatch.dataset.variantId;
            var image = swatch.dataset.variantImage;
            var el = document.querySelector('.grid-product__color-image--' + id);
            el.style.backgroundImage = 'url(' + image + ')';
            el.classList.add('is-active');
          });
          swatch.addEventListener('mouseleave', function() {
            var id = swatch.dataset.variantId;
            document.querySelector('.grid-product__color-image--' + id).classList.remove('is-active');
          });
        });
      },
  
      /*====================
        Collection filters
      ====================*/
      initFilters: function() {
        var tags = document.querySelectorAll(selectors.tags);
  
        if (!tags.length) {
          return;
        }
  
        this.bindBackButton();
  
        // Set mobile top value for filters if sticky header enabled
        if (theme.config.stickyHeader) {
          this.setFilterStickyPosition();
  
          window.on('resize', theme.utils.debounce(500, this.setFilterStickyPosition));
        }
  
        document.querySelectorAll(selectors.activeTags).forEach(tag => {
          tag.addEventListener('click', this.tagClick.bind(this));
        });
  
        document.querySelectorAll(selectors.tagsForm).forEach(form => {          
          form.addEventListener('submit', this.onFormSubmit.bind(this));
        });

        document.querySelectorAll(selectors.tagsForm).forEach(form => {
          form.addEventListener('input', this.onInputSelect.bind(this));
        });

        document.querySelectorAll(selectors.tagsForm).forEach(form => {
          form.addEventListener('reset', this.onFormReset.bind(this));
        });

      },
  
      initPriceRange: function() {
        const priceRangeEls = document.querySelectorAll(selectors.priceRange);
        priceRangeEls.forEach((el) => new theme.PriceRange(el, {
          // onChange passes in formData
          onChange: this.renderFromFormData.bind(this),
        }));
      },
  
      tagClick: function(evt) {
        var el = evt.currentTarget;
  
        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }
  
        // Do not ajax-load collection links
        if (el.classList.contains('no-ajax')) {
          return;
        }
  
        evt.preventDefault();
  
        if (isAnimating) {
          return;
        }
  
        isAnimating = true;
  
        const parent = el.parentNode;
        const newUrl = new URL(el.href);
  
        this.renderActiveTag(parent, el);
        // this.updateScroll(true);
        this.startLoading();
        this.renderCollectionPage(newUrl.searchParams);
      },

      onFormReset: function(evt) {
        var el = evt.target;
  
        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }

        // Do not ajax-load collection links
        if (el.classList.contains('no-ajax')) {
          return;
        }
  
        evt.preventDefault();
        if (isAnimating) {
          return;
        }
  
        isAnimating = true;

        const formEl = el.closest('form');
        const formData = new FormData();
  
        // this.renderActiveTag(parent, el);
        // this.updateScroll(true);
        this.startLoading();
        this.renderFromFormData(formData);
      },

      onInputSelect: function(evt) {
        evt.preventDefault();
        var el = evt.target;
        const parent = el.closest('li');
        this.renderActiveTag(parent, el);

        if (!theme.FilterDrawer.isOpen) {
          this.onFormSubmit(evt);
        }
      },
  
      onFormSubmit: function(evt) {
        var el = evt.target;  
        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }
  
        // Do not ajax-load collection links
        if (el.classList.contains('no-ajax')) {
          return;
        }
  
        evt.preventDefault();
        if (isAnimating) {
          return;
        }
  
        isAnimating = true;
  
        // const parent = el.closest('li');

        const formEl = el.closest('form');
        const formData = new FormData(formEl);
  
        // this.updateScroll(true);
        // this.renderActiveTag(parent, el);
        this.startLoading();
        this.renderFromFormData(formData);        
      },
  
      fetchOpenCollasibleFilters: function() {
        return Array.from(
          document.querySelectorAll(
            `${selectors.sidebar} ${selectors.trigger}.${classes.isOpen}`,
          ),
        ).map(trigger => trigger.dataset.collapsibleId);
      },
  
      renderActiveTag: function(parent, el) {
        const textEl = parent.querySelector('.tag__text');
  
        if (parent.classList.contains(classes.activeTag)) {
          parent.classList.remove(classes.activeTag);
        } else {
          parent.classList.add(classes.activeTag);
  
          // If adding a tag, show new tag right away.
          // Otherwise, remove it before ajax finishes
          if (el.closest('li').classList.contains(classes.removeTagParent)) {
            parent.remove();
          } else {
            // Append new tag in both drawer and sidebar
            document.querySelectorAll(selectors.activeTagList).forEach(list => {
              const newTag = document.createElement('li');
              const newTagLink = document.createElement('a');
              newTag.classList.add('tag', 'tag--remove');
              newTagLink.classList.add('btn', 'btn--small');
              newTagLink.innerText = textEl.innerText;
              newTag.appendChild(newTagLink);
  
              list.appendChild(newTag);
            });
          }
        }
      },
  
      renderFromFormData: function(formData) {
        const searchParams = new URLSearchParams(formData);
        this.renderCollectionPage(searchParams);
      },
  
      onReplaceAjaxContent: function(newDom, section) {
        const openCollapsibleIds = this.fetchOpenCollasibleFilters();
  
        openCollapsibleIds.forEach(selector => {
          newDom
            .querySelectorAll(`[data-collapsible-id=${selector}]`)
            .forEach(this.openCollapsible);
        });
  
        document.getElementById(section.nodeId).innerHTML = newDom.getElementById(
          section.nodeId,
        ).innerHTML;
      },
  
      openCollapsible: function(el) {
        if (el.classList.contains(classes.filterSidebar)) {
          el.style.height = 'auto';
        }
  
        el.classList.add(classes.isOpen);
      },
  
      renderCollectionPage: function(searchParams, updateURLHash = true) {
        this.ajaxRenderer
          .renderPage(window.location.pathname, searchParams, updateURLHash)
          .then(() => {
            if (useEndlessScoll) {
              var endlessScroll = new Ajaxinate({
                container: '#AEX-Page-Loop',
                pagination: '#AEX-Pagination',
                loadingText: 'Loading',
                method: 'scroll'
              });

              var el = document.getElementById("AEX-Pagination")
              var el1 = document.getElementById("AEX-NonPagination")
              var el2 = document.getElementById("AEX-Pagination-Click")
              if (el1 != null) { el1.classList.add("hide")}
              if (el2 != null) { el2.classList.add("hide")}
              if (el != null) { el.classList.remove("hide")}
            } else if (useEndlessClick){
              var endlessScroll = new Ajaxinate({
                container: '#AEX-Page-Loop',
                pagination: '#AEX-Pagination-Click',
                loadingText: 'Loading',
                method: 'click'
              });

              var el = document.getElementById("AEX-Pagination")
              var el1 = document.getElementById("AEX-NonPagination")
              var el2 = document.getElementById("AEX-Pagination-Click")
              if (el1 != null) { el1.classList.add("hide")}
              if (el2 != null) { el2.classList.remove("hide")}
              if (el != null) { el.classList.add("hide")}

            } else {
              var el = document.getElementById("AEX-Pagination")
              var el1 = document.getElementById("AEX-NonPagination")
              var el2 = document.getElementById("AEX-Pagination-Click")
              if (el1 != null) { el1.classList.remove("hide")}
              if (el2 != null) { el2.classList.add("hide")}
              if (el != null) { el.classList.add("hide")}

            }

            theme.sections.reinit('collection-template');
            // this.updateScroll(false);
            this.initPriceRange();
            theme.reinitProductGridItem();
            try {
              let els = document.getElementsByClassName("image-wrap-aex-secondary")
              for (let i = 0; i < els.length; i++) {
                els[i].classList.add("hide")
              }
              DoublyGlobalCurrency.convertAll(DoublyGlobalCurrency.currentCurrency, '')
            } catch (e) {

            }


            isAnimating = false;
            
            if(document.querySelectorAll('.aex-call-to-action-collection-list').length > 0){
              updateGiftBox();
            }
            
            $(document).ready(function(){
              $('.collection-carousel').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: true
              });
            });
            
          });
      },

      initEndlessScroll: function() {
        document.addEventListener('collection-endless-scroll', this.endlessScrollHandler.bind(this));
        document.addEventListener('collection-endless-click', this.endlessClickHandler.bind(this));
      },

      endlessScrollHandler: function() {
        useEndlessScoll = true;
        useEndlessClick = false;
        const newUrl = new URL(window.location.href);
        this.renderCollectionPage(newUrl.searchParams);
      },

      endlessClickHandler: function() {
        useEndlessClick = true;
        useEndlessScoll = false;
        const newUrl = new URL(window.location.href);
        this.renderCollectionPage(newUrl.searchParams);
      },
  
      bindBackButton: function() {
        // Ajax page on back button
        window.off('popstate' + this.namespace);
        window.on('popstate' + this.namespace, function(state) {
          if (state) {
            const newUrl = new URL(window.location.href);
            this.renderCollectionPage(newUrl.searchParams, false);
          }
        }.bind(this));
      },
  
      updateScroll: function(animate) {
        var scrollTo;
        if (theme.config.bpSmall) {
          // 60 is ~ height of sticky filters
          scrollTo = document.querySelector('[data-scroll-to]').offsetTop - 60;
        } else {
          scrollTo = document.getElementById('CollectionAjaxResult').offsetTop + 1;
        }
  
        if (theme.config.stickyHeader) {
          var headerHeight = document.querySelector('.site-header').offsetHeight;
          scrollTo = scrollTo - headerHeight;
        }
  
        if (animate) {
          window.scrollTo({top: scrollTo, behavior: 'smooth'});
        } else {
          window.scrollTo({top: scrollTo});
        }
      },
  
      setFilterStickyPosition: function() {
        var headerHeight = document.querySelector('.site-header').offsetHeight;
        document.querySelector(selectors.filters).style.top = headerHeight + 'px';
  
        // Also update top position of sticky sidebar
        var stickySidebar = document.querySelector('.grid__item--sidebar');
        if (stickySidebar) {
          stickySidebar.style.top = headerHeight + 10 + 'px';
        }
      },
  
      forceReload: function() {
        this.init();
      },
  
      startLoading: function() {
        document.querySelector(selectors.collectionGrid).classList.add('unload');
      },
    });
  
    return Collection;
  })();
  
  theme.FooterSection = (function() {
    var selectors = {
      locale: '[data-disclosure-locale]',
      currency: '[data-disclosure-currency]'
    };
  
    function FooterSection(container) {
      this.container = container;
      this.localeDisclosure = null;
      this.currencyDisclosure = null;
  
      this.init();
    }
  
    FooterSection.prototype = Object.assign({}, FooterSection.prototype, {
      init: function() {
        var localeEl = this.container.querySelector(selectors.locale);
        var currencyEl = this.container.querySelector(selectors.currency);
  
        if (localeEl) {
          this.localeDisclosure = new theme.Disclosure(localeEl);
        }
  
        if (currencyEl) {
          this.currencyDisclosure = new theme.Disclosure(currencyEl);
        }
  
        // Change email icon to submit text
        var newsletterInput = document.querySelector('.footer__newsletter-input');
        if (newsletterInput) {
          newsletterInput.addEventListener('keyup', function() {
            newsletterInput.classList.add('footer__newsletter-input--active');
          });
        }
  
        // Re-hook up collapsible box triggers
        theme.collapsibles.init(this.container);
      },
  
      onUnload: function() {
        if (this.localeDisclosure) {
          this.localeDisclosure.destroy();
        }
  
        if (this.currencyDisclosure) {
          this.currencyDisclosure.destroy();
        }
      }
    });
  
    return FooterSection;
  })();
  
  theme.HeaderSection = (function() {
  
    var selectors = {
      locale: '[data-disclosure-locale]',
      currency: '[data-disclosure-currency]'
    };
  
    function HeaderSection(container) {
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');
  
      this.init();
    }
  
    HeaderSection.prototype = Object.assign({}, HeaderSection.prototype, {
      init: function() {
        // Reload any slideshow if header is reloaded to make sure
        // sticky header works as expected
        // (can be anywhere in sections.instance array)
        if (Shopify && Shopify.designMode) {
          theme.sections.reinit('slideshow-section');
  
          // Set a timer to resize the header in case the logo changes size
          setTimeout(function() {
            window.dispatchEvent(new Event('resize'));
          }, 500);
        }
  
        this.initDrawers();
        this.initDisclosures();
        theme.headerNav.init();
        theme.announcementBar.init();
      },
  
      initDisclosures: function() {
        var localeEl = this.container.querySelector(selectors.locale);
        var currencyEl = this.container.querySelector(selectors.currency);
  
        if (localeEl) {
          this.localeDisclosure = new theme.Disclosure(localeEl);
        }
  
        if (currencyEl) {
          this.currencyDisclosure = new theme.Disclosure(currencyEl);
        }
      },
  
      initDrawers: function() {
        theme.NavDrawer = new theme.Drawers('NavDrawer', 'nav');        
        if (theme.settings.cartType === 'drawer') {
          if (!document.body.classList.contains('template-cart')) {
            new theme.CartDrawer();
          }
        }
  
        theme.collapsibles.init(document.getElementById('NavDrawer'));
      },
  
      onBlockSelect: function(evt) {
        theme.announcementBar.onBlockSelect(evt.detail.blockId);
      },
  
      onBlockDeselect: function() {
        theme.announcementBar.onBlockDeselect();
      },
  
      onUnload: function() {
        theme.NavDrawer.close();
        theme.announcementBar.unload();
  
        if (this.localeDisclosure) {
          this.localeDisclosure.destroy();
        }
  
        if (this.currencyDisclosure) {
          this.currencyDisclosure.destroy();
        }
      }
    });
  
    return HeaderSection;
  })();
  
  theme.Product = (function() {
    var videoObjects = {};
  
    var classes = {
      onSale: 'on-sale',
      disabled: 'disabled',
      isModal: 'is-modal',
      loading: 'loading',
      loaded: 'loaded',
      hidden: 'hide',
      interactable: 'video-interactable',
      visuallyHide: 'visually-invisible'
    };
  
    var selectors = {
      productVideo: '.product__video',
      videoParent: '.product__video-wrapper',
      slide: '.product-main-slide',
      currentSlide: '.is-selected',
      startingSlide: '.starting-slide',
      variantType: '.variant-wrapper',
      blocks: '[data-product-blocks]',
      blocksHolder: '[data-blocks-holder]'
    };
  
    function Product(container) {
      this.container = container;
      var sectionId = this.sectionId = container.getAttribute('data-section-id');
      var productId = this.productId = container.getAttribute('data-product-id');
  
      this.inModal = (container.dataset.modal === 'true');
      this.modal;
  
      this.settings = {
        enableHistoryState: container.dataset.history || false,
        namespace: '.product-' + sectionId,
        inventory: false,
        inventoryThreshold: 10,
        modalInit: false,
        hasImages: true,
        imageSetName: null,
        imageSetIndex: null,
        currentImageSet: null,
        imageSize: '620x',
        currentSlideIndex: 0,
        videoLooping: container.dataset.videoLooping
      };
  
      // Overwrite some settings when loaded in modal
      if (this.inModal) {
        this.settings.enableHistoryState = false;
        this.settings.namespace = '.product-' + sectionId + '-modal';
        this.modal = document.getElementById('QuickShopModal-' + productId);
      }
  
      this.selectors = {
        variantsJson: '[data-variant-json]',
        currentVariantJson: '[data-current-variant-json]',
        form: '.product-single__form',
        offerButton: '.offer_button',
  
        media: '[data-product-media-type-model]',
        closeMedia: '.product-single__close-media',
        photoThumbs: '[data-product-thumb]',
        thumbSlider: '[data-product-thumbs]',
        thumbScroller: '.product__thumbs--scroller',
        mainSlider: '[data-product-photos]',
        imageContainer: '[data-product-images]',
        productImageMain: '[data-product-image-main]',
  
        priceWrapper: '[data-product-price-wrap]',
        price: '[data-product-price]',
        comparePrice: '[data-compare-price]',
        savePrice: '[data-save-price]',
        priceA11y: '[data-a11y-price]',
        comparePriceA11y: '[data-compare-price-a11y]',
        unitWrapper: '[data-unit-price-wrapper]',
        unitPrice: '[data-unit-price]',
        unitPriceBaseUnit: '[data-unit-base]',
        sku: '[data-sku]',
        inventory: '[data-product-inventory]',
        incomingInventory: '[data-incoming-inventory]',
        colorLabel: '[data-variant-color-label]',
  
        addToCart: '[data-add-to-cart]',
        addToCartSticky: '[data-add-to-cart-sticky]',
        addToCartText: '[data-add-to-cart-text]',
        addToCartTextSticky: '[data-add-to-cart-text-sticky]',

        originalSelectorId: '[data-product-select]',
        singleOptionSelector: '[data-variant-input]',
        variantColorSwatch: '.variant__input--color-swatch',
  
        availabilityContainer: '[data-store-availability-holder]'
      };
  
      this.cacheElements();
  
      this.firstProductImage = this.cache.mainSlider.querySelector('img');
  
      if (!this.firstProductImage) {
        this.settings.hasImages = false;
      }
  
      var dataSetEl = this.cache.mainSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.settings.imageSetName = dataSetEl.dataset.setName;
      }
  
      this.init();
    }
  
    Product.prototype = Object.assign({}, Product.prototype, {
      init: function() {
        if (this.inModal) {
          this.container.classList.add(classes.isModal);
          document.addEventListener('modalOpen.QuickShopModal-' + this.productId, this.openModalProduct.bind(this));
          document.addEventListener('modalClose.QuickShopModal-' + this.productId, this.closeModalProduct.bind(this));
        }
  
        if (!this.inModal) {
          this.formSetup();
          this.productSetup();
          this.videoSetup();
          this.initProductSlider();
          this.customMediaListners();
          this.addIdToRecentlyViewed();
        }
      },
  
      cacheElements: function() {
        this.cache = {
          form: this.container.querySelector(this.selectors.form),
          mainSlider: this.container.querySelector(this.selectors.mainSlider),
          thumbSlider: this.container.querySelector(this.selectors.thumbSlider),
          thumbScroller: this.container.querySelector(this.selectors.thumbScroller),
          productImageMain: this.container.querySelector(this.selectors.productImageMain),
  
          // Price-related
          priceWrapper: this.container.querySelector(this.selectors.priceWrapper),
          comparePriceA11y: this.container.querySelector(this.selectors.comparePriceA11y),
          comparePrice: this.container.querySelector(this.selectors.comparePrice),
          price: this.container.querySelector(this.selectors.price),
          savePrice: this.container.querySelector(this.selectors.savePrice),
          priceA11y: this.container.querySelector(this.selectors.priceA11y)
        };
      },
  
      formSetup: function() {
        this.initQtySelector();
        this.initAjaxProductForm();
        this.availabilitySetup();
        this.initVariants();
  
        // We know the current variant now so setup image sets
        if (this.settings.imageSetName) {
          this.updateImageSet();
        }
      },
  
      availabilitySetup: function() {
        var container = this.container.querySelector(this.selectors.availabilityContainer);
        if (container) {
          this.storeAvailability = new theme.StoreAvailability(container);
        }
      },
  
      productSetup: function() {
        this.setImageSizes();
        this.initImageZoom();
        this.initModelViewerLibraries();
        this.initShopifyXrLaunch();
  
        if (window.SPR) {SPR.initDomEls();SPR.loadBadges()}
      },
  
      setImageSizes: function() {
        if (!this.settings.hasImages) {
          return;
        }
  
        // Get srcset image src, works on most modern browsers
        // otherwise defaults to settings.imageSize
        var currentImage = this.firstProductImage.currentSrc;
  
        if (currentImage) {
          this.settings.imageSize = theme.Images.imageSize(currentImage);
        }
      },
  
      addIdToRecentlyViewed: function() {
        var handle = this.container.getAttribute('data-product-handle');
        var url = this.container.getAttribute('data-product-url');
        var aspectRatio = this.container.getAttribute('data-aspect-ratio');
        var featuredImage = this.container.getAttribute('data-img-url');
  
        // Remove current product if already in set of recent
        if (theme.recentlyViewed.recent.hasOwnProperty(handle)) {
          delete theme.recentlyViewed.recent[handle];
        }
  
        // Add it back to the end
        theme.recentlyViewed.recent[handle] = {
          url: url,
          aspectRatio: aspectRatio,
          featuredImage: featuredImage
        };
  
        if (theme.config.hasLocalStorage) {
          window.localStorage.setItem('theme-recent', JSON.stringify(theme.recentlyViewed.recent));
        }
      },
  
      initVariants: function() {
        var variantJson = this.container.querySelector(this.selectors.variantsJson);
  
        if (!variantJson) {
          return;
        }
  
        this.variantsObject = JSON.parse(variantJson.innerHTML);
  
        var options = {
          container: this.container,
          enableHistoryState: this.settings.enableHistoryState,
          singleOptionSelector: this.selectors.singleOptionSelector,
          originalSelectorId: this.selectors.originalSelectorId,
          variants: this.variantsObject
        };
  
        var swatches = this.container.querySelectorAll(this.selectors.variantColorSwatch);
        if (swatches.length) {
          swatches.forEach(swatch => {
            swatch.addEventListener('change', function(evt) {
              var color = swatch.dataset.colorName;
              var index = swatch.dataset.colorIndex;
              this.updateColorName(color, index);
            }.bind(this))
          });
        }
  
        this.variants = new theme.Variants(options);
  
        // Product availability on page load
        if (this.storeAvailability) {
          var variant_id = this.variants.currentVariant ? this.variants.currentVariant.id : this.variants.variants[0].id;
  
          this.storeAvailability.updateContent(variant_id);
          this.container.on('variantChange' + this.settings.namespace, this.updateAvailability.bind(this));
        }
  
        this.container.on('variantChange' + this.settings.namespace, this.updateCartButton.bind(this));
        this.container.on('variantImageChange' + this.settings.namespace, this.updateVariantImage.bind(this));
        this.container.on('variantPriceChange' + this.settings.namespace, this.updatePrice.bind(this));
        this.container.on('variantUnitPriceChange' + this.settings.namespace, this.updateUnitPrice.bind(this));
  
        if (this.container.querySelector(this.selectors.sku)) {
          this.container.on('variantSKUChange' + this.settings.namespace, this.updateSku.bind(this));
        }
  
        var inventoryEl = this.container.querySelector(this.selectors.inventory);
        if (inventoryEl) {
          this.settings.inventory = true;
          this.settings.inventoryThreshold = inventoryEl.dataset.threshold;
          this.container.on('variantChange' + this.settings.namespace, this.updateInventory.bind(this));
        }
  
        // Update individual variant availability on each selection
        if (theme.settings.dynamicVariantsEnable) {
          var currentVariantJson = this.container.querySelector(this.selectors.currentVariantJson);
  
          if (currentVariantJson) {
            var variantType = this.container.querySelector(selectors.variantType);
  
            if (variantType) {
              new theme.VariantAvailability({
                container: this.container,
                namespace: this.settings.namespace,
                type: variantType.dataset.type,
                variantsObject: this.variantsObject,
                currentVariantObject: JSON.parse(currentVariantJson.innerHTML)
              });
            }
          }
        }
  
        // image set names variant change listeners
        if (this.settings.imageSetName) {
          var variantWrapper = this.container.querySelector('.variant-input-wrap[data-handle="'+this.settings.imageSetName+'"]');
          if (variantWrapper) {
            this.settings.imageSetIndex = variantWrapper.dataset.index;
            this.container.on('variantChange' + this.settings.namespace, this.updateImageSet.bind(this))
          } else {
            this.settings.imageSetName = null;
          }
        }
      },
  
      initQtySelector: function() {
        this.container.querySelectorAll('.js-qty__wrapper').forEach(el => {
          new theme.QtySelector(el, {
            namespace: '.product'
          });
        });
      },
  
      initAjaxProductForm: function() {
        if (theme.settings.cartType === 'drawer') {
          new theme.AjaxProduct(this.cache.form);
        }
      },
  
      /*============================================================================
        Variant change methods
      ==============================================================================*/
      updateColorName: function(color, index) {
        // Updates on radio button change, not variant.js
        this.container.querySelector(this.selectors.colorLabel + `[data-index="${index}"`).textContent = color;
      },
  
      updateCartButton: function(evt) {
        var variant = evt.detail.variant;
        var cartBtn = this.container.querySelector(this.selectors.addToCart);
        var cartBtnSticky = this.container.querySelector(this.selectors.addToCartSticky);
        var cartBtnText = this.container.querySelector(this.selectors.addToCartText);
        var cartBtnStickyText = this.container.querySelector(this.selectors.addToCartTextSticky);
        var cartBtnStickyVariants = this.container.querySelector('[data-sticky-atc-variant-summary]');

        if (variant) {
         if (cartBtnStickyVariants)  cartBtnStickyVariants.textContent = variant.options.join(" / ")
          if (variant.available) {
            // Available, enable the submit button and change text
            cartBtn.classList.remove(classes.disabled);
            cartBtnSticky.classList.remove(classes.disabled);
            cartBtn.disabled = false;
            cartBtnSticky.disabled = false;
            var defaultText = cartBtnText.dataset.defaultText;
            cartBtnText.textContent = defaultText;
            cartBtnStickyText.textContent = defaultText;
          } else {
            // Sold out, disable the submit button and change text
            cartBtn.classList.add(classes.disabled);
            cartBtnSticky.classList.add(classes.disabled);
            cartBtn.disabled = true;
            cartBtnSticky.disabled = true;
            cartBtnText.textContent = theme.strings.soldOut;
            cartBtnStickyText.textContent = theme.strings.soldOut;
          }
        } else {
          // The variant doesn't exist, disable submit button
          cartBtn.classList.add(classes.disabled);
          cartBtnSticky.classList.add(classes.disabled);
          cartBtn.disabled = true;
          cartBtnSticky.disabled = true;
          cartBtnText.textContent = theme.strings.unavailable;
          cartBtnStickyText.textContent = theme.strings.unavailable;
        }
      },
  
      updatePrice: function(evt) {
        var variant = evt.detail.variant;
  
        if (variant) {
          // Regular price
          this.cache.price.innerHTML = theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat);
  
          // Sale price, if necessary
          if (variant.compare_at_price > variant.price) {
            this.cache.comparePrice.innerHTML = theme.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat);
            this.cache.priceWrapper.classList.remove(classes.hidden);
            this.cache.price.classList.add(classes.onSale);
            this.cache.comparePriceA11y.setAttribute('aria-hidden', 'false');
            this.cache.priceA11y.setAttribute('aria-hidden', 'false');
  
            var savings = variant.compare_at_price - variant.price;
  
            if (theme.settings.saveType == 'percent') {
              savings = Math.round(((savings) * 100) / variant.compare_at_price) + '%';
            } else {
              savings = theme.Currency.formatMoney(savings, theme.settings.moneyFormat);
            }
  
            this.cache.savePrice.classList.remove(classes.hidden);
            this.cache.savePrice.innerHTML = theme.strings.savePrice.replace('[saved_amount]', savings);
          } else {
            if (this.cache.priceWrapper) {
              this.cache.priceWrapper.classList.add(classes.hidden);
            }
            this.cache.savePrice.classList.add(classes.hidden);
            this.cache.price.classList.remove(classes.onSale);
            if (this.cache.comparePriceA11y) {
              this.cache.comparePriceA11y.setAttribute('aria-hidden', 'true');
            }
            this.cache.priceA11y.setAttribute('aria-hidden', 'true');
          }
        }
      },
  
      updateUnitPrice: function(evt) {
        var variant = evt.detail.variant;
  
        if (variant && variant.unit_price) {
          this.container.querySelector(this.selectors.unitPrice).innerHTML = theme.Currency.formatMoney(variant.unit_price, theme.settings.moneyFormat);
          this.container.querySelector(this.selectors.unitPriceBaseUnit).innerHTML = theme.Currency.getBaseUnit(variant);
          this.container.querySelector(this.selectors.unitWrapper).classList.remove(classes.hidden);
        } else {
          this.container.querySelector(this.selectors.unitWrapper).classList.add(classes.hidden);
        }
      },
  
      imageSetArguments: function(variant) {
        var variant = variant ? variant : (this.variants ? this.variants.currentVariant : null);
        if (!variant) return;
  
        var setValue = this.settings.currentImageSet = this.getImageSetName(variant[this.settings.imageSetIndex]);
        var set = this.settings.imageSetName + '_' + setValue;
  
        // Always start on index 0
        this.settings.currentSlideIndex = 0;
  
        // Return object that adds cellSelector to mainSliderArgs
        return {
          cellSelector: '[data-group="'+set+'"]',
          imageSet: set,
          initialIndex: this.settings.currentSlideIndex
        }
      },
  
      updateImageSet: function(evt) {
        // If called directly, use current variant
        var variant = evt ? evt.detail.variant : (this.variants ? this.variants.currentVariant : null);
        if (!variant) {
          return;
        }
  
        var setValue = this.getImageSetName(variant[this.settings.imageSetIndex]);
  
        // Already on the current image group
        if (this.settings.currentImageSet === setValue) {
          return;
        }
  
        this.initProductSlider(variant);
      },
  
      // Show/hide thumbnails based on current image set
      updateImageSetThumbs: function(set) {
        this.cache.thumbSlider.querySelectorAll('.product__thumb-item').forEach(thumb => {
          thumb.classList.toggle(classes.hidden, thumb.dataset.group !== set);
        });
      },
  
      getImageSetName: function(string) {
        return string.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
      },
  
      updateSku: function(evt) {
        var variant = evt.detail.variant;
        var newSku = '';
  
        if (variant) {
          if (variant.sku) {
            newSku = variant.sku;
          }
  
          this.container.querySelector(this.selectors.sku).textContent = newSku;
        }
      },
  
      updateInventory: function(evt) {
        var variant = evt.detail.variant;
  
        // Hide stock if no inventory management or policy is continue
        if (!variant || !variant.inventory_management || variant.inventory_policy === 'continue') {
          this.toggleInventoryQuantity(variant, false);
          this.toggleIncomingInventory(false);
          return;
        }
  
        if (variant.inventory_management === 'shopify' && window.inventories && window.inventories[this.productId]) {
          var variantInventoryObject = window.inventories[this.productId][variant.id];
  
          // Hide stock if policy is continue
          if (variantInventoryObject.policy === 'continue') {
            this.toggleInventoryQuantity(variant, false);
            this.toggleIncomingInventory(false);
            return;
          }
  
          var quantity = variantInventoryObject.quantity;
          var showInventory = true;
          var showIncomingInventory = false;
  
          if (quantity <= 0 || quantity > this.settings.inventoryThreshold) {
            showInventory = false;
          }
  
          this.toggleInventoryQuantity(variant, showInventory, quantity);
  
          // Only show incoming inventory when:
          // - inventory notice itself is hidden
          // - have incoming inventory
          // - current quantity is below theme setting threshold
          if (!showInventory && variantInventoryObject.incoming === 'true' && quantity <= this.settings.inventoryThreshold) {
            showIncomingInventory = true;
          }
  
          this.toggleIncomingInventory(showIncomingInventory, variant.available, variantInventoryObject.next_incoming_date);
        }
      },
  
      updateAvailability: function(evt) {
        var variant = evt.detail.variant;
        if (!variant) {
          return;
        }
  
        this.storeAvailability.updateContent(variant.id);
      },
  
      toggleInventoryQuantity: function(variant, show, qty) {
        if (!this.settings.inventory) {
          show = false;
        }
  
        var el = this.container.querySelector(this.selectors.inventory);
        var salesPoint = el.closest('.product-block');
  
        if (parseInt(qty) <= parseInt(this.settings.inventoryThreshold)) {
          el.parentNode.classList.add('inventory--low')
          el.textContent = theme.strings.stockLabel.replace('[count]', qty);
        } else {
          el.parentNode.classList.remove('inventory--low')
          el.textContent = theme.strings.inStockLabel;
        }
  
        if (variant && variant.available) {
          el.parentNode.classList.remove(classes.hidden);
          if (salesPoint) {
            salesPoint.classList.remove(classes.hidden);
          }
        } else {
          el.parentNode.classList.add(classes.hidden);
          if (salesPoint) {
            salesPoint.classList.add(classes.hidden);
          }
        }
      },
  
      toggleIncomingInventory: function(show, available, date) {
        var el = this.container.querySelector(this.selectors.incomingInventory);
        var salesPoint = el.closest('.product-block');
  
        if (!el) {
          return;
        }
  
        var textEl = el.querySelector('.js-incoming-text');
  
        if (show) {
          var string = available ?
                       theme.strings.willNotShipUntil.replace('[date]', date) :
                       theme.strings.willBeInStockAfter.replace('[date]', date);
  
          if (!date) {
            string = theme.strings.waitingForStock;
          }
  
          el.classList.remove(classes.hidden);
          if (salesPoint) {
            salesPoint.classList.remove(classes.hidden);
          }
          textEl.textContent = string;
        } else {
          el.classList.add(classes.hidden);
        }
      },
  
      /*============================================================================
        Product videos
      ==============================================================================*/
      videoSetup: function() {
        var productVideos = this.cache.mainSlider.querySelectorAll(selectors.productVideo);
  
        if (!productVideos.length) {
          return false;
        }
  
        productVideos.forEach(vid => {
          var type = vid.dataset.videoType;
          if (type === 'youtube') {
            this.initYoutubeVideo(vid);
          } else if (type === 'mp4') {
            this.initMp4Video(vid);
          }
        });
      },
  
      initYoutubeVideo: function(div) {
        videoObjects[div.id] = new theme.YouTube(
          div.id,
          {
            videoId: div.dataset.youtubeId,
            videoParent: selectors.videoParent,
            autoplay: false, // will handle this in callback
            style: div.dataset.videoStyle,
            loop: div.dataset.videoLoop,
            events: {
              onReady: this.youtubePlayerReady.bind(this),
              onStateChange: this.youtubePlayerStateChange.bind(this)
            }
          }
        );
      },
  
      // Comes from YouTube SDK
      // Get iframe ID with evt.target.getIframe().id
      // Then access product video players with videoObjects[id]
      youtubePlayerReady: function(evt) {
        var iframeId = evt.target.getIframe().id;
  
        if (!videoObjects[iframeId]) {
          // No youtube player data
          return;
        }
  
        var obj = videoObjects[iframeId];
        var player = obj.videoPlayer;
  
        if (obj.options.style !== 'sound') {
          player.mute();
        }
  
        obj.parent.classList.remove('loading');
        obj.parent.classList.add('loaded');
  
        // If we have an element, it is in the visible/first slide,
        // and is muted, play it
        if (this._isFirstSlide(iframeId) && obj.options.style !== 'sound') {
          player.playVideo();
        }
      },
  
      _isFirstSlide: function(id) {
        return this.cache.mainSlider.querySelector(selectors.startingSlide + ' ' + '#' + id);
      },
  
      youtubePlayerStateChange: function(evt) {
        var iframeId = evt.target.getIframe().id;
        var obj = videoObjects[iframeId];
  
        switch (evt.data) {
          case -1: // unstarted
            // Handle low power state on iOS by checking if
            // video is reset to unplayed after attempting to buffer
            if (obj.attemptedToPlay) {
              obj.parent.classList.add('video-interactable');
            }
            break;
          case 0: // ended
            if (obj && obj.options.loop === 'true') {
              obj.videoPlayer.playVideo();
            }
            break;
          case 3: // buffering
            obj.attemptedToPlay = true;
            break;
        }
      },
  
      initMp4Video: function(div) {
        videoObjects[div.id] = {
          id: div.id,
          type: 'mp4'
        };
  
        if (this._isFirstSlide(div.id)) {
          this.playMp4Video(div.id);
        }
      },
  
      stopVideos: function() {
        for (var [id, vid] of Object.entries(videoObjects)) {
          if (vid.videoPlayer) {
            if (typeof vid.videoPlayer.stopVideo === 'function') {
              vid.videoPlayer.stopVideo(); // YouTube player
            }
          } else if (vid.type === 'mp4') {
            this.stopMp4Video(vid.id); // MP4 player
          }
        }
      },
  
      _getVideoType: function(video) {
        return video.getAttribute('data-video-type');
      },
  
      _getVideoDivId: function(video) {
        return video.id;
      },
  
      playMp4Video: function(id) {
        var player = this.container.querySelector('#' + id);
        var playPromise = player.play();
  
        if (playPromise !== undefined) {
          playPromise.then(function() {
            // Playing as expected
          })
          .catch(function(error) {
            // Likely low power mode on iOS, show controls
            player.setAttribute('controls', '');
            player.closest(selectors.videoParent).setAttribute('data-video-style', 'unmuted');
          });
        }
      },
  
      stopMp4Video: function(id) {
        var player = this.container.querySelector('#' + id);
        if (player && typeof player.pause === 'function') {
          player.pause();
        }
      },
  
      /*============================================================================
        Product images
      ==============================================================================*/
      initImageZoom: function() {
        var container = this.container.querySelector(this.selectors.imageContainer);
        if (!container) {
          return;
        }
        var imageZoom = new theme.Photoswipe(container, this.sectionId);
        container.addEventListener('photoswipe:afterChange', function(evt) {
          if (this.flickity) {
            this.flickity.goToSlide(evt.detail.index);
          }
        }.bind(this));
      },
  
      getThumbIndex: function(target) {
        return target.dataset.index;
      },
  
      updateVariantImage: function(evt) {
        var variant = evt.detail.variant;
        var sizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_media.preview_image.src, this.settings.imageSize);
  
        var newImage = this.container.querySelector('.product__thumb[data-id="' + variant.featured_media.id + '"]');
        var imageIndex = this.getThumbIndex(newImage);
  
        // If there is no index, slider is not initalized
        if (typeof imageIndex === 'undefined') {
          return;
        }
  
        // Go to that variant image's slide
        if (this.flickity) {
          this.flickity.goToSlide(imageIndex);
        }
      },
  
      initProductSlider: function(variant) {
        // Stop if only a single image, but add active class to first slide
        if (this.cache.mainSlider.querySelectorAll(selectors.slide).length <= 1) {
          var slide = this.cache.mainSlider.querySelector(selectors.slide);
          if (slide) {
            slide.classList.add('is-selected');
          }
          return;
        }
  
        // Destroy slider in preparation of new initialization
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
  
        // If variant argument exists, slideshow is reinitializing because of the
        // image set feature enabled and switching to a new group.
        // currentSlideIndex
        if (!variant) {
          var activeSlide = this.cache.mainSlider.querySelector(selectors.startingSlide);
          this.settings.currentSlideIndex = this._slideIndex(activeSlide);
        }
  
        var mainSliderArgs = {
          adaptiveHeight: true,
          avoidReflow: true,
          initialIndex: this.settings.currentSlideIndex,
          childNav: this.cache.thumbSlider,
          childNavScroller: this.cache.thumbScroller,
          childVertical: this.cache.thumbSlider.dataset.position === 'beside',
          pageDots: true, // mobile only with CSS
          draggable: true,
          wrapAround: true,
          callbacks: {
            onInit: this.onSliderInit.bind(this),
            onChange: this.onSlideChange.bind(this)
          }
        };
  
        // Override default settings if image set feature enabled
        if (this.settings.imageSetName) {
          var imageSetArgs = this.imageSetArguments(variant);
          mainSliderArgs = Object.assign({}, mainSliderArgs, imageSetArgs);
          this.updateImageSetThumbs(mainSliderArgs.imageSet);
        }
  
        this.flickity = new theme.Slideshow(this.cache.mainSlider, mainSliderArgs);
      },
  
      onSliderInit: function(slide) {
        // If slider is initialized with image set feature active,
        // initialize any videos/media when they are first slide
        if (this.settings.imageSetName) {
          this.prepMediaOnSlide(slide);
        }
      },
  
      onSlideChange: function(index) {
        if (!this.flickity) return;
  
        var prevSlide = this.cache.mainSlider.querySelector('.product-main-slide[data-index="'+this.settings.currentSlideIndex+'"]');
  
        // If imageSetName exists, use a more specific selector
        var nextSlide = this.settings.imageSetName ?
                        this.cache.mainSlider.querySelectorAll('.flickity-slider .product-main-slide')[index] :
                        this.cache.mainSlider.querySelector('.product-main-slide[data-index="'+index+'"]');
  
        prevSlide.setAttribute('tabindex', '-1');
        nextSlide.setAttribute('tabindex', 0);
  
        // Pause any existing slide video/media
        this.stopMediaOnSlide(prevSlide);
  
        // Prep next slide video/media
        this.prepMediaOnSlide(nextSlide);
  
        // Update current slider index
        this.settings.currentSlideIndex = index;
      },
  
      stopMediaOnSlide(slide) {
        // Stop existing video
        var video = slide.querySelector(selectors.productVideo);
        if (video) {
          var videoType = this._getVideoType(video);
          var videoId = this._getVideoDivId(video);
          if (videoType === 'youtube') {
            if (videoObjects[videoId].videoPlayer) {
              videoObjects[videoId].videoPlayer.stopVideo();
              return;
            }
          } else if (videoType === 'mp4') {
            this.stopMp4Video(videoId);
            return;
          }
        }
  
        // Stop existing media
        var currentMedia = slide.querySelector(this.selectors.media);
        if (currentMedia) {
          currentMedia.dispatchEvent(
            new CustomEvent('mediaHidden', {
              bubbles: true,
              cancelable: true
            })
          );
        }
      },
  
      prepMediaOnSlide(slide) {
        var video = slide.querySelector(selectors.productVideo);
        if (video) {
          var videoType = this._getVideoType(video);
          var videoId = this._getVideoDivId(video);
          if (videoType === 'youtube') {
            if (videoObjects[videoId].videoPlayer && videoObjects[videoId].options.style !== 'sound') {
              videoObjects[videoId].videoPlayer.playVideo();
              return;
            }
          } else if (videoType === 'mp4') {
            this.playMp4Video(videoId);
          }
        }
  
        var nextMedia = slide.querySelector(this.selectors.media);
        if (nextMedia) {
          nextMedia.dispatchEvent(
            new CustomEvent('mediaVisible', {
              bubbles: true,
              cancelable: true
            })
          );
          slide.querySelector('.shopify-model-viewer-ui__button').setAttribute('tabindex', 0);
          slide.querySelector('.product-single__close-media').setAttribute('tabindex', 0);
        }
      },
  
      _slideIndex: function(el) {
        return el.getAttribute('data-index');
      },
  
      /*============================================================================
        Products when in quick view modal
      ==============================================================================*/
      openModalProduct: function() {
        var initialized = false;
  
        if (!this.settings.modalInit) {
          this.blocksHolder = this.container.querySelector(selectors.blocksHolder);
          var url = this.blocksHolder.dataset.url;
  
          fetch(url).then(function(response) {
            return response.text();
          }).then(function(html) {
            
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var blocks = doc.querySelector(selectors.blocks);
            var root = document.documentElement;

            window.showVariantDrawer = function () {           
              var drawer = document.getElementById("VariantDrawer-modal");
              if (!drawer) return;
              theme.utils.prepareTransition(drawer, function () {
                drawer.classList.add('drawer--is-open');
              });
              root.classList.add('js-drawer-open');
            };

            window.hideVariantDrawer = function () {
              var drawer = document.getElementById("VariantDrawer-modal");
              if (!drawer) return;
              root.classList.remove('js-drawer-open');
              theme.utils.prepareTransition(drawer, function () {
                drawer.classList.remove('drawer--is-open');
              });
            };

            window.isVariantSelected = function (el, title, option) {
              var drawer = document.getElementById("VariantDrawer-modal");
              if (!drawer) return;
              drawer.querySelectorAll('[data-variant-input]').forEach(function (element) {
                var label = element.nextElementSibling;
                if (el === element) {
                  label.innerText = "Selected";
                } else {
                  if (element.classList.contains('disabled') || label.classList.contains('disabled')) {
                    label.innerText = "Out of Stock";
                  } else {
                    label.innerText = "Choose";
                  }
                }
              });

              var selectedBtn = document.getElementById('personalisation-choice-selection-modal');

              setTimeout(function () {
                if (selectedBtn) {
                  selectedBtn.innerText = title + ' - ' + option;
                }
                hideVariantDrawer();
              }, 500);
            };
           
            // Because the same product could be opened in quick view
            // on the page we load the form elements from, we need to
            // update any `id`, `for`, and `form` attributes
            blocks.querySelectorAll('[id]').forEach(el => {
              // Update input `id`
              var val = el.getAttribute('id');
              el.setAttribute('id', val + '-modal');
  
              // Update related label if it exists
              var label = blocks.querySelector(`[for="${val}"]`);
              if (label) {
                label.setAttribute('for', val + '-modal');
              }
  
              // Update any collapsible elements
              var collapsibleTrigger = blocks.querySelector(`[aria-controls="${val}"]`);
              if (collapsibleTrigger) {
                collapsibleTrigger.setAttribute('aria-controls', val + '-modal');
              }
            });
  
            // Update any elements with `form` attribute.
            // Form element already has `-modal` appended
            var form = blocks.querySelector(this.selectors.form);
            var offerButton = blocks.querySelector(this.selectors.offerButton);
            if(window.offerTextBebPDP != null) {
              offerButton.innerHTML = window.offerTextBebPDP;
            }
            var formId = form.getAttribute('id');
            blocks.querySelectorAll('[form]').forEach(el => {
              el.setAttribute('form', formId);
            });
  
            this.blocksHolder.innerHTML = '';
            this.blocksHolder.append(blocks);
            this.blocksHolder.classList.add('product-form-holder--loaded');
  
            this.cacheElements();
  
            this.formSetup();
            this.updateModalProductInventory();
  
            if (Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
  
            // Re-hook up collapsible box triggers
            theme.collapsibles.init(this.container);
  
            document.dispatchEvent(new CustomEvent('quickview:loaded', {
              detail: {
                productId: this.sectionId
              }
            }));
          }.bind(this));
  
          this.productSetup();
          this.videoSetup();


          // Enable product slider in quick view
          // 1. with image sets enabled, make sure we have this.variants before initializing
          // 2. initialize normally, form data not required
          if (this.settings.imageSetName) {
            if (this.variants) {
              this.initProductSlider();
            } else {
              document.addEventListener('quickview:loaded', function(evt) {
                if (evt.detail.productId === this.sectionId) {
                  this.initProductSlider();
                }
              }.bind(this));
            }
          } else {
            this.initProductSlider();
          }
          this.customMediaListners();
          this.addIdToRecentlyViewed();
          this.settings.modalInit = true;
        } else {
          initialized = true;
        }
  
        AOS.refreshHard();
  
        document.dispatchEvent(new CustomEvent('quickview:open', {
          detail: {
            initialized: initialized,
            productId: this.sectionId
          }
        }));
      },
  
      // Recommended products load via JS and don't add variant inventory to the
      // global variable that we later check. This function scrapes a data div
      // to get that info and manually add the values.
      updateModalProductInventory: function() {
        window.inventories = window.inventories || {};
        this.container.querySelectorAll('.js-product-inventory-data').forEach(el => {
          var productId = el.dataset.productId;
          window.inventories[productId] = {};
  
          el.querySelectorAll('.js-variant-inventory-data').forEach(el => {
            window.inventories[productId][el.dataset.id] = {
              'quantity': el.dataset.quantity,
              'policy': el.dataset.policy,
              'incoming': el.dataset.incoming,
              'next_incoming_date': el.dataset.date
            }
          });
        });
      },
  
      closeModalProduct: function() {
        this.stopVideos();
      },
  
      /*============================================================================
        Product media (3D)
      ==============================================================================*/
      initModelViewerLibraries: function() {
        var modelViewerElements = this.container.querySelectorAll(this.selectors.media);
        if (modelViewerElements.length < 1) return;
  
        theme.ProductMedia.init(modelViewerElements, this.sectionId);
      },
  
      initShopifyXrLaunch: function() {
        document.addEventListener(
          'shopify_xr_launch',
          function() {
            var currentMedia = this.container.querySelector(
              this.selectors.productMediaWrapper +
                ':not(.' +
                self.classes.hidden +
                ')'
            );
            currentMedia.dispatchEvent(
              new CustomEvent('xrLaunch', {
                bubbles: true,
                cancelable: true
              })
            );
          }.bind(this)
        );
      },
  
      customMediaListners: function() {
        document.querySelectorAll(this.selectors.closeMedia).forEach(el => {
          el.addEventListener('click', function() {
            var slide = this.cache.mainSlider.querySelector(selectors.currentSlide);
            var media = slide.querySelector(this.selectors.media);
            if (media) {
              media.dispatchEvent(
                new CustomEvent('mediaHidden', {
                  bubbles: true,
                  cancelable: true
                })
              );
            }
          }.bind(this))
        });
  
        var modelViewers = this.container.querySelectorAll('model-viewer');
        if (modelViewers.length) {
          modelViewers.forEach(el => {
            el.addEventListener('shopify_model_viewer_ui_toggle_play', function(evt) {
              this.mediaLoaded(evt);
            }.bind(this));
  
            el.addEventListener('shopify_model_viewer_ui_toggle_pause', function(evt) {
              this.mediaUnloaded(evt);
            }.bind(this));
          });
        }
      },
  
      mediaLoaded: function(evt) {
        this.container.querySelectorAll(this.selectors.closeMedia).forEach(el => {
          el.classList.remove(classes.hidden);
        });
  
        if (this.flickity) {
          this.flickity.setDraggable(false);
        }
      },
  
      mediaUnloaded: function(evt) {
        this.container.querySelectorAll(this.selectors.closeMedia).forEach(el => {
          el.classList.add(classes.hidden);
        });
  
        if (this.flickity) {
          this.flickity.setDraggable(true);
        }
      },
  
      onUnload: function() {
        theme.ProductMedia.removeSectionModels(this.sectionId);
  
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      }
    });
  
    return Product;
  })();
  
  theme.RecentlyViewed = (function() {
    var init = false;
  
    function RecentlyViewed(container) {
      if (!container) {
        return;
      }
  
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');
      this.namespace = '.recently-viewed' + this.sectionId;
      this.gridItemWidth = this.container.getAttribute('data-grid-item-class');
      this.rowOf = this.container.getAttribute('data-row-of');
  
      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 600
      });
    };
  
    RecentlyViewed.prototype = Object.assign({}, RecentlyViewed.prototype, {
      init: function() {
        if (init) {
          return;
        }
  
        init = true;
  
        if (Object.keys(theme.recentlyViewed.recent).length === 0 && theme.recentlyViewed.recent.constructor === Object) {
          // No previous history on page load, so bail
          this.container.classList.add('hide');
          return;
        }
  
        this.outputContainer = document.getElementById('RecentlyViewed-' + this.sectionId);
        this.handle = this.container.getAttribute('data-product-handle');
  
        // Request new product info via JS API
        var promises = [];
        Object.keys(theme.recentlyViewed.recent).forEach(function (handle) {
          if (handle !== 'undefined' && !handle.includes('free')) {
            promises.push(this.getProductInfo(handle));
          }
        }.bind(this));
  
       
        Promise.all(promises).then(function(result) {
          this.setupOutput(result);
          this.captureProductDetails(result);          
          
           var gridSlider = document.querySelector('.recently-grid-slider');
          if (gridSlider) {
            var gridItems = gridSlider.querySelectorAll('.grid__item'); 
            if (gridItems.length > 4 || (window.innerWidth < 767 && gridItems.length >= 1)) {
              $('.recently-grid-slider').slick({
                arrow: false,
                dots: false,
                infinite: false,
                slidesToShow: 4,
                slidesToScroll: 1,
                nextArrow: '<button class="slick-arrow arrow-main arrow-main-next"><img src="https://cdn.shopify.com/s/files/1/0315/5827/1111/files/Vector.png?v=1727415233"></button>',
                prevArrow: '<button class="slick-arrow arrow-main arrow-main-prev"><img src="https://cdn.shopify.com/s/files/1/0315/5827/1111/files/Vector_1.png?v=1727415233"></button>',
                responsive: [
                  {
                    breakpoint: 1024,
                    settings: {
                      dots: false,
                      arrow: false,
                      slidesToShow: 3,
                      slidesToScroll: 1
                    }
                  },
                  {
                    breakpoint: 767,
                    settings: {
                      dots: false,
                      arrow: false,
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      centerMode: true
                    }
                  }
                ]
              });
            }
          }
          theme.initQuickShop();
        }.bind(this));
      },
  
      getProductInfo: function(handle) {
        return new Promise(function(resolve, reject) {
          if (theme.recentlyViewed.productInfo.hasOwnProperty(handle)) {
            resolve(theme.recentlyViewed.productInfo[handle]);
          } else {
            fetch('/products/'+ handle +'.js').then(function(response) {
              return response.text();
            }).then(function(product) {
              resolve(product);
            });
          }
        });
      },
  
      setupOutput: function(products) {
        var allProducts = [];
        var data = {};
        var limit = this.container.getAttribute('data-recent-count');
  
        var i = 0;
  
        Object.keys(products).forEach(function (key) {
          if (!products[key]) {
            return;
          }
          var product = JSON.parse(products[key]);
  
          // Ignore current product
          if (product.handle === this.handle) {
            return;
          }
  
          // Ignore undefined key
          if (typeof product.handle == 'undefined') {
            return;
          }
  
          i++;
  
          // New or formatted properties
          product.url = theme.recentlyViewed.recent[product.handle] ? theme.recentlyViewed.recent[product.handle].url : product.url;
          product.image_responsive_url = theme.recentlyViewed.recent[product.handle].featuredImage;
          product.image_aspect_ratio = theme.recentlyViewed.recent[product.handle].aspectRatio;
  
          // Unit pricing checks first variant
          var firstVariant = product.variants[0];
          if (firstVariant && firstVariant.unit_price) {
            var baseUnit = '';
  
            if (firstVariant.unit_price_measurement) {
              if (firstVariant.unit_price_measurement.reference_value != 1) {
                baseUnit += firstVariant.unit_price_measurement.reference_value + ' ';
              }
              baseUnit += firstVariant.unit_price_measurement.reference_unit;
            }
  
            product.unit_price = theme.Currency.formatMoney(firstVariant.unit_price);
            if (baseUnit != '') {
              product.unit_price += '/' + baseUnit;
            }
          }
  
          allProducts.unshift(product);
        }.bind(this));
  
        if (allProducts.length === 0) {
          this.container.classList.add('hide');
          return;
        }
  
        var productMarkup = theme.buildProductGridItem(allProducts.slice(0, limit), this.gridItemWidth, this.rowOf);
        var productQuickView = theme.buildProductQuickVew(allProducts.slice(0, limit));

        this.outputContainer.innerHTML = productMarkup;
        let span = document.createElement("div");
        span.innerHTML = productQuickView;

        this.outputContainer.after(span);
  
        if (AOS) {
          AOS.refreshHard();
        }
      },
  
      captureProductDetails: function(products) {
        for (var i = 0; i < products.length; i++) {
          var product = products[i];
          theme.recentlyViewed.productInfo[product.handle] = product;
        }
  
        // Add data to session storage to reduce API requests later
        if (theme.config.hasSessionStorage) {
          sessionStorage.setItem('recent-products', JSON.stringify(theme.recentlyViewed.productInfo));
        }
      },
  
      onUnload: function() {
        init = false;
      }
    });
  
    return RecentlyViewed;
  })();
  
  theme.Testimonials = (function() {
    var defaults = {
      adaptiveHeight: true,
      avoidReflow: true,
      pageDots: false,
      prevNextButtons: true
    };
  
    function Testimonials(container) {
      this.container = container;
      this.timeout;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('#Testimonials-' + sectionId);
      this.namespace = '.testimonial-' + sectionId;
  
      if (!this.slideshow) { return }
  
      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 600
      });
    }
  
    Testimonials.prototype = Object.assign({}, Testimonials.prototype, {
      init: function() {
        // Do not wrap when only a few blocks
        if (this.slideshow.dataset.count <= 3) {
          defaults.wrapAround = false;
        }
  
        this.flickity = new theme.Slideshow(this.slideshow, defaults);
  
        // Autoscroll to next slide on load to indicate more blocks
        if (this.slideshow.dataset.count > 2) {
          this.timeout = setTimeout(function() {
            this.flickity.goToSlide(1);
          }.bind(this), 1000);
        }
      },
  
      onUnload: function() {
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      },
  
      onDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      },
  
      onBlockSelect: function(evt) {
        var slide = this.slideshow.querySelector('.testimonials-slide--' + evt.detail.blockId)
        var index = parseInt(slide.dataset.index);
  
        clearTimeout(this.timeout);
  
        if (this.flickity && typeof this.flickity.pause === 'function') {
          this.flickity.goToSlide(index);
          this.flickity.pause();
        }
      },
  
      onBlockDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      }
    });
  
    return Testimonials;
  })();
  

  theme.isStorageSupported = function(type) {
    // Return false if we are in an iframe without access to sessionStorage
    if (window.self !== window.top) {
      return false;
    }

    var testKey = 'test';
    var storage;
    if (type === 'session') {
      storage = window.sessionStorage;
    }
    if (type === 'local') {
      storage = window.localStorage;
    }

    try {
      storage.setItem(testKey, '1');
      storage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  };

  theme.reinitProductGridItem = function(scope) {
    if (AOS) {AOS.refreshHard()}

    theme.initQuickShop();

    if (window.innerWidth < 1550) {
    $('.slick-filter').slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      infinite: false,
      prevArrow: '<button type="button" class="slick-prev"></button>',
      nextArrow: '<button type="button" class="slick-next"></button>',
      responsive: [
         {
          breakpoint: 900,
          settings: {
            slidesToShow: 4.5,
            slidesToScroll: 1,
          }
        },
         {
          breakpoint: 770,
          settings: {
            slidesToShow: 4.5,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 428,
          settings: {
            slidesToShow: 2.5,
            slidesToScroll: 1,
          }
        },
         {
          breakpoint: 378,
          settings: {
            slidesToShow: 2.5,
            slidesToScroll: 1,
          }
        }
      ]
    });
  }

    // Refresh reviews app
    if (window.SPR) {SPR.initDomEls();SPR.loadBadges()}

    // Re-hook up collapsible box triggers
    theme.collapsibles.init();
  };

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/
  theme.config.hasSessionStorage = theme.isStorageSupported('session');
  theme.config.hasLocalStorage = theme.isStorageSupported('local');
  AOS.init({
    easing: 'ease-out-quad',
    once: true,
    offset: 60,
    disableMutationObserver: true
  });

  if (theme.config.hasLocalStorage) {
    theme.recentlyViewed.localStorage = window.localStorage.getItem('theme-recent');

    if (theme.recentlyViewed.localStorage) {
      theme.recentlyViewed.recent = JSON.parse(theme.recentlyViewed.localStorage);
    }
  }

  theme.recentlyViewed.productInfo = theme.config.hasSessionStorage && sessionStorage['recent-products'] ? JSON.parse(sessionStorage['recent-products']) : {};

  // Trigger events when going between breakpoints
  theme.config.bpSmall = matchMedia(theme.config.mediaQuerySmall).matches;
  matchMedia(theme.config.mediaQuerySmall).addListener(function(mql) {
    if (mql.matches) {
      theme.config.bpSmall = true;
      document.dispatchEvent(new CustomEvent('matchSmall'));
    }
    else {
      theme.config.bpSmall = false;
      document.dispatchEvent(new CustomEvent('unmatchSmall'));
    }
  });

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
  }

  // Load generic JS. Also reinitializes when sections are
  // added, edited, or removed in Shopify's editor
  theme.initGlobals = function() {
    theme.collapsibles.init();
    theme.videoModal();
  }

  DOMready(function(){
    theme.initializePromotions();

    theme.sections = new theme.Sections();

    theme.sections.register('slideshow-section', theme.SlideshowSection);
    theme.sections.register('header', theme.HeaderSection);
    theme.sections.register('product', theme.Product);
    theme.sections.register('blog', theme.Blog);
    theme.sections.register('password-header', theme.PasswordHeader);
    theme.sections.register('photoswipe', theme.Photoswipe);
    theme.sections.register('product-recommendations', theme.Recommendations);
    theme.sections.register('background-image', theme.BackgroundImage);
    theme.sections.register('testimonials', theme.Testimonials);
    theme.sections.register('video-section', theme.VideoSection);
    theme.sections.register('map', theme.Maps);
    theme.sections.register('footer-section', theme.FooterSection);
    theme.sections.register('store-availability', theme.StoreAvailability);
    theme.sections.register('recently-viewed', theme.RecentlyViewed);
    theme.sections.register('newsletter-popup', theme.NewsletterPopup);
    theme.sections.register('collection-header', theme.CollectionHeader);
    theme.sections.register('collection-template', theme.Collection);

    theme.initGlobals();
    theme.initQuickShop();
    theme.rteInit();

    if (document.body.classList.contains('template-cart')) {
      var cartPageForm = document.getElementById('CartPageForm');
      if (cartPageForm) {
        new theme.CartForm(cartPageForm);
      }
    }

    if (theme.settings.predictiveSearch) {
      theme.predictiveSearch.init();
    }

    if (theme.settings.isCustomerTemplate) {
      theme.customerTemplates();
    }

    document.dispatchEvent(new CustomEvent('page:loaded'));
  });

})(); 

(function() {

  var addToCartAddon = function() {
    $(document).on('click','.addtocart__addon',function(e){
      e.preventDefault();
      var id = $(this).data('id');
      $.ajax({
        type:"post",
        dataType: "json",
        url: '/cart/add.js',
        data:{quantity:1,id:id},
        success: function(data){
          // console.log(data.id);
          new theme.CartDrawer();
//           $('.ajaxcart__addons[data-id="addOn-'+data.id+'"]').hide();
        }
      });
    });
    
  };

  addToCartAddon();

  $(document).on('shopify:section:load', function(event) { 
    addToCartAddon();
  });
}());

if (window.matchMedia("(max-width: 768px)").matches) {
  let promoBox_main = document.querySelector('#aex-pdp-b2g1-banner');
  if(promoBox_main) {
    let promoBox = document.querySelector('#aex-pdp-b2g1-banner').outerHTML;
    if(promoBox && document.querySelector('.mobile-view_acco-banner')){
      document.querySelector('#aex-pdp-b2g1-banner').remove()
      document.querySelector('.mobile-view_acco-banner').innerHTML = promoBox;
    }
  }
  
} 
// 70% off popup for all visitors
var t = _template.suffix;
if(t == 'summer-deal-necklaces' || t == 'summer-deal-any-5-mu-2' || t == 'summer-deal-any-5' || t == 'bf-any-5-new-arrivals-2-1' || t == 'bf-any-5-new-arrivals-1' || t == 'any-5-new-arrivals-4' || t == 'any-5-new-arrivals-3' || t == 'any-5-floral-pink' || t == 'any-5-manual-sort-1' || t == 'any-5-manual-sort-2' || t == 'any-5-manual-sort-3' || t == 'silver-focus-any-5-deal' || t == 'any-5-manual-sort-4' || t == 'any-5-manual-sort-5' || t == 'waterproof-any-5-v2' || t == 'summer-deal-any-5-images-carousel' || t == 'any-12-summer24-advent-v1' ){
    window.optinmonster = 'true'
} 
document.addEventListener("DOMContentLoaded", function() {
  var bannerElement = document.querySelector('.aex-pdp-b2g1-banner');
  var productBlockImages = document.querySelector('.product_block_images');

  if (bannerElement && !bannerElement.classList.contains('hide')) {
    if (productBlockImages) {
      productBlockImages.classList.add('hide');
    }
  }
});
document.addEventListener("DOMContentLoaded", function() {
  var offerElements = document.querySelectorAll('.aexb2g1-accordion-b2g1');
  
  offerElements.forEach(function(offerElement) {
    var customElement = offerElement.closest('.aexb2g1-accordion').querySelector('.aexb2g1-accordion-b2g1-custom');
    
    if (!offerElement.classList.contains('hide')) {
      if (customElement) {
        customElement.classList.add('hide');
      }
    }
  });
});

function collectionaddtocart(event, element) {
      event.preventDefault();
    var form = element.closest('form'); 
    var productId = form.querySelector('input[name="id"]').value; 
    var root = document.documentElement;
    var drawer = document.getElementById("CartDrawer");

    let formData = {
        "items": [{ "id": productId, "quantity": 1 }]
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(cart => {
        document.dispatchEvent(new CustomEvent('cart:build'));
    })
    .catch(error => {
        console.error("Error adding:", error);
    }).finally(() => {
      document.dispatchEvent(new CustomEvent('cart:open')); 
    });
}
class QuickProductForm extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.QucikSelectFunction);
    }
    QucikSelectFunction() {
      let Vid = event.target.selectedOptions[0].value;
      let Purl = event.target.dataset.url;
      console.log(`https://beautifulearthboutique.com/${Purl}?variant=${Vid}&sections=quick-section`);
      fetch(`https://beautifulearthboutique.com/${Purl}?variant=${Vid}&sections=quick-section`)
      .then(response => response.json())
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText['quick-section'], 'text/html');
        this.parentElement.innerHTML = html.querySelector('.product-grid-item-quick-product-info').innerHTML;
      })
      .catch((e) => {
        console.error(e);
      });
    }
  }
  customElements.define("quick-product-form",QuickProductForm);
          
  function add_to_cart_grid(variantid,qty){
    var id = variantid;
    var q = qty;
    var ajax = {
        type: "POST",
        url: "/cart/add.js",
        data: "quantity=" + q + "&id=" + id,
        dataType: "json",
        success: function (n) {
          var cart = new theme.CartDrawer
          cart.init()
          cart.open();
        },
        error: function (n, c) {
           console.log('fail');
        }
     };
    jQuery.ajax(ajax)
  }
  function add_to_cart_grid_pop(val,qty){
    var id = val.closest('form').querySelector('[name="id"]').value;
    var q = qty;
    var ajax = {
        type: "POST",
        url: "/cart/add.js",
        data: "quantity=" + q + "&id=" + id,
        dataType: "json",
        success: function (n) {
          var cart = new theme.CartDrawer
          cart.init()
          cart.open();
        },
        error: function (n, c) {
           console.log('fail');
        }
     };
    jQuery.ajax(ajax)
    val.closest('.product-grid-item-quick-atc-pop').classList.remove('popup-open');
  }
document.querySelectorAll(".close-btn-quick-add").forEach(function(element) {
  element.addEventListener("click", function() {
    document.querySelectorAll(".product-grid-item-quick-atc-pop").forEach(function(element) {
      element.classList.remove("popup-open");
    });
  });
});


class SizeGuideElement extends HTMLElement {
  connectedCallback() {
    const openBtn = this.querySelector('.size_guide_drawer');

    // Targets passed as attributes
    const drawerSelector = this.getAttribute('drawer-target');
    const closeSelector = this.getAttribute('close-target');

    const drawer = document.querySelector(`.${drawerSelector}`);
    const closeBtn = document.querySelector(`.${closeSelector}`);

    if (openBtn && drawer) {
      openBtn.addEventListener('click', () => {
        drawer.classList.add('open-gift');
        document.body.classList.add('open_size_body_size');
      });
    }

    if (closeBtn && drawer) {
      closeBtn.addEventListener('click', () => {
        drawer.classList.remove('open-gift');
        document.body.classList.remove('open_size_body_size');
      });
    }
  }
}

customElements.define('size-guide-element', SizeGuideElement);



class GiftOrder extends HTMLElement {
  connectedCallback() {
    const toggleBtn = this.querySelector('.gift_toggle_btn');

    const drawerSelector = this.getAttribute('drawer-target');
    const closeSelector = this.getAttribute('close-target');

    const drawer = document.querySelector(`.${drawerSelector}`);
    const closeBtn = document.querySelector(`.${closeSelector}`);
    const body = document.body;

    if (toggleBtn && drawer && body) {
      toggleBtn.addEventListener('click', () => {
        drawer.classList.add('open-gift');
        toggleBtn.classList.add('start-toggle');
        body.classList.add('open_gift_body');
      });
    }

    if (closeBtn && drawer && toggleBtn && body) {
      closeBtn.addEventListener('click', () => {
        drawer.classList.remove('open-gift');
        toggleBtn.classList.remove('start-toggle');
        body.classList.remove('open_gift_body');
      });
    }
  }
}

customElements.define('gift-order', GiftOrder);



customElements.define('product-card-secondary', class extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const productFormId = this.dataset.productFormId;
    const sliderEl = this.querySelector('[product-grid-secondary-slider]');
    const prevArrow = this.querySelector('.product-grid-secondary-slider-prev');
    const nextArrow = this.querySelector('.product-grid-secondary-slider-next');
    const sliderEl_mobile = this.querySelector('[product-grid-secondary-slider-mobile]');
    const prevArrow_mobile = this.querySelector('.product-grid-secondary-slider-mobile-prev');
    const nextArrow_mobile = this.querySelector('.product-grid-secondary-slider-mobile-next');

    setTimeout(() => {
      if (sliderEl && !$(sliderEl).hasClass('slick-initialized')) {
        $(sliderEl).slick({
          slidesToScroll: 1,
          slidesToShow: 1,
          arrows: true,
          prevArrow: $(prevArrow),
          nextArrow: $(nextArrow),
          dots: true,
          autoplay: false,
        });
      }
    }, 500);
    
    setTimeout(() => {
      if (sliderEl_mobile && !$(sliderEl_mobile).hasClass('slick-initialized')) {
        $(sliderEl_mobile).slick({
          slidesToScroll: 1,
          slidesToShow: 1,
          arrows: true,
          prevArrow: $(prevArrow_mobile),
          nextArrow: $(nextArrow_mobile),
          dots: true,
          autoplay: false,
        });
      }
    }, 500);

    // Refresh on hover
    this.addEventListener('mouseenter', () => {
      if (window.innerWidth > 768 && $(sliderEl).hasClass('slick-initialized')) {
        $(sliderEl).slick('setPosition');
        
      }
      if (window.innerWidth > 768 && $(sliderEl_mobile).hasClass('slick-initialized')) {
        $(sliderEl_mobile).slick('setPosition');
      }
    });
  }
});
function waitForElement(selector, callback, interval = 100, maxDuration = 120000) {
  const startTime = Date.now();

  function check() {
    const elapsed = Date.now() - startTime;
    const element = document.querySelector(selector);

    if (element) {
      callback(element);
    } else if (elapsed < maxDuration) {
      setTimeout(check, interval);
    } else {
      console.warn(`Element ${selector} not found within ${maxDuration / 1000} seconds.`);
    }
  }

  check();
}

// Usage:
if (window.location.href.includes("de-de")) {
  waitForElement(".cbb-also-bought-title", function(el) {
    el.innerHTML = 'Kunden Kauften Auch';
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const variantWrapper = document.querySelector('#variant_option_wrapper');
  if (variantWrapper) {
    const height = variantWrapper.offsetHeight;
    console.log(height, "height");
    document.documentElement.style.setProperty('--variant-option-element-height', `${height}px`);
  }
});


 /*document.addEventListener("DOMContentLoaded", function () {
    var expiryDate = new Date();
    expiryDate.setTime(expiryDate.getTime() + (1*24*60*60*1000)); 

    document.cookie = "BEB_PROMOTION=YESPLEASE; path=/; expires=" + expiryDate.toUTCString();
  });*/

  let allSearchOpen = document.querySelectorAll('[search-open]');
if(allSearchOpen.length > 0){
    allSearchOpen.forEach(btn => {
        btn.addEventListener("click", function(){
            const searchDrawer = document.getElementById("searchDrawer");
            const PredictiveWrapper = document.getElementById("PredictiveWrapper");
            if(!searchDrawer.hasAttribute('open')) {
                searchDrawer.setAttribute('open','');
            }
            if(PredictiveWrapper.classList.contains('hide')) {
                PredictiveWrapper.classList.remove('hide');
            }

            const input = searchDrawer.querySelector('input[type="search"]');
            if (input) {
              input.focus();
              // Move cursor to end
              const val = input.value;
              input.value = '';
              input.value = val;

              // Or you can use this:
              // input.setSelectionRange(input.value.length, input.value.length);
            }
        })
    });
}

let allSearchClose = document.querySelectorAll('[search-close]');
if(allSearchClose.length > 0){
    allSearchClose.forEach(btn => {
        btn.addEventListener("click", function(){
            const searchDrawer = document.getElementById("searchDrawer");
            const PredictiveWrapper = document.getElementById("PredictiveWrapper");
            if(searchDrawer.hasAttribute('open')) {
                searchDrawer.removeAttribute('open');
            }
            // if(!PredictiveWrapper.classList.contains('hide')) {
            //     PredictiveWrapper.classList.add('hide');
            // }
        })
    });
}

let SearchClose = document.getElementById('searchDrawerOverlay');
if(SearchClose) {
  SearchClose.addEventListener("click", function(){
      const searchDrawer = document.getElementById("searchDrawer");
      if(searchDrawer.hasAttribute('open')) {
          searchDrawer.removeAttribute('open');
      }
  })
}


// Progress Bar Update New Script Start
// (function () {

//   function triggerCartUpdate() {
//     fetch('/cart.js')
//       .then(res => res.json())
//       .then(cart => {

//         window.dispatchEvent(new CustomEvent('CartUpdate', {
//           detail: cart.total_price
//         }));

//       });
//   }

//   // quantity plus minus
//   document.addEventListener("click", function(e){

//     if (
//       e.target.closest('.js-qty__adjust') ||
//       e.target.closest('.cart__remove') ||
//       e.target.closest('[name="add"]') ||
//       e.target.closest('.add-to-cart')
//     ) {
//       setTimeout(triggerCartUpdate, 250);
//     }

//   });

//   // qty input change
//   document.addEventListener("change", function(e){
//     if(e.target.closest('.js-qty__num')){
//       setTimeout(triggerCartUpdate, 250);
//     }
//   });

//   // drawer open
//   document.addEventListener("click", function(e){
//     if(e.target.closest('.js-drawer-open-cart')){
//       setTimeout(triggerCartUpdate, 300);
//     }
//   });

//   // first load
//   document.addEventListener("DOMContentLoaded", function(){
//     setTimeout(triggerCartUpdate, 400);
//   });

// })();
// Progress Bar update New script End 